(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["announcement-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    // The width from which, with "compact" off, every message shows at once (the stylesheet's breakpoint).
    var wide = window.matchMedia('(min-width: 769px)');

    // Focus the keyboard gave (a click on an arrow focuses it too, in some browsers, and shouldn't stop the bar).
    function keyboardFocus(element) {
      try {
        return element.matches(':focus-visible');
      } catch (error) {
        return true;
      }
    }

    class AnnouncementRotator extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.announcement__slide'));
        this.start();
      }

      // Rotation needs two messages. A bar with one starts when lead() gives it another.
      start() {
        if (this.running || this.slides.length < 2) return;
        this.running = true;

        this.interval = Number(this.dataset.interval) || 6000;
        this.index = Math.max(0, this.slides.findIndex(function (slide) {
          return slide.classList.contains('announcement__slide--active');
        }));
        this.holds = new Set();
        this.schedule = this.schedule.bind(this);
        this.onVisibility = this.onVisibility.bind(this);

        if (!this.wired) this.wire();
        document.addEventListener('visibilitychange', this.onVisibility);
        wide.addEventListener('change', this.schedule);
        this.schedule();
      }

      disconnectedCallback() {
        this.running = false;
        clearTimeout(this.timer);
        document.removeEventListener('visibilitychange', this.onVisibility);
        wide.removeEventListener('change', this.schedule);
      }

      // Listeners on the element itself, once: a reconnected element keeps them.
      wire() {
        this.wired = true;

        // A mouse resting on the bar holds the message it is about to click. Touch has no hover to rest in.
        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse') this.hold('pointer');
        });
        this.addEventListener('pointerleave', () => this.release('pointer'));

        // The keyboard holds the bar, and a link it reaches becomes the message shown.
        this.addEventListener('focusin', (event) => {
          if (!keyboardFocus(event.target)) return;
          this.hold('focus');
          var slide = event.target.closest('.announcement__slide');
          if (slide) this.show(this.slides.indexOf(slide));
        });
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.release('focus');
        });

        this.querySelectorAll('.announcement__arrow').forEach((arrow) => {
          arrow.addEventListener('click', () => {
            this.step(arrow.classList.contains('announcement__arrow--prev') ? -1 : 1);
          });
        });

        // A swipe across the bar on a touch screen steps too (its touch-action leaves sideways moves to this script).
        this.addEventListener('pointerdown', (event) => {
          this.swipe = event.pointerType === 'touch' ? { x: event.clientX, y: event.clientY } : null;
        });
        this.addEventListener('pointercancel', () => {
          this.swipe = null;
        });
        this.addEventListener('pointerup', (event) => {
          if (!this.swipe) return;
          var dx = event.clientX - this.swipe.x;
          var dy = event.clientY - this.swipe.y;
          this.swipe = null;
          if (Math.abs(dx) < 30 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
          this.swipedAt = Date.now();
          this.step(dx < 0 ? 1 : -1);
        });

        // A swipe that ends on a link or an arrow doesn't also follow the link or step again.
        this.addEventListener('click', (event) => {
          if (!this.swipedAt || Date.now() - this.swipedAt > 500) return;
          event.preventDefault();
          event.stopPropagation();
        }, true);

        var pause = this.querySelector('.announcement__pause');
        if (pause) {
          pause.addEventListener('click', () => {
            var paused = pause.getAttribute('aria-pressed') !== 'true';
            pause.setAttribute('aria-pressed', String(paused));
            if (paused) {
              this.hold('button');
            } else {
              this.release('button');
            }
          });
        }

        // The theme editor: selecting a message's block shows it and holds it until the block is deselected.
        this.addEventListener('shopify:block:select', (event) => {
          var slide = event.target.closest('.announcement__slide');
          if (slide) this.show(this.slides.indexOf(slide));
          this.hold('editor');
        });
        this.addEventListener('shopify:block:deselect', () => this.release('editor'));
      }

      showsAll() {
        return this.dataset.compact === 'false' && wide.matches;
      }

      show(index) {
        if (index < 0) return;
        this.index = index;
        this.slides.forEach(function (slide, i) {
          slide.classList.toggle('announcement__slide--active', i === index);
        });
      }

      /*
        Messages that go ahead of the section's own, in order: Global-E's free-shipping offer, from
        snippets/globale-shipping-banner.liquid. A later call replaces them; an empty list takes them away.
        The first shows at once, the bar's timed change starting over from it, unless something holds the bar (a
        pointer resting on it, the keyboard in it, the pause button). `opening`: the page knew the messages before it
        drew, so the bar opens on the first with no fade.
      */
      lead(texts, opening) {
        var track = this.querySelector('.announcement__track');
        if (!track) return;

        track.querySelectorAll('.announcement__slide--lead').forEach(function (slide) {
          slide.remove();
        });
        var first = track.firstElementChild;
        texts.forEach(function (text, i) {
          var slide = document.createElement('div');
          var words = document.createElement('span');
          slide.className = 'announcement__slide announcement__slide--lead';
          slide.id = track.id + '-lead-' + i;
          words.className = 'announcement__text';
          words.textContent = text;
          slide.appendChild(words);
          track.insertBefore(slide, first);
        });
        this.slides = Array.from(track.querySelectorAll('.announcement__slide'));

        var active = this.slides.findIndex(function (slide) {
          return slide.classList.contains('announcement__slide--active');
        });
        if (opening) this.setAttribute('data-instant', '');
        this.start();
        if (texts.length && (opening || !this.holds || !this.holds.size)) {
          this.removeAttribute('data-stepped');
          this.show(0);
        } else {
          this.show(Math.max(0, active));
        }
        if (this.running) this.schedule();
        if (opening) {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => this.removeAttribute('data-instant'));
          });
        }
      }

      // A step a person takes: the quicker change, and the timed one starts over.
      step(delta) {
        this.setAttribute('data-stepped', '');
        this.show((this.index + delta + this.slides.length) % this.slides.length);
        this.schedule();
      }

      // The next message after a full interval, unless something holds the bar or every message already shows.
      schedule() {
        clearTimeout(this.timer);
        if (this.holds.size || this.showsAll()) return;
        this.timer = setTimeout(() => {
          this.removeAttribute('data-stepped');
          this.show((this.index + 1) % this.slides.length);
          this.schedule();
        }, this.interval);
      }

      hold(reason) {
        this.holds.add(reason);
        this.schedule();
      }

      release(reason) {
        this.holds.delete(reason);
        this.schedule();
      }

      onVisibility() {
        if (document.hidden) {
          this.hold('hidden');
        } else {
          this.release('hidden');
        }
      }
    }

    customElements.define('announcement-rotator', AnnouncementRotator);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    /*
    The drawer's own controls. The lines arrive by fetch (templates/cart.ajax.liquid), and a
    snippet's script never runs for fetched markup, so their Remove is handled here, delegated
    from the drawer, which every page renders.
  */
  (() => {
    const init = () => {
      const drawer = document.getElementById('CartDrawer');
      if (!drawer || drawer.dataset.controls) return;
      drawer.dataset.controls = 'true';

      const products = drawer.querySelector('[data-products]');
      const count = drawer.querySelector('[data-cart-count]');

      // The header's "2 items", from the count the fetched lines carry.
      const syncCount = () => {
        const items = products?.querySelector('[data-count-label]');
        if (!items || !count) return;

        count.textContent = items.dataset.countLabel;
        count.hidden = !(Number(items.dataset.count) > 0);
      };

      if (products) new MutationObserver(syncCount).observe(products, { childList: true });
      syncCount();

      drawer.addEventListener('click', (event) => {
        /*
          Remove sets the line's quantity to 0 through its own box, so theme.js changes the
          cart, rebuilds the lines and announces it, as for the minus button. Without the box
          (or without this script) the link still works: it goes to the cart page.
        */
        const remove = event.target.closest('[data-cart-remove]');
        if (remove) {
          const line = remove.closest('[data-key]');
          const input = line?.querySelector('input[data-id]');
          if (!input) return;

          event.preventDefault();
          line.classList.add('is-removing');
          input.value = '0';
          input.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }

        if (event.target.closest('[data-cart-dismiss]')) {
          event.preventDefault();
          document.dispatchEvent(new CustomEvent('cart:close'));
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-error-modal"] && !Shopify.designMode) return;
  try {
    class CartErrorModal extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-dialog]');
      this.messageEl = this.querySelector('[data-message]');
      this.abortController = new AbortController();

      const { signal } = this.abortController;

      document.addEventListener('cart:error', this.onError.bind(this), { signal });
      document.addEventListener('ajaxProduct:error', this.onProductError.bind(this), { signal });

      // Capturing on window runs ahead of the cart drawer's listener on document.
      window.addEventListener('ajaxProduct:added', this.onProductAdded.bind(this), { capture: true, signal });

      this.dialog.addEventListener('click', (event) => {
        // A click on the backdrop targets the dialog itself.
        if (event.target === this.dialog || event.target.closest('[data-close]')) {
          this.dialog.close();
        }
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    onError(event) {
      /*
        `description` carries the reason ("You can only add 2 of ..."); `message`
        is the generic "Cart Error" that the old theme showed by preferring it.
      */
      const detail = event.detail || {};
      this.show(detail.description || detail.message);
    }

    /*
      A product form's add that Shopify refused (a 422, nearly always stock).
      `theme.js` has just written the reason under the button, as `.errors`. The
      live site shows it in this pop-up instead, so the pop-up takes the text and
      the copy under the button is hidden.
    */
    onProductError(event) {
      const inline = event.target.querySelector(':scope > .errors');
      this.show(inline?.textContent);
      if (inline) inline.hidden = true;

      /*
        `theme.js` follows the refusal with a bare `ajaxProduct:added`, in the same
        callback, and the cart drawer slides open on it. The flag marks that one
        event; the microtask clears it once the callback is done, either way.
      */
      this.addRefused = true;
      queueMicrotask(() => {
        this.addRefused = false;
      });
    }

    /*
      Live leaves the drawer shut after a refused add. Part of the quantity can
      still have gone in ("Only 8 items were added to your cart"), so the drawer
      and the cart count are rebuilt, just not opened.
    */
    onProductAdded(event) {
      if (!this.addRefused) return;

      this.addRefused = false;
      event.stopPropagation();
      document.dispatchEvent(new CustomEvent('cart:build'));
    }

    show(message) {
      this.messageEl.textContent = message || this.dialog.dataset.fallback;
      if (!this.dialog.open) this.dialog.showModal();
    }
  }

  customElements.define('cart-error-modal', CartErrorModal);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-recommendations"] && !Shopify.designMode) return;
  try {
    class CartRecommendations extends HTMLElement {
    connectedCallback() {
      this.listEl = this.querySelector('[data-list]');
      this.arrowsEl = this.querySelector('[data-carousel-arrows]');
      this.products = [];
      this.wasOpen = false;
      this.abortController = new AbortController();

      const { signal } = this.abortController;
      this.addEventListener('change', this.onVariantChange.bind(this), { signal });
      this.addEventListener('click', this.onAdd.bind(this), { signal });
      this.addEventListener('click', this.onArrow.bind(this), { signal });
      this.listEl.addEventListener('scroll', () => this.syncArrows(), { signal, passive: true });
      window.addEventListener('resize', () => this.syncArrows(), { signal, passive: true });

      this.watchDrawer();
    }

    disconnectedCallback() {
      this.abortController.abort();
      this.drawerObserver?.disconnect();
    }

    get root() {
      return window.Shopify?.routes?.root || '/';
    }

    static escape(value) {
      const el = document.createElement('div');
      el.textContent = value ?? '';
      return el.innerHTML;
    }

    formatMoney(cents) {
      if (window.theme?.Currency?.formatMoney) {
        return theme.Currency.formatMoney(cents, theme.settings?.moneyFormat);
      }

      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: window.Shopify?.currency?.active || 'GBP'
        }).format(cents / 100);
      } catch {
        return `${(cents / 100).toFixed(2)}`;
      }
    }

    // Shopify's CDN sizes from a query param, and product URLs may already carry one.
    static resize(url, width) {
      if (!url) return '';
      return `${url}${url.includes('?') ? '&' : '?'}width=${width}`;
    }

    static srcset(url) {
      return [180, 270, 360, 540].map((w) => `${CartRecommendations.resize(url, w)} ${w}w`).join(', ');
    }

    watchDrawer() {
      const drawer = document.getElementById('CartDrawer');
      if (!drawer) return;

      this.drawerObserver = new MutationObserver(() => {
        const open = drawer.classList.contains('drawer--is-open');

        if (open && !this.wasOpen) {
          this.wasOpen = true;
          this.load();
        } else if (!open) {
          this.wasOpen = false;
        }
      });

      this.drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    async load() {
      try {
        const cartRes = await fetch(`${this.root}cart.js`, { credentials: 'same-origin' });
        if (!cartRes.ok) throw new Error(`Cart HTTP ${cartRes.status}`);

        const cart = await cartRes.json();
        const productId = cart.items?.[0]?.product_id;
        if (!productId) {
          this.hidden = true;
          return;
        }

        // Ask for enough to fill the row once what is already in the cart is left out.
        const limit = Number(this.dataset.limit) || 4;
        const inCart = new Set(cart.items.map((item) => item.product_id));
        const ask = Math.min(limit + inCart.size, 10);
        const url = `${this.root}recommendations/products.json?product_id=${productId}&intent=related&limit=${ask}`;

        const recRes = await fetch(url, { credentials: 'same-origin' });
        if (!recRes.ok) throw new Error(`Recommendations HTTP ${recRes.status}`);

        this.products = ((await recRes.json()).products || [])
          .filter((product) => !inCart.has(product.id))
          .slice(0, limit);
        this.render();
      } catch (error) {
        console.warn('[cart-recommendations]', error);
        this.hidden = true;
      }
    }

    render() {
      if (!this.products.length) {
        this.hidden = true;
        return;
      }

      this.listEl.innerHTML = this.products.map((product) => this.cardHtml(product)).join('');
      this.listEl.scrollLeft = 0;
      this.hidden = false;
      requestAnimationFrame(() => this.syncArrows());
    }

    priceHtml(variant) {
      const price = this.formatMoney(variant.price);
      if (!(variant.compare_at_price > variant.price)) return price;

      return `
        <span class="visually-hidden">${CartRecommendations.escape(this.dataset.strRegularPrice)}</span>
        <s class="cart-recommendations__was">${this.formatMoney(variant.compare_at_price)}</s>
        <span class="visually-hidden">${CartRecommendations.escape(this.dataset.strSalePrice)}</span>
        <span class="cart-recommendations__sale">${price}</span>
      `;
    }

    cardHtml(product) {
      const variant = product.variants.find((v) => v.available) || product.variants[0];
      if (!variant) return '';

      const image = variant.featured_image?.src || product.featured_image;
      const title = CartRecommendations.escape(product.title);
      const url = CartRecommendations.escape(product.url);

      let picker = '';
      if (product.variants.length > 1) {
        const options = product.variants
          .map((v) => {
            const label = v.available
              ? CartRecommendations.escape(v.title)
              : `${CartRecommendations.escape(v.title)} — ${CartRecommendations.escape(this.dataset.strSoldOut)}`;

            return `<option value="${v.id}"${v.available ? '' : ' disabled'}${v.id === variant.id ? ' selected' : ''}>${label}</option>`;
          })
          .join('');

        // snippets/option-picker.liquid's markup; its stylesheet is on every page.
        picker = `
          <div class="option-picker">
            <span class="option-picker__choice" data-choice aria-hidden="true">${CartRecommendations.escape(variant.title)}</span>
            <select class="option-picker__select cart-recommendations__select" data-product-id="${product.id}" aria-label="${title}">
              ${options}
            </select>
          </div>
        `;
      }

      const label = variant.available ? this.dataset.strAdd : this.dataset.strSoldOut;

      return `
        <li class="cart-recommendations__item">
          <a href="${url}" class="cart-recommendations__image-link" tabindex="-1" aria-hidden="true">
            <img
              class="cart-recommendations__image"
              src="${CartRecommendations.resize(image, 360)}"
              srcset="${CartRecommendations.srcset(image)}"
              sizes="176px"
              width="360"
              height="554"
              alt=""
              loading="lazy">
          </a>
          <a href="${url}" class="cart-recommendations__name">${title}</a>
          <div class="cart-recommendations__price" data-price>${this.priceHtml(variant)}</div>
          <div class="cart-recommendations__actions">
            ${picker}
            <button type="button" class="cart-recommendations__add" data-variant-id="${variant.id}"${variant.available ? '' : ' disabled'}>
              ${CartRecommendations.escape(label)}
            </button>
          </div>
        </li>
      `;
    }

    // The arrows show when the row runs past the drawer, each greyed at its end.
    syncArrows() {
      if (!this.arrowsEl || this.hidden) return;

      const list = this.listEl;
      const overflow = list.scrollWidth - list.clientWidth > 1;
      this.arrowsEl.hidden = !overflow;
      if (!overflow) return;

      const [prev, next] = this.arrowsEl.querySelectorAll('[data-step]');
      prev.disabled = list.scrollLeft <= 1;
      next.disabled = list.scrollLeft >= list.scrollWidth - list.clientWidth - 1;
    }

    onArrow(event) {
      const arrow = event.target.closest('[data-step]');
      if (!arrow) return;

      const card = this.listEl.querySelector('.cart-recommendations__item');
      const gap = parseFloat(getComputedStyle(this.listEl).columnGap) || 0;
      const step = (card ? card.getBoundingClientRect().width + gap : this.listEl.clientWidth) * Number(arrow.dataset.step);
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.listEl.scrollBy({ left: step, behavior: reduced ? 'auto' : 'smooth' });
    }

    onVariantChange(event) {
      const select = event.target.closest('.cart-recommendations__select');
      if (!select) return;

      const product = this.products.find((p) => String(p.id) === select.dataset.productId);
      const variant = product?.variants.find((v) => String(v.id) === select.value);
      const item = select.closest('.cart-recommendations__item');
      if (!variant || !item) return;

      item.querySelector('[data-price]').innerHTML = this.priceHtml(variant);

      const choice = item.querySelector('[data-choice]');
      if (choice) choice.textContent = variant.title;

      const button = item.querySelector('.cart-recommendations__add');
      button.dataset.variantId = variant.id;
      button.disabled = !variant.available;
      button.textContent = variant.available ? this.dataset.strAdd : this.dataset.strSoldOut;

      const img = item.querySelector('.cart-recommendations__image');
      if (variant.featured_image?.src && img) {
        img.src = CartRecommendations.resize(variant.featured_image.src, 360);
        img.srcset = CartRecommendations.srcset(variant.featured_image.src);
      }
    }

    async onAdd(event) {
      const button = event.target.closest('.cart-recommendations__add');
      if (!button || button.disabled) return;

      button.disabled = true;
      button.textContent = this.dataset.strAdding;

      try {
        const response = await fetch(window.theme?.routes?.cartAdd || `${this.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: button.dataset.variantId, quantity: 1 })
        });

        const data = await response.json();

        // The old theme announced "Added!" whether or not Shopify accepted it.
        if (!response.ok) {
          document.dispatchEvent(new CustomEvent('cart:error', {
            detail: { message: data?.description || data?.message }
          }));
          button.textContent = this.dataset.strError;
          return;
        }

        document.dispatchEvent(new CustomEvent('cart:build'));
        // The shipping band draws the thread on to the new total (cart:build tells it nothing).
        document.querySelector('#CartDrawer cart-shipping-progress')?.render?.();
        this.scrollDrawerToTop();

        button.textContent = this.dataset.strAdded;
        setTimeout(() => { button.textContent = this.dataset.strAdd; }, 1500);
      } catch (error) {
        console.warn('[cart-recommendations]', error);
        button.textContent = this.dataset.strError;
      } finally {
        button.disabled = false;
      }
    }

    // Lets the rebuilt line item land before moving to it.
    scrollDrawerToTop() {
      setTimeout(() => {
        const scroller = document.querySelector('#CartDrawer .drawer__scrollable');
        if (!scroller) return;

        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        scroller.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
      }, 350);
    }
  }

  customElements.define('cart-recommendations', CartRecommendations);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-shipping-progress"] && !Shopify.designMode) return;
  try {
    class CartShippingProgress extends HTMLElement {
    // Six hours, matching the old theme's cache window.
    // v2: bumped with the August 2026 API-key rotation, so a browser holding
    // rates fetched under the retired key discards them instead of serving
    // them until the TTL runs out.
    static FX_CACHE_KEY = 'fx_rates_cache_v2';
    static FX_CACHE_TTL_MS = 1000 * 60 * 60 * 6;

    // After a failed call (quota used up, bad key, API down) this browser waits
    // an hour before asking again, instead of asking on every drawer open.
    static FX_FAILED_KEY = 'fx_rates_failed';
    static FX_RETRY_MS = 1000 * 60 * 60;
    // The same, for a browser that can't store it (private mode).
    static fxFailedAt = 0;

    // Shared across instances so a second element can't fire a duplicate request.
    static fxRequest = null;

    connectedCallback() {
      this.messageEl = this.querySelector('[data-message]');
      this.barsEl = this.querySelector('[data-bars]');
      this.abortController = new AbortController();

      this.baseCurrency = this.dataset.baseCurrency;
      this.thresholds = this.readThresholds();
      this.wasOpen = false;

      const { signal } = this.abortController;
      document.addEventListener('cart:open', () => this.render(), { signal });
      document.addEventListener('cart:updated', () => {
        if (this.isDrawerOpen()) this.render();
        // The cart page's thread follows its quantities with the drawer shut, from what needs no
        // exchange-rate call: a listed threshold, or rates this browser already holds.
        else if (this.classList.contains('cart-shipping-progress--page')) this.render({ network: false });
      }, { signal });

      this.watchDrawer();
      this.watchScroll();

      /*
        The shop currency is already rendered server-side. Any other currency is
        rendered now only if that costs no exchange-rate call (a listed threshold,
        or rates this browser already holds); otherwise it waits for the drawer to
        open, as live does. Calling on page load spent a credit on every visitor's
        first page, cart or no cart, and used up the month's credits within hours
        when this theme was briefly published.
      */
      if (this.activeCurrency() !== this.baseCurrency) this.render({ network: this.isDrawerOpen() });
    }

    disconnectedCallback() {
      this.abortController.abort();
      this.drawerObserver?.disconnect();
    }

    readThresholds() {
      let map = {};

      try {
        map = JSON.parse(this.dataset.thresholds || '{}') || {};
      } catch {
        // A malformed setting must not take the band down for everyone else.
        console.warn('[cart-shipping-progress] Ignoring malformed threshold JSON');
        map = {};
      }

      // The dedicated number settings are authoritative for the shop currency.
      map[this.baseCurrency] = {
        shipping: Number(this.dataset.baseShipping) || 0,
        returns: Number(this.dataset.baseReturns) || 0
      };

      return map;
    }

    activeCurrency() {
      return window.Shopify?.currency?.active || this.baseCurrency;
    }

    isDrawerOpen() {
      const drawer = document.getElementById('CartDrawer');
      return !!drawer?.classList.contains('drawer--is-open');
    }

    // Always en-GB, so every dollar is named: US$, CA$, A$. Live uses the browser's locale, which gives a US
    // browser plain $ for US dollars and a Canadian one plain $ for Canadian dollars. A whole amount drops its
    // pence (£50, not £50.00), as Liquid's money_without_trailing_zeros does for the shop currency.
    formatMoney(amount, currency) {
      const rounded = Math.round(amount * 100) / 100;
      const digits = Number.isInteger(rounded) ? 0 : 2;

      try {
        return new Intl.NumberFormat('en-GB', {
          style: 'currency',
          currency,
          currencyDisplay: 'symbol',
          minimumFractionDigits: digits,
          maximumFractionDigits: digits
        }).format(rounded);
      } catch {
        return `${currency} ${rounded.toFixed(digits)}`;
      }
    }

    // Keeps a converted threshold looking like a price rather than a conversion.
    static roundUp(value) {
      if (value <= 100) return Math.ceil(value / 5) * 5;
      if (value <= 1000) return Math.ceil(value / 10) * 10;
      return Math.ceil(value / 50) * 50;
    }

    cachedRates() {
      try {
        const raw = localStorage.getItem(CartShippingProgress.FX_CACHE_KEY);
        if (!raw) return null;

        const parsed = JSON.parse(raw);
        if (!parsed?.rates || !parsed?.timestamp) return null;
        if (Date.now() - parsed.timestamp > CartShippingProgress.FX_CACHE_TTL_MS) return null;

        return parsed.rates;
      } catch {
        return null;
      }
    }

    recentlyFailed() {
      let failedAt = CartShippingProgress.fxFailedAt;

      try {
        failedAt = Math.max(failedAt, Number(localStorage.getItem(CartShippingProgress.FX_FAILED_KEY)) || 0);
      } catch {
        // Unreadable storage: the in-memory time alone.
      }

      return Date.now() - failedAt < CartShippingProgress.FX_RETRY_MS;
    }

    recordFailure() {
      CartShippingProgress.fxFailedAt = Date.now();

      try {
        localStorage.setItem(CartShippingProgress.FX_FAILED_KEY, String(CartShippingProgress.fxFailedAt));
      } catch {
        // Private mode / quota — the in-memory time still holds for this page.
      }
    }

    fetchRates() {
      const cached = this.cachedRates();
      if (cached) return Promise.resolve(cached);

      const key = this.dataset.fxKey;
      if (!key || this.recentlyFailed()) return Promise.resolve(null);

      if (CartShippingProgress.fxRequest) return CartShippingProgress.fxRequest;

      const url = `https://v6.exchangerate-api.com/v6/${key}/latest/${this.baseCurrency}`;

      CartShippingProgress.fxRequest = fetch(url)
        .then((response) => {
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          return response.json();
        })
        .then((data) => {
          if (data?.result !== 'success' || !data.conversion_rates) throw new Error('Invalid FX response');

          try {
            localStorage.setItem(CartShippingProgress.FX_CACHE_KEY, JSON.stringify({
              rates: data.conversion_rates,
              timestamp: Date.now()
            }));
            localStorage.removeItem(CartShippingProgress.FX_FAILED_KEY);
          } catch {
            // Private mode / quota — the rates still work for this page view.
          }

          return data.conversion_rates;
        })
        .catch((error) => {
          // A navigation cancelling the call is not the API failing.
          if (error?.name !== 'AbortError') this.recordFailure();
          return null;
        })
        .finally(() => {
          CartShippingProgress.fxRequest = null;
        });

      return CartShippingProgress.fxRequest;
    }

    // `network: false` resolves only what needs no exchange-rate call.
    async config(currency, network) {
      const known = this.thresholds[currency];
      if (known?.shipping) return known;

      const base = Number(this.dataset.fxBaseThreshold) || 0;
      if (!base) return null;

      let rates = this.cachedRates();
      if (!rates) {
        if (!network || this.recentlyFailed()) return null;

        this.showChecking(currency);
        rates = await this.fetchRates();
      }
      if (!rates?.[currency]) return null;

      return { shipping: CartShippingProgress.roundUp(base * rates[currency]), returns: 0 };
    }

    showChecking(currency) {
      this.hidden = false;
      this.messageEl.textContent = (this.dataset.strChecking || '').replace('[currency]', currency);
      this.paint([{ percent: 0, label: this.dataset.strLoading, amount: '' }]);
    }

    // One stretch of the thread: as rendered in the Liquid above.
    barHtml() {
      return `
        <div class="cart-shipping-progress__bar">
          <div class="cart-shipping-progress__thread">
            <div class="cart-shipping-progress__track">
              <div class="cart-shipping-progress__fill" style="width: 0%;"></div>
            </div>
            <span class="cart-shipping-progress__knot"></span>
          </div>
          <div class="cart-shipping-progress__label">
            <span data-label-name></span>
            <span class="cart-shipping-progress__threshold" data-label-amount></span>
          </div>
        </div>
      `;
    }

    /*
      Updates the stretches in place, so the thread draws on from where it stood (the
      fill's width transition) rather than starting again from nothing. When both
      stretches move the same way, the second waits for the first, so the thread runs
      through the free-shipping knot rather than filling both at once; on the way back
      down the first waits for the second.
    */
    paint(bars) {
      this.barsEl.classList.toggle('cart-shipping-progress__bars--single', bars.length === 1);

      if (this.barsEl.querySelectorAll('.cart-shipping-progress__bar').length !== bars.length) {
        this.barsEl.innerHTML = bars.map(() => this.barHtml()).join('');
      }

      const els = [...this.barsEl.querySelectorAll('.cart-shipping-progress__bar')];
      const fills = els.map((el) => el.querySelector('.cart-shipping-progress__fill'));
      const before = fills.map((fill) => parseFloat(fill.style.width) || 0);
      // In seconds; 0 when the visitor asks for less motion.
      const drawSetting = parseFloat(getComputedStyle(this).getPropertyValue('--_draw'));
      const draw = Number.isFinite(drawSetting) ? drawSetting : 0.7;

      els.forEach((el, i) => {
        el.querySelector('[data-label-name]').textContent = bars[i].label || '';
        el.querySelector('[data-label-amount]').textContent = bars[i].amount || '';
      });

      if (bars.length === 2) {
        const up = bars[0].percent > before[0] && bars[1].percent > before[1];
        const down = bars[0].percent < before[0] && bars[1].percent < before[1];
        fills[0].style.transitionDelay = down ? `${draw}s` : '';
        fills[1].style.transitionDelay = up ? `${draw}s` : '';
        els[1].style.setProperty('--_knot-wait', up ? `${draw}s` : '0s');
      }

      // Next frame, so a stretch just built starts from zero and draws out.
      requestAnimationFrame(() => {
        els.forEach((el, i) => {
          fills[i].style.width = `${bars[i].percent}%`;
          el.classList.toggle('is-earned', bars[i].percent >= 100);
        });
      });
    }

    async render({ network = true } = {}) {
      const currency = this.activeCurrency();
      const config = await this.config(currency, network);

      if (!config) {
        // No threshold and no rate — say nothing rather than guess.
        this.hidden = true;
        return;
      }

      let total;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { credentials: 'same-origin' });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        total = (await response.json()).items_subtotal_price / 100;
      } catch {
        this.hidden = true;
        return;
      }

      const hasReturns = config.returns > config.shipping;
      const shippingPercent = config.shipping > 0 ? Math.min((total / config.shipping) * 100, 100) : 0;

      let returnsPercent = 0;
      if (hasReturns && total > config.shipping) {
        returnsPercent = Math.min(((total - config.shipping) / (config.returns - config.shipping)) * 100, 100);
      }

      const message = this.messageHtml(total, currency, config, hasReturns);
      if (this.messageEl.innerHTML !== message) this.messageEl.innerHTML = message;

      const bars = [{ percent: shippingPercent, label: this.dataset.strLabelShipping, amount: this.formatMoney(config.shipping, currency) }];
      if (hasReturns) bars.push({ percent: returnsPercent, label: this.dataset.strLabelReturns, amount: this.formatMoney(config.returns, currency) });

      this.hidden = false;
      this.paint(bars);
    }

    messageHtml(total, currency, config, hasReturns) {
      if (hasReturns && total >= config.returns) return this.dataset.strEarnedAll;
      if (total >= config.shipping) {
        if (!hasReturns) return this.dataset.strEarnedShipping;

        return (this.dataset.strAwayReturns || '')
          .replace('[amount]', this.formatMoney(config.returns - total, currency));
      }

      return (this.dataset.strAwayShipping || '')
        .replace('[amount]', this.formatMoney(config.shipping - total, currency));
    }

    watchDrawer() {
      const drawer = document.getElementById('CartDrawer');
      if (!drawer) return;

      this.drawerObserver = new MutationObserver(() => {
        const open = this.isDrawerOpen();

        if (open && !this.wasOpen) {
          this.wasOpen = true;
          this.render();
        } else if (!open) {
          this.wasOpen = false;
        }
      });

      this.drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    /*
      Shrinking changes the band's height, which moves the scroll position that
      triggered it. The lock and the expand delay stop that feeding back into a
      shrink/expand oscillation, and the two thresholds (30 / 5) give it hysteresis.
    */
    watchScroll() {
      const scroller = this.closest('.drawer__scrollable');
      if (!scroller) return;

      let shrunk = false;
      let locked = false;
      let expandTimer = null;

      const lock = () => {
        locked = true;
        setTimeout(() => { locked = false; }, 120);
      };

      scroller.addEventListener('scroll', () => {
        if (locked) return;

        if (!shrunk && scroller.scrollTop > 30) {
          this.classList.add('cart-shipping-progress--shrink');
          shrunk = true;
          lock();
          clearTimeout(expandTimer);
          return;
        }

        if (shrunk && scroller.scrollTop < 5) {
          clearTimeout(expandTimer);
          expandTimer = setTimeout(() => {
            this.classList.remove('cart-shipping-progress--shrink');
            shrunk = false;
            lock();
          }, 80);
        }
      }, { signal: this.abortController.signal, passive: true });
    }
  }

  customElements.define('cart-shipping-progress', CartShippingProgress);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-description"] && !Shopify.designMode) return;
  try {
    (function () {
    class CollectionDescription extends HTMLElement {
      connectedCallback() {
        /*
          The first heading only, which is what the old theme bound — it toggles the
          whole description rather than its own section. Later headings are styled
          with the same glyph but are not triggers; that is the live behaviour, and
          descriptions in practice carry a single heading.
        */
        var trigger = this.querySelector('h2');
        if (!trigger) return;

        trigger.setAttribute('role', 'button');
        trigger.setAttribute('tabindex', '0');
        trigger.setAttribute('aria-expanded', 'false');

        var toggle = () => {
          var open = this.classList.toggle('is-open');
          trigger.classList.toggle('is-open', open);
          trigger.setAttribute('aria-expanded', String(open));
        };

        trigger.addEventListener('click', toggle);
        trigger.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggle();
          }
        });
      }
    }

    customElements.define('collection-description', CollectionDescription);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-grid-filters-form"] && !Shopify.designMode) return;
  try {
    (() => {
    // "Show all" on a long list. The choice outlives the reload after each tick, which replaces the list.
    const expanded = new Set();

    class FilterValueList extends HTMLElement {
      connectedCallback() {
        this.toggleButton = this.querySelector('.filter-values__toggle');
        if (!this.toggleButton) return;
        if (!this.toggleButton.hasAttribute('data-bound')) {
          this.toggleButton.setAttribute('data-bound', '');
          this.toggleButton.addEventListener('click', () => this.show(!this.hasAttribute('data-expanded')));
        }
        this.show(expanded.has(this.dataset.filterId));
      }

      show(open) {
        if (open) expanded.add(this.dataset.filterId);
        else expanded.delete(this.dataset.filterId);
        this.toggleAttribute('data-expanded', open);
        this.toggleButton.setAttribute('aria-expanded', String(open));
        this.toggleButton.textContent = open ? this.dataset.labelFewer : this.dataset.labelAll;
      }
    }

    if (!customElements.get('filter-value-list')) customElements.define('filter-value-list', FilterValueList);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-grid-filters"] && !Shopify.designMode) return;
  try {
    (() => {
    // "Show N products": the products have already updated behind the drawer, so it only has to close.
    document.addEventListener('click', event => {
      if (!event.target.closest('[data-filter-drawer-show]')) return;
      if (window.theme && theme.FilterDrawer) theme.FilterDrawer.close();
    });

    // A tick or a chip in the drawer: show that the count is being worked out until the reload replaces the footer.
    const markBusy = () => {
      const show = document.querySelector('#FilterDrawer [data-filter-drawer-show]');
      if (show) show.setAttribute('aria-busy', 'true');
    };
    document.addEventListener('input', event => {
      if (event.target.closest('#FilterDrawer .filter-form')) markBusy();
    }, true);
    document.addEventListener('click', event => {
      if (event.target.closest('#FilterDrawer .tag-list a')) markBusy();
    }, true);

    // After the reload, read the new count out to screen readers.
    document.addEventListener('collection:reloaded', () => {
      const drawer = document.getElementById('FilterDrawer');
      if (!drawer || !drawer.classList.contains('drawer--is-open')) return;
      const status = drawer.querySelector('[data-filter-drawer-status]');
      const show = drawer.querySelector('[data-filter-drawer-show]');
      if (status && show) status.textContent = show.textContent.trim();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-grid"] && !Shopify.designMode) return;
  try {
    (function () {
    /*
      The sort list a mouse opens. The native select stays the control: it lies unseen over the toolbar's words,
      phones open their own picker from it, screen readers read it, and theme.js sorts on its change event. Where
      the pointer is a mouse (or a pen), a press or a key that would open the native list opens this one instead,
      drawn in the toolbar's type; choosing an order sets the select and fires its change, as picking it there
      would. Arrow keys move through the list, Enter or Space chooses, Escape closes it back onto the select.

      Desktop Chrome and Edge draw it with any pointer too (Ayoob, 2026-10-12: testing in Chrome's device mode,
      "the sort dropdown only takes half the screen"). A desktop browser opens a select as its own small grey list
      the width of the box that was pressed, even while DevTools makes it pass for a phone: device mode fakes the
      screen, touch and the user agent, and the hover/pointer query with them, but not the browser's features.
      WebHID (`navigator.hid`) is only in desktop Chrome and Edge, never on Android or iOS, so phones and tablets
      keep their own full-size picker. Shared with the page picker in snippets/pagination.liquid.
    */
    var MOUSE = '(hover: hover) and (pointer: fine)';
    var DESKTOP_CHROME = 'hid' in navigator;

    class CollectionSort extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('select');
        this.panel = this.querySelector('[data-sort-panel]');
        if (!this.select || !this.panel) return;

        this.mouse = window.matchMedia(MOUSE);
        this.onOutside = this.onOutside.bind(this);

        this.select.addEventListener('mousedown', (event) => {
          if (!this.drawn() || event.button !== 0) return;
          event.preventDefault();
          this.select.focus({ focusVisible: false });
          if (this.panel.hidden) this.open(false);
          else this.close(false);
        });

        this.select.addEventListener('keydown', (event) => {
          if (!this.drawn()) return;
          if (event.key === 'Escape' && !this.panel.hidden) {
            this.escape(event);
          } else if (['Enter', ' ', 'ArrowDown', 'ArrowUp'].includes(event.key)) {
            event.preventDefault();
            this.open(true);
          }
        });

        this.panel.addEventListener('click', (event) => {
          var option = event.target.closest('[role="option"]');
          if (option) this.choose(option, false);
        });

        this.panel.addEventListener('keydown', (event) => this.onPanelKey(event));
      }

      disconnectedCallback() {
        document.removeEventListener('pointerdown', this.onOutside);
      }

      /* Whether this browser gets the drawn list rather than the select's own (see the note at the top). */
      drawn() {
        return this.mouse.matches || DESKTOP_CHROME;
      }

      options() {
        return Array.from(this.panel.querySelectorAll('[role="option"]'));
      }

      open(focusList) {
        this.panel.hidden = false;
        this.classList.add('is-open');
        document.addEventListener('pointerdown', this.onOutside);
        if (focusList) {
          var current = this.panel.querySelector('[aria-selected="true"]') || this.options()[0];
          if (current) current.focus();
        }
      }

      /* `byKey`: a key did this, not the mouse, so the focus handed back to the select shows its ring. */
      close(refocus, byKey) {
        if (this.panel.hidden) return;
        this.panel.hidden = true;
        this.classList.remove('is-open');
        document.removeEventListener('pointerdown', this.onOutside);
        if (refocus) this.select.focus({ focusVisible: Boolean(byKey) });
      }

      onOutside(event) {
        if (!this.contains(event.target)) this.close(false);
      }

      choose(option, byKey) {
        var value = option.dataset.value;
        this.close(true, byKey);
        if (this.select.value === value) return;
        this.select.value = value;
        this.select.dispatchEvent(new Event('change', { bubbles: true }));
      }

      /*
        Escape closes the list and stops there: theme.js closes the search on any Escape that reaches the
        document, and that blurs whatever has focus, which would drop it off the select we hand it back to.
      */
      escape(event) {
        event.preventDefault();
        event.stopPropagation();
        this.close(true, true);
      }

      onPanelKey(event) {
        var list = this.options();
        var index = list.indexOf(document.activeElement);
        switch (event.key) {
          case 'ArrowDown':
            event.preventDefault();
            list[Math.min(list.length - 1, index + 1)].focus();
            break;
          case 'ArrowUp':
            event.preventDefault();
            list[Math.max(0, index - 1)].focus();
            break;
          case 'Home':
            event.preventDefault();
            list[0].focus();
            break;
          case 'End':
            event.preventDefault();
            list[list.length - 1].focus();
            break;
          case 'Enter':
          case ' ':
            event.preventDefault();
            if (index > -1) this.choose(list[index], true);
            break;
          case 'Escape':
            this.escape(event);
            break;
          case 'Tab':
            this.close(false);
            break;
        }
      }
    }

    customElements.define('collection-sort', CollectionSort);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-pill-nav"] && !Shopify.designMode) return;
  try {
    (function () {
    class CollectionPillNav extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('[data-pill-nav-scroller]');
        if (!this.scroller) return;

        this.sync = this.sync.bind(this);

        // An arrow moves the row on by most of what is showing, keeping the last pill or two in sight.
        this.querySelector('[data-pill-nav-prev]').addEventListener('click', () => {
          this.scroller.scrollBy({ left: -this.scroller.clientWidth * 0.7 });
        });
        this.querySelector('[data-pill-nav-next]').addEventListener('click', () => {
          this.scroller.scrollBy({ left: this.scroller.clientWidth * 0.7 });
        });

        this.scroller.addEventListener('scroll', this.sync, { passive: true });

        // The row's fit changes with the screen's width, so its ends are re-read rather than computed once.
        if (window.ResizeObserver) {
          this.resizeObserver = new ResizeObserver(this.sync);
          this.resizeObserver.observe(this.scroller);
        }

        this.revealActive();
        this.sync();
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      /*
        Marks the ends the row has reached: data-at-start while there is nothing to the left, data-at-end
        while there is nothing to the right. A row that fits carries both, so it shows no fade and no arrow.
        A pixel's slack, as scroll positions land on fractions.
      */
      sync() {
        var left = this.scroller.scrollLeft;
        var room = this.scroller.scrollWidth - this.scroller.clientWidth;
        this.toggleAttribute('data-at-start', left <= 1);
        this.toggleAttribute('data-at-end', left >= room - 1);
      }

      /*
        Bring the current category into the middle of the row. `scrollIntoView` would also scroll the page
        vertically to reach it, so the offset is set directly, before the smooth scrolling can animate it.
      */
      revealActive() {
        var active = this.scroller.querySelector('.collection-pill-nav__link--active');
        if (!active) return;
        var target = active.offsetLeft - (this.scroller.clientWidth - active.offsetWidth) / 2;
        this.scroller.style.scrollBehavior = 'auto';
        this.scroller.scrollLeft = Math.max(0, target);
        this.scroller.style.scrollBehavior = '';
      }
    }

    customElements.define('collection-pill-nav', CollectionPillNav);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["country-switcher"] && !Shopify.designMode) return;
  try {
    const NARROW = 768;
  const GUTTER = 12;

  /* The country name in English, for the search.

     It cannot come from Liquid. On a Glopal host SHOPIFY ITSELF renders the page
     in the site language — Shopify.locale is "ar" on ae. — so country.name is
     already Arabic before the page leaves Shopify. The row order gives it away:
     the list arrives IS, AZ, AM, AW, AU, AF, which is Arabic alphabetical, not
     English.

     That is why three earlier attempts all failed the same way, and why none of
     them were really about Glopal: a data-find attribute, an EN_NAMES object,
     and a base64 of the same map all arrived in Arabic, because Liquid put
     Arabic in them.

     So ask the browser, which knows every ISO code in English and needs no
     payload, no map to maintain, and no new country added to Shopify to be
     remembered here.

     Wrapped and cached: Intl.DisplayNames is absent on older browsers, and
     losing English search is survivable — losing the panel is not. */
  const englishName = (() => {
    let display = null;
    try {
      display = new Intl.DisplayNames(['en'], { type: 'region' });
    } catch (e) {}
    const seen = {};
    return (cc) => {
      if (!display || !cc) return '';
      if (seen[cc] === undefined) {
        try {
          seen[cc] = display.of(cc) || '';
        } catch (e) {
          seen[cc] = '';
        }
      }
      return seen[cc];
    };
  })();

  /* What is Glopal actually serving on this page?

     Since 25 Aug 2026 the hostname alone cannot answer that. A branded site
     serves either its own language or English, chosen by a Glopal cookie we
     cannot read and not written into the URL — their redirect strips
     gl_language on the way back. So ask Glopal, who publish it:
     window.glopal.config.target.languageTag flips nl-NL -> en-GB the moment the
     shopper switches. _webinterpret.language is the same value under the older
     global, kept as a fallback.

     Returns a BCP-47 tag or null. Wrapped because both globals belong to a third
     party and are absent on the main site. */
  function glopalLanguageTag() {
    try {
      const target = window.glopal && window.glopal.config && window.glopal.config.target;
      if (target && target.languageTag) return target.languageTag;
    } catch (e) {}
    try {
      if (window._webinterpret && window._webinterpret.language) return window._webinterpret.language;
    } catch (e) {}
    return null;
  }

  /* Accents off, so "franc" finds Français and "osterreich" finds Österreich. A
     shopper typing on an English keyboard should not have to produce a ç to find
     their own country. */
  function flatten(text) {
    const value = String(text).toLowerCase();
    return (value.normalize ? value.normalize('NFD').replace(/[̀-ͯ]/g, '') : value).replace(
      /\s+/g,
      ' '
    );
  }

  function absolute(href) {
    try {
      return new URL(href, window.location.href).href;
    } catch (e) {
      return href;
    }
  }

  function param(name) {
    const match = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.search);
    return match ? decodeURIComponent(match[1]) : null;
  }

  class CountrySwitcher extends HTMLElement {
    /* The old theme booted this on DOMContentLoaded and the timing matters:
       locate() and relabelCountries() both read window.glopal, a third-party
       global that is not there yet while the parser is still inside the header.
       A custom element upgrades far earlier than that, so wait DOMContentLoaded
       out and keep the behaviour identical to what it replaced. */
    connectedCallback() {
      if (this.bound) return;
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setup(), { once: true });
      } else {
        this.setup();
      }
    }

    setup() {
      if (this.bound) return;

      const data = this.querySelector('.country-switcher__data');
      this.toggle = this.querySelector('.country-switcher__toggle');
      this.panel = this.querySelector('.country-switcher__panel');
      this.list = this.querySelector('.country-switcher__list');
      this.search = this.querySelector('.country-switcher__input');
      this.empty = this.querySelector('.country-switcher__empty');
      this.notice = this.querySelector('.country-switcher__notice');
      if (!data || !this.toggle || !this.panel || !this.list) return;

      try {
        this.data = JSON.parse(data.textContent);
      } catch (e) {
        return;
      }

      /* Accepts either form: a bare path like /de, or a full address if this is
         ever pointed back at an absolute one. */
      const shared = this.data.sharedGerman || '';
      this.sharedGermanPath =
        shared.charAt(0) === '/' ? shared : '/' + shared.split('/').slice(3).join('/');

      this.where = this.locate();
      /* The country comes from the address on a Glopal site, from the parameter
         our own links carry, and only otherwise from Shopify. */
      this.country = this.where.cc || param('country') || this.data.shopCountry;

      this.rows = [];
      this.options = [];
      this.findCache = [];
      this.plainFor = {};
      this.bindEvents();

      this.bound = true;

      /* The trigger's flag and name come from Liquid, right on the main site in
         English. Anywhere else (a Glopal address, the /de path, a ?country=
         Shopify has not applied) markCurrent() corrects them from the rows, so
         those pages fetch the rows now rather than when the switcher opens. */
      const labelled =
        !this.where.fixed && this.where.lang === 'English' && this.country === this.data.shopCountry;
      if (!labelled) this.load();
    }

    /* The rows, from sections/country-switcher-list.liquid, once. Asked of the
       page we are on, so a Glopal path translates them as it did the page;
       Shopify's root if that page won't render them (a 404 says not OK). Until
       they land the list is busy and holds its open height. A failure leaves the
       list empty and the next reach tries again. */
    load() {
      if (this.loading) return this.loading;
      this.list.setAttribute('aria-busy', 'true');

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const rowsFrom = (path) =>
        fetch(path + '?section_id=country-switcher-list', { credentials: 'same-origin' })
          .then((response) => (response.ok ? response.text() : ''))
          .then((html) =>
            Array.from(
              new DOMParser().parseFromString(html, 'text/html').querySelectorAll('.country-switcher__item')
            )
          );

      this.loading = rowsFrom(window.location.pathname)
        .then((rows) => (rows.length || window.location.pathname === root ? rows : rowsFrom(root)))
        .then((rows) => {
          if (!rows.length) throw new Error('no rows');
          this.list.replaceChildren(...rows);
          this.relabelCountries();
          this.indexRows();
          this.markCurrent();
          this.rewriteHrefs();
          this.describeFixedCountry();
          this.list.removeAttribute('aria-busy');
          if (this.getAttribute('data-open') === 'true') {
            if (this.search && this.search.value.trim()) this.filter();
            this.reveal(this.current);
          }
        })
        .catch(() => {
          this.list.removeAttribute('aria-busy');
          this.loading = null;
        });
      return this.loading;
    }

    /* Where is this browser, and what is it reading? */
    locate() {
      const host = window.location.hostname;
      const path = window.location.pathname;
      const sites = this.data.sites || [];

      /* English is the only alternate any branded site offers, so one flag is
         enough to tell what a hostname is currently serving. If Glopal ever add
         a third language to a site, this needs the full tag rather than a
         boolean. */
      const tag = glopalLanguageTag();
      const readingEnglish = !!tag && tag.slice(0, 2).toLowerCase() === 'en';

      let fallback = null;
      for (let i = 0; i < sites.length; i++) {
        if (sites[i].host !== host) continue;
        const isEnglishRow = sites[i].lang === 'English';
        /* Prefer the row matching what Glopal say they are serving. */
        if (tag && isEnglishRow === readingEnglish) {
          return { cc: sites[i].cc, lang: sites[i].lang, endo: sites[i].endo, fixed: true };
        }
        if (!fallback) fallback = sites[i];
      }
      /* Reading English on a branded host that has no English row.

         Since 26 Aug 2026 English is served by the main site, so nobody is sent
         here for it and there is nothing to match. A shopper can still arrive in
         this state through Glopal's OWN selector, which they render on every
         branded site and which still offers English. The country is still
         pinned by the host, so keep it and tell the truth about the language
         rather than claiming they are reading German at a page that is in
         English. */
      if (fallback && readingEnglish) {
        return { cc: fallback.cc, lang: 'English', endo: 'English', fixed: true };
      }
      /* No tag, or no row matched it: the site's own language is the honest
         default — it is what the host serves to a shopper who has not asked for
         anything else. */
      if (fallback) {
        return { cc: fallback.cc, lang: fallback.lang, endo: fallback.endo, fixed: true };
      }
      /* Deliberately not checking the host: /de is a path, so it is German on
         staging and on any preview domain too, not only on the live one. A
         branded Glopal host would already have matched above. */
      if (this.sharedGermanPath !== '/' && path.indexOf(this.sharedGermanPath) === 0) {
        return { cc: null, lang: 'German', endo: 'Deutsch', fixed: false };
      }
      return { cc: null, lang: 'English', endo: 'English', fixed: false };
    }

    /* Put the country names into the language the shopper is actually reading,
       when Shopify has rendered them in a different one.

       Glopal switch their own translation layer when a shopper picks a language,
       but they do not re-request the page from Shopify, so Shopify.locale stays
       pinned to the site's language:

           ae. default      shopify=ar  reading=ar  -> agrees
           ae. in English   shopify=ar  reading=en  -> Arabic names
           ca. in English   shopify=fr  reading=en  -> "Royaume-Uni"

       So an English-reading Canadian was picking from a French list. That is
       Glopal's to fix properly — it affects checkout and address forms too,
       which are not ours — but the panel can at least stop being wrong about
       itself, and Intl.DisplayNames already gives us every name in every
       language for nothing.

       The rows are RE-SORTED afterwards. Shopify sorted them by the name it
       rendered, so relabelling alone would leave English names in Arabic order —
       Iceland, Azerbaijan, Armenia, Afghanistan — which is worse than the
       problem. The sort is stable, so a country keeps its rows together and in
       their existing native-then-English order.

       Does nothing on the main site, where nothing disagrees, and nothing at all
       if Intl.DisplayNames is missing. */
    relabelCountries() {
      const tag = glopalLanguageTag();
      if (!tag) return;
      const reading = tag.slice(0, 2).toLowerCase();
      if (!reading || reading === String(this.data.shopLocale).slice(0, 2).toLowerCase()) return;

      let display;
      try {
        display = new Intl.DisplayNames([tag], { type: 'region' });
      } catch (e) {
        return;
      }

      const items = Array.from(this.list.querySelectorAll('.country-switcher__item'));
      let named = false;
      items.forEach((row) => {
        const option = row.querySelector('.country-switcher__option');
        const nameEl = option && option.querySelector('.country-switcher__name');
        if (!option || !nameEl) return;
        const cc = option.getAttribute('data-cc');
        let name;
        try {
          name = display.of(cc);
        } catch (e) {
          return;
        }
        /* .of() hands back the code itself when it has no name for it. */
        if (!name || name === cc) return;
        nameEl.textContent = name;
        named = true;
      });
      if (!named) return;

      const fragment = document.createDocumentFragment();
      items
        .sort((x, y) => {
          const a = x.querySelector('.country-switcher__name');
          const b = y.querySelector('.country-switcher__name');
          if (!a || !b) return 0;
          return a.textContent.localeCompare(b.textContent, tag);
        })
        .forEach((row) => fragment.appendChild(row));
      this.list.appendChild(fragment);
    }

    indexRows() {
      this.rows = Array.from(this.list.querySelectorAll('.country-switcher__item'));
      this.options = this.rows.map((row) => row.querySelector('.country-switcher__option'));
      this.findCache = [];

      /* Which plain row belongs to each country, so we can spot a language row
         that would land on exactly the same address and hide it. On /de the
         plain rows are already German, so the Deutsch rows are duplicates. */
      this.plainFor = {};
      this.options.forEach((option) => {
        if (option && !option.hasAttribute('data-lang')) {
          this.plainFor[option.getAttribute('data-cc')] = absolute(option.getAttribute('href'));
        }
      });
    }

    isDuplicate(option) {
      return (
        option.hasAttribute('data-lang') &&
        this.plainFor[option.getAttribute('data-cc')] === absolute(option.getAttribute('href'))
      );
    }

    markCurrent() {
      this.current = null;

      this.rows.forEach((row, i) => {
        const option = this.options[i];
        if (!option) return;
        if (this.isDuplicate(option)) {
          row.hidden = true;
          return;
        }

        const cc = option.getAttribute('data-cc');
        const lang = option.getAttribute('data-lang');
        /* Which row is the page we are on?

           On a BRANDED host the country is decided by the hostname, not by the
           ?country= that got us here, and every country now has a plain row —
           including this host's own. That plain row means "the main site, in
           English": somewhere to go, not where we are. So match on the language
           too, and let a plain row win only when English is what is actually
           being read.

           On the MAIN SITE every row that stays put is a plain one — at the root
           they are English, on /de they are German — and the language rows all
           lead to other hosts. So the plain row for this country is the answer
           whatever language the path serves. */
        const isHere = this.where.fixed
          ? cc === this.where.cc && (lang || 'English') === this.where.lang
          : cc === this.country && !lang;
        if (isHere && !this.current) {
          this.current = option;
          option.setAttribute('aria-current', 'true');
        }
      });

      /* The trigger. Shopify's own label is right on the main site and wrong on
         a Glopal one, so correct it rather than trusting it. */
      if (!this.current) return;
      const name = this.current.querySelector('.country-switcher__name');
      const valueName = this.querySelector('.country-switcher__value-name');
      const valueLang = this.querySelector('.country-switcher__value-language');
      const valueFlag = this.querySelector('.country-switcher__flag--toggle');
      /* Take the flag off the row we matched rather than building an asset URL
         by hand: Liquid has already stamped the CDN path onto it. */
      const rowFlag = this.current.querySelector('.country-switcher__flag');
      if (valueFlag && rowFlag) valueFlag.src = rowFlag.getAttribute('src');
      if (valueName && name) valueName.textContent = name.textContent.trim();
      if (!valueLang) return;
      if (this.where.lang === 'English') {
        valueLang.hidden = true;
      } else {
        valueLang.textContent = '· ' + this.where.endo;
        valueLang.hidden = false;
      }
    }

    rewriteHrefs() {
      const originHost = this.data.originHost;

      /* On a branded address EVERY plain row has to leave, this host's own
         country included.

         A plain row used to be a row for somewhere else, because a country with
         a branded site had no plain row at all, so the site's own country kept
         its relative href and meant "stay here". Since 26 Aug 2026 every country
         has a plain row and it means "the main site, in English" — so on de. the
         Germany plain row is the way OUT to English, and leaving it relative
         would resolve it back against de. and go nowhere.

         Pointing straight at the main site also saves a redirect: a relative
         link would land here and rely on Glopal bouncing it, which does work but
         is their behaviour to change, not ours. */
      if (this.where.fixed) {
        this.options.forEach((option) => {
          if (!option) return;
          const cc = option.getAttribute('data-cc');
          const href = option.getAttribute('href') || '';
          const plain = !option.hasAttribute('data-lang');
          /* Everything relative has to be made absolute: it would otherwise
             resolve against THIS host, and nothing but this country lives here —
             /de in particular does not. Rows that are already absolute name
             another branded site and are left alone. */
          if (href.charAt(0) === '/') {
            option.setAttribute('href', 'https://' + originHost + href);
          } else if (plain) {
            option.setAttribute(
              'href',
              'https://' + originHost + '/?wi=off&country=' + encodeURIComponent(cc)
            );
          }
        });
      }

      /* /de is Germany's page, and only Germany's. Glopal would serve any
         country there, but the shop wants one market and one currency on it, so
         every other country leaves for the main site in English.

         Keyed off the country list rather than the currency: Italy pays in euros
         too, and it still does not belong on the German site.

         The link is root-relative on purpose. /de is a PATH on the main site,
         not a host of its own, so dropping the path is the whole journey back to
         English — and it keeps staging on staging. Writing the live address here
         sends a tester off the theme they are testing.

         Only relative links need this. An absolute one already points at a
         country-specific address, which has its own market and is none of /de's
         business. */
      if (this.where.lang === 'German' && !this.where.fixed) {
        const allowed = ',' + (this.data.sharedGermanCountries || '') + ',';
        this.options.forEach((option) => {
          if (!option) return;
          const cc = option.getAttribute('data-cc');
          if (allowed.indexOf(',' + cc + ',') > -1) return;
          const href = option.getAttribute('href') || '';
          if (href.charAt(0) !== '?' && href.charAt(0) !== '/') return;
          option.setAttribute('href', '/?wi=off&country=' + encodeURIComponent(cc));
        });
      }
    }

    /* On a Glopal address the country is fixed by the site itself. */
    describeFixedCountry() {
      if (!this.notice || !this.where.fixed || !this.current) return;
      const name = this.current.querySelector('.country-switcher__name');
      const currency = this.current.querySelector('.country-switcher__currency');
      /* Square brackets, not the curly braces Liquid normally uses for
         placeholders: the string arrives from a locale file through Liquid, so a
         curly placeholder would be evaluated at render time and vanish before
         the browser ever saw it. */
      this.notice.textContent = String(this.data.shipsTo || '')
        .replace('[[country]]', name ? name.textContent.trim() : '')
        .replace('[[currency]]', currency ? currency.textContent.trim() : '');
      this.notice.hidden = false;
    }

    /* Place the panel on a phone, then CHECK the result and correct it. Working
       out where an absolutely positioned box will land from the stylesheet alone
       is guesswork — a transformed or positioned ancestor anywhere up the header
       can quietly become its containing block. So rather than assume, measure
       what the browser actually did and nudge the panel back inside the viewport
       if it escaped. Costs one layout read on open and is immune to whatever the
       header does above us. */
    place() {
      this.panel.style.top = '';
      this.panel.style.width = '';
      this.panel.style.transform = '';
      if (window.innerWidth > NARROW) return;

      this.panel.style.top = Math.round(this.toggle.getBoundingClientRect().bottom + 10) + 'px';

      const room = window.innerWidth - GUTTER * 2;
      let rect = this.panel.getBoundingClientRect();
      if (rect.width > room) {
        this.panel.style.width = room + 'px';
        rect = this.panel.getBoundingClientRect();
      }
      /* Centre it outright rather than nudging it off an edge. Correcting only
         the overflowing side leaves the panel lopsided once the viewport is
         narrow enough that the gutters stop being equal, which is exactly what
         shows up below about 324px. */
      const want = Math.max(GUTTER, Math.round((window.innerWidth - rect.width) / 2));
      const shift = Math.round(want - rect.left);
      if (shift) this.panel.style.transform = 'translateX(' + shift + 'px)';
    }

    /* Scroll the LIST, never the document. scrollIntoView walks every scrollable
       ancestor and its `inline` option defaults to 'nearest', so on a page that
       overflows sideways it scrolls the PAGE across to reveal a row. The fixed
       panel stays put, the layout slides under it, and the result reads as a
       panel that is not centred. */
    reveal(row) {
      if (!row) return;
      const top = row.offsetTop - (this.list.clientHeight - row.offsetHeight) / 2;
      this.list.scrollTop = Math.max(0, Math.round(top));
    }

    open(state) {
      this.setAttribute('data-open', state ? 'true' : 'false');
      this.toggle.setAttribute('aria-expanded', state ? 'true' : 'false');
      this.panel.hidden = !state;
      if (!state) return;
      if (!this.rows.length) this.load();
      this.place();
      /* Not on a phone: focusing the search box there throws the on-screen
         keyboard up over the list the shopper just asked to see. */
      if (this.search && window.innerWidth > NARROW) this.search.focus();
      this.reveal(this.current);
    }

    /* What each row can be found by — FOUR sources, so a shopper can type either
       language wherever they are standing.

       1. data-find    Liquid renders it in English, and on a Glopal site Glopal
                       TRANSLATE it. Left deliberately unprotected: that is what
                       makes searching in the page language work, in any language
                       they add, without the theme knowing a word of it.
       2. englishName  the country name in English, from the browser, because
                       Shopify has already localised its own copy. This is what
                       keeps English working on a translated host.
       3. data-lang    the language in English — "German", not "Deutsch".
                       Survives translation on its own.
       4. textContent  the visible names: the country translated, the endonym
                       protected by data-gp-noloc.

       1 and 4 give the page language, 2 and 3 give English, and on the main site
       they all agree. Cached on first search: 232 rows is too many to re-read on
       every keystroke. */
    findable(option, i) {
      if (this.findCache[i] === undefined) {
        this.findCache[i] = flatten(
          (option.getAttribute('data-find') || '') +
            ' ' +
            englishName(option.getAttribute('data-cc')) +
            ' ' +
            (option.getAttribute('data-lang') || '') +
            ' ' +
            (option.textContent || '')
        );
      }
      return this.findCache[i];
    }

    filter() {
      const query = flatten(this.search.value.trim());
      let shown = 0;
      this.rows.forEach((row, i) => {
        const option = this.options[i];
        if (!option) return;
        if (this.isDuplicate(option)) return;
        const hit = !query || this.findable(option, i).indexOf(query) > -1;
        row.hidden = !hit;
        if (hit) shown++;
      });
      /* No rows yet is not "no results": load() filters again when they land. */
      if (this.empty) this.empty.hidden = shown > 0 || !this.rows.length;
    }

    bindEvents() {
      this.toggle.addEventListener('click', () => {
        this.open(this.getAttribute('data-open') !== 'true');
      });

      /* A head start on the rows: the pointer reaching the trigger, a tap
         landing on it or focus arriving comes a moment before the click. */
      ['pointerenter', 'pointerdown', 'focus'].forEach((type) => {
        this.toggle.addEventListener(type, () => this.load(), { passive: true });
      });

      const closer = this.querySelector('.country-switcher__close');
      if (closer) {
        closer.addEventListener('click', () => {
          /* Focus first, then close — same reason as the Escape handler below. */
          this.toggle.focus();
          this.open(false);
        });
      }

      window.addEventListener('resize', () => {
        if (this.getAttribute('data-open') === 'true') this.place();
      });

      if (this.search) {
        this.search.addEventListener('input', () => this.filter());
      }

      /* Arrow keys walk the list; Escape closes and hands focus back.

         Focus BEFORE closing, not after: hiding a panel that still contains the
         focused element makes the browser relocate focus on its own, which can
         land after a focus() on the next line. Taking focus first leaves it
         nothing to relocate. The old theme called these the other way round.

         ⚠️ On a page where Glopal is live the trigger does NOT keep that focus,
         and it is not this component's doing. GLOPAL STEALS IT: their script
         has its own document-level Escape handler that focuses their selector
         widget. Measured 2026-08-26 with this switcher CLOSED and none of the
         code below running — Escape still moved focus off the trigger onto
         `.glopal-design-discreet-branding`. So do not go hunting in here for
         it, and do not "fix" it by fighting them for focus on a timer. */
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.getAttribute('data-open') === 'true') {
          event.preventDefault();
          this.toggle.focus();
          this.open(false);
          return;
        }
        if (['ArrowDown', 'ArrowUp', 'Home', 'End'].indexOf(event.key) === -1) return;
        const live = this.options.filter((option, i) => option && !this.rows[i].hidden);
        if (!live.length) return;
        event.preventDefault();
        const at = live.indexOf(document.activeElement);
        const next =
          event.key === 'Home'
            ? 0
            : event.key === 'End'
              ? live.length - 1
              : event.key === 'ArrowDown'
                ? at < 0
                  ? 0
                  : Math.min(at + 1, live.length - 1)
                : at <= 0
                  ? 0
                  : at - 1;
        live[next].focus();
        this.reveal(live[next]);
      });
    }

    closeUnless(owner) {
      if (owner === this) return;
      if (this.getAttribute('data-open') === 'true') this.open(false);
    }
  }

  if (!customElements.get('country-switcher')) {
    customElements.define('country-switcher', CountrySwitcher);

    /* Capture phase on purpose: a bubble-phase handler can see a target that has
       already been detached by whatever the click did, read it as an outside
       click, and shut the panel in the same gesture that opened it. */
    document.addEventListener(
      'click',
      (event) => {
        const owner = event.target.closest ? event.target.closest('country-switcher') : null;
        document.querySelectorAll('country-switcher').forEach((el) => {
          if (el.closeUnless) el.closeUnless(owner);
        });
      },
      true
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["element.select"] && !Shopify.designMode) return;
  try {
    // Custom element for select button functionality
  class ElementSelect extends HTMLElement {
    constructor() {
      super();
      this.select = null;
      this.buttonText = null;
      this.button = null;
    }

    connectedCallback() {
      // Wait for DOM to be ready
      this.select = this.querySelector('select');
      this.button = this.querySelector('.element-button');
      
      if (this.select && this.button) {
        this.init();
      }
    }

    init() {
      // Find the button text element within the element.button
      this.buttonText = this.button.querySelector('.element-button__text') || this.button.querySelector('[data-button-text]');
      
      // Set initial text
      this.updateButtonText();
      
      // Add click handler to button to trigger select
      this.button.addEventListener('click', (e) => this.handleButtonClick(e));
      
      // Add keyboard handler for the select element
      this.select.addEventListener('keydown', (e) => this.handleKeydown(e));
      
      // Update on change
      this.select.addEventListener('change', () => this.updateButtonText());
      
      // Update on focus for better UX
      this.select.addEventListener('focus', () => this.handleFocus());
      this.select.addEventListener('blur', () => this.handleBlur());
    }

    handleButtonClick(e) {
      // Prevent default button behavior
      e.preventDefault();
      e.stopPropagation();
      
      // Trigger the native select
      this.select.focus();
      this.select.click();
    }

    handleKeydown(e) {
      // Handle keyboard navigation for the select
      switch (e.key) {
        case 'Enter':
        case ' ':
          e.preventDefault();
          this.select.click();
          break;
        case 'ArrowDown':
        case 'ArrowUp':
          // Let the native select handle arrow key navigation
          break;
        default:
          // Let other keys pass through
          break;
      }
    }

    updateButtonText() {
      if (!this.buttonText) return;
      
      const selectedOption = this.select.options[this.select.selectedIndex];
      if (selectedOption && selectedOption.value !== '') {
        this.buttonText.textContent = selectedOption.textContent;
      } else {
        this.buttonText.textContent = this.select.getAttribute('aria-label') || 'Select an option';
      }
    }

    handleFocus() {
      this.classList.add('element-select__wrapper--focused');
    }

    handleBlur() {
      this.classList.remove('element-select__wrapper--focused');
    }

    disconnectedCallback() {
      // Clean up event listeners
      if (this.button) {
        this.button.removeEventListener('click', (e) => this.handleButtonClick(e));
      }
      if (this.select) {
        this.select.removeEventListener('keydown', (e) => this.handleKeydown(e));
        this.select.removeEventListener('change', () => this.updateButtonText());
        this.select.removeEventListener('focus', () => this.handleFocus());
        this.select.removeEventListener('blur', () => this.handleBlur());
      }
    }
  }

  // Register the custom element
  customElements.define('element-select', ElementSelect);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product"] && !Shopify.designMode) return;
  try {
    class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.findSubmitButton();
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    findSubmitButton() {
      // Look for submit button in the form
      const submitButton = this.form.querySelector('button[type="submit"], input[type="submit"]');
      return submitButton;
    }

    disableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = true;
        this.submitButton.classList.add('product-form__submit-button--pulsing');
      }
    }

    enableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = false;
        this.submitButton.classList.remove('product-form__submit-button--pulsing');
      }
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();

      // Disable submit button and start pulsing
      this.disableSubmitButton();

      // Get cart state before form submission
      let cartBeforeSubmission;
      try {
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        cartBeforeSubmission = await cartResponse.json();
      } catch (error) {
        console.error('Failed to get cart state before submission:', error);
        cartBeforeSubmission = null;
      }

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      };

      const formData = new FormData(this.form);

      // Dispatch event allowing subscribers to modify formData
      this.dispatchEvent(
        new CustomEvent('product-form:submit:before', {
          bubbles: true,
          detail: {
            form: formData,
          },
          cancelable: true
        })
      );

      // Wait for the next tick to allow async event listeners to complete
      // This ensures all synchronous and microtask listeners have finished
      await new Promise(resolve => {
        // Use queueMicrotask for better performance than setTimeout
        queueMicrotask(resolve);
      });

      config.body = formData;

      // Dispatch event allowing subscribers to handle cart request themselves
      const cartRequestEvent = new CustomEvent('product-form:cart:request', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: formData,
          config: config,
          cartBefore: cartBeforeSubmission,
          resolve: (responseData) => this.resolveCartRequest(responseData),
          reject: (error) => this.rejectCartRequest(error)
        }
      });

      const cartRequestHandled = !this.dispatchEvent(cartRequestEvent);
      let responseData;

      try {
        if (cartRequestHandled) {
          // Event was cancelled, meaning a subscriber handled the cart request
          // We need to wait for them to provide the response data
          responseData = await this.waitForCartResponse();
        } else {
          // No subscriber handled it, proceed with default behavior
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, config);       
          responseData = await response.json();

          if (!response.ok) {
            throw responseData;
          }
        }

        // Get updated cart state after form submission
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        const cartAfterSubmission = await cartResponse.json();

        this.dispatchEvent(
          new CustomEvent('product-form:submit:success', {
            bubbles: true,
            detail: {
              form: formData,
              response: responseData,
              cart: cartAfterSubmission
            },
          })
        );

        // Only fire cart:update if there's a change from this specific submission
        if (this.hasCartChanged(cartBeforeSubmission, cartAfterSubmission)) {
          this.dispatchEvent(
            new CustomEvent('product-form:cart:update', {
              bubbles: true,
              detail: {
                cart: cartAfterSubmission,
                form: formData,
                response: responseData
              },
            })
          );
        }

        // Navigate to cart unless prevented by another event handler
        const cartNavigationEvent = new CustomEvent('product-form:cart:navigate', {
          bubbles: true,
          cancelable: true,
          detail: {
            form: formData,
            response: responseData,
            cart: cartAfterSubmission
          }
        });

        const navigationPrevented = !this.dispatchEvent(cartNavigationEvent);
        
        if (!navigationPrevented) {
          window.location.href = `${window.Shopify.routes.root}cart`;
        }
      } catch (error) {
        this.dispatchEvent(
          new CustomEvent('product-form:submit:error', {
            bubbles: true,
            detail: {
              form: formData,
              cart: cartBeforeSubmission,
              error: error
            },
          })
        );
      } finally {
        // Re-enable submit button and stop pulsing
        this.enableSubmitButton();
      }
    }

    /**
     * Waits for a subscriber to provide cart response data after handling the cart request
     * @returns {Promise<Object>} The cart response data
     */
    waitForCartResponse() {
      return new Promise((resolve, reject) => {
        // Store the resolver for this request
        this._cartRequestResolver = { resolve, reject };
        
        // Set a timeout to prevent hanging
        const timeout = setTimeout(() => {
          if (this._cartRequestResolver) {
            delete this._cartRequestResolver;
            reject(new Error('Cart request timeout - no response received from subscriber'));
          }
        }, 30000); // 30 second timeout
        
        // Store timeout reference for cleanup
        this._cartRequestResolver.timeout = timeout;
      });
    }

    /**
     * Resolves a pending cart request with response data
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Object} responseData - The cart response data
     */
    resolveCartRequest(responseData) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.resolve(responseData);
        delete this._cartRequestResolver;
      }
    }

    /**
     * Rejects a pending cart request with an error
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Error} error - The error that occurred
     */
    rejectCartRequest(error) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.reject(error);
        delete this._cartRequestResolver;
      }
    }

    hasCartChanged(cartBefore, cartAfter) {
      if (!cartBefore || !cartAfter) {
        return true; // If we can't compare, assume there's a change
      }

      // Deep comparison using JSON.stringify for simplicity
      // This handles all nested changes automatically
      return JSON.stringify(cartBefore) !== JSON.stringify(cartAfter);
    }
  }

  customElements.define('product-form', ProductForm);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product.messages"] && !Shopify.designMode) return;
  try {
    class ProductFormMessages extends HTMLElement {
    constructor() {
      super();
      
      // Pull localized error message from data attributes
      this.formId = this.dataset.formId;
      this.defaultErrorMessage = this.dataset.error;
      this.defaultSuccessMessage = this.dataset.success;
      
      // Create abort controller for event cleanup
      this.abortController = new AbortController();
    }

    connectedCallback() {
      // Cache the template content for better performance
      this.cacheTemplate();
      this.bindEvents();
    }

    disconnectedCallback() {
      // Clean up event listeners when component is removed
      this.abortController.abort();
    }

    cacheTemplate() {
      const template = this.querySelector('template');
      if (template) {
        this.template = template.innerHTML;
        this.templateElement = template;
      }
    }

    bindEvents() {
      const { signal } = this.abortController;
      
      // Listen for form submission start to clear error messages
      document.addEventListener('product-form:submit:before', this.handleSubmitStart.bind(this), { signal });
      
      // Listen for form errors
      document.addEventListener('product-form:submit:error', this.handleError.bind(this), { signal });

      // Listen for form success
      document.addEventListener('product-form:submit:success', this.handleSuccess.bind(this), { signal });
    }

    handleSubmitStart(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      this.clearMessages();
    }

    handleSuccess(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      let message = this.defaultSuccessMessage;

      const successMessageEvent = new CustomEvent('product-form:message:success', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      // Dispatch the event and check if it was cancelled
      const eventCancelled = !this.dispatchEvent(successMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(successMessageEvent.detail.message);
    }

    handleError(e) { 
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      const error = e.detail.error;
      let message = this.defaultErrorMessage;
      
      // Use server response message if available (already localized)
      if (error.description) {
        message = error.description;
      } else if (error.message) {
        message = error.message;
      }

      const errorMessageEvent = new CustomEvent('product-form:message:error', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      const eventCancelled = !this.dispatchEvent(errorMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(errorMessageEvent.detail.message);
    }

    showMessage(message) {
      // Clear existing error messages
      this.clearMessages();
      this.classList.remove('hide');
      
      // Use cached template content and replace <slot> with the error message
      if (this.template) {
        const messageContent = this.template.replace('<slot></slot>', message);
        
        // Insert the error message content
        this.innerHTML = messageContent;
      }
    }

    clearMessages() {
      this.classList.add('hide');

      // Restore the original template structure using cached template
      if (this.templateElement) {
        this.innerHTML = this.templateElement.outerHTML;
      }
    }
  }

  customElements.define('product-form-messages', ProductFormMessages);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["globale-shipping-banner"] && !Shopify.designMode) return;
  try {
    (function () {
    var box = document.getElementById('GlobaleFreeShippingBannerContainer');
    var bar = document.getElementById('AnnouncementSlider');
    if (!box || !bar) return;

    var KEPT = 'globale-free-shipping';
    var country = box.dataset.country;
    var handed = '';

    // The announcement bar carries the words, so Global-E's own bar never shows or takes room.
    box.hidden = true;

    // "Free shipping to Taiwan on all orders above NT$6,390 | …" -> ["Free shipping over NT$6,390", "…"].
    function messages(text) {
      return text.split(/\s*\|\s*/).filter(Boolean).map(function (part, i) {
        var offer = i === 0 && part.match(/^free shipping to .+ on all orders above (.+)$/i);
        return offer && box.dataset.offer ? box.dataset.offer.replace('[amount]', offer[1]) : part;
      });
    }

    function hand(texts, opening) {
      var key = JSON.stringify(texts);
      if (key === handed) return;
      handed = key;
      customElements.whenDefined('announcement-rotator').then(function () {
        if (typeof bar.lead === 'function') bar.lead(texts, opening);
      });
    }

    function read() {
      var words = box.querySelector('.ge-free-shipping-msg');
      var text = words ? words.textContent.replace(/\s+/g, ' ').trim() : '';
      if (!text) return;
      var texts = messages(text);
      hand(texts, false);
      try {
        sessionStorage.setItem(KEPT, JSON.stringify({ country: country, texts: texts }));
      } catch (error) {}
    }

    // An offer Global-E gave earlier in the visit, for the same country, opens the bar before Global-E answers.
    try {
      var kept = JSON.parse(sessionStorage.getItem(KEPT) || 'null');
      if (kept && kept.country === country && Array.isArray(kept.texts) && kept.texts.length) {
        hand(kept.texts, true);
      }
    } catch (error) {}

    new MutationObserver(read).observe(box, { childList: true, subtree: true, characterData: true });
    read();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kit.popover"] && !Shopify.designMode) return;
  try {
    class KitPopover extends HTMLElement {
    #abortController = null;

    connectedCallback() {
      this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      // Prevent flash of previously-positioned popover
      this.addEventListener(
        'beforetoggle',
        (event) => {
          if (event.newState === 'open') {
            this.style.visibility = 'hidden';
          }
        },
        { signal }
      );

      this.addEventListener(
        'toggle',
        (event) => {
          if (event.newState === 'open') {
            this.#position();
            this.style.visibility = '';
          }
        },
        { signal }
      );

      window.addEventListener(
        'resize',
        () => {
          if (this.matches(':popover-open')) this.#position();
        },
        { signal, passive: true }
      );

      this.addEventListener(
        'click',
        (event) => {
          if (event.target.closest('a[href], button:not([popovertarget])')) {
            this.hidePopover();
          }
        },
        { signal }
      );
    }

    disconnectedCallback() {
      this.#abortController?.abort();
    }

    #position() {
      const trigger = document.querySelector(`[popovertarget="${this.id}"]`);
      if (!trigger) return;

      const placement = this.getAttribute('placement') || 'bottom-start';
      const isRTL = getComputedStyle(this).direction === 'rtl';
      const gap = Number(this.getAttribute('gap') ?? 4);
      const margin = 4;

      const triggerRect = trigger.getBoundingClientRect();
      const popoverWidth = this.offsetWidth;
      const popoverHeight = this.offsetHeight;

      const [axis, alignment] = placement.split('-');

      let top = axis === 'bottom' ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap;
      let resolvedAxis = axis;

      // Auto-flip vertically if overflowing viewport
      if (axis === 'bottom' && top + popoverHeight > window.innerHeight - margin) {
        top = triggerRect.top - popoverHeight - gap;
        resolvedAxis = 'top';
      } else if (axis === 'top' && top < margin) {
        top = triggerRect.bottom + gap;
        resolvedAxis = 'bottom';
      }

      const alignStart = isRTL ? 'end' : 'start';
      let left;
      if (alignment === 'center') {
        left = triggerRect.left + (triggerRect.width - popoverWidth) / 2;
      } else if (alignment === alignStart) {
        left = triggerRect.left;
      } else {
        left = triggerRect.right - popoverWidth;
      }

      // Clamp horizontally to viewport
      if (left < margin) {
        left = margin;
      } else if (left + popoverWidth > window.innerWidth - margin) {
        left = window.innerWidth - popoverWidth - margin;
      }

      this.style.transformOrigin = resolvedAxis === 'bottom' ? 'top' : 'bottom';

      // Convert to document coordinates so popover scrolls with page
      this.style.top = `${Math.round(top + window.scrollY)}px`;
      this.style.left = `${Math.round(left + window.scrollX)}px`;
    }
  }

  customElements.define('kit-popover', KitPopover);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.grid"] && !Shopify.designMode) return;
  try {
    class LayoutGrid extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-grid', LayoutGrid);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.stack"] && !Shopify.designMode) return;
  try {
    class LayoutStack extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-stack', LayoutStack);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.sticky-scroller"] && !Shopify.designMode) return;
  try {
    class StickyScroller extends HTMLElement {
    constructor() {
      super()
      this.resizeObserver = new ResizeObserver(() => this.recalculateStyles())
      this.abortController = new AbortController()
      this.isScrolling = false
      this.position = 'relative'
      this.lastKnownScrollY = 0
      this.initialTop = 0
      this.currentTop = 0
      this.boundOnScroll = this.onScroll.bind(this)
    }

    connectedCallback() {
      this.inView(this, this.setupObservers.bind(this), { margin: '500px' })
    }

    disconnectedCallback() {
      this.cleanupObservers()
    }

    setupObservers() {
      this.resizeObserver.observe(this)
      window.addEventListener('scroll', this.boundOnScroll, { passive: true, signal: this.abortController.signal })
      return this.cleanupObservers.bind(this)
    }

    cleanupObservers() {
      this.abortController.abort()
      this.resizeObserver.disconnect()
    }

    onScroll() {
      if (!this.isScrolling) {
        requestAnimationFrame(() => {
          this.updatePosition()
          this.isScrolling = false
        })
        this.isScrolling = true
      }
    }

    recalculateStyles() {
      this.style.removeProperty('top')
      const { top, position } = getComputedStyle(this)
      this.initialTop = parseInt(top, 10)
      this.position = position
      this.updatePosition()
    }

    updatePosition() {
      if (this.position !== 'sticky') {
        this.style.removeProperty('top')
        return
      }

      const { top, height } = this.getBoundingClientRect()
      const maxTop = top + window.scrollY - this.offsetTop + this.initialTop
      const minTop = height - window.innerHeight + 20

      this.currentTop += this.lastKnownScrollY - window.scrollY
      this.currentTop = Math.min(Math.max(this.currentTop, -minTop), maxTop, this.initialTop)

      this.lastKnownScrollY = window.scrollY
      this.style.top = `${Math.round(this.currentTop)}px`
    }
    
    /**
     * Original source from https://www.npmjs.com/package/@motionone/dom
     * Usage: https://motion.dev/dom/in-view
     */
    inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = 'any' } = {}) {
      const thresholds = {
        any: 0,
        all: 1
      }

      if (typeof IntersectionObserver === 'undefined') {
        return () => {}
      }

      let elements
      if (typeof elementOrSelector === 'string') {
        elements = document.querySelectorAll(elementOrSelector)
      } else if (elementOrSelector instanceof Element) {
        elements = [elementOrSelector]
      } else {
        elements = Array.from(elementOrSelector || [])
      }

      const activeIntersections = new WeakMap()
      const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
          const onEnd = activeIntersections.get(entry.target)
          if (entry.isIntersecting === Boolean(onEnd)) return
          if (entry.isIntersecting) {
            const newOnEnd = onStart(entry)
            if (typeof newOnEnd === 'function') {
              activeIntersections.set(entry.target, newOnEnd)
            } else {
              observer.unobserve(entry.target)
            }
          } else if (onEnd) {
            onEnd(entry)
            activeIntersections.delete(entry.target)
          }
        })
      }

      const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === 'number' ? amount : thresholds[amount]
      })

      elements.forEach((element) => observer.observe(element))
      return () => observer.disconnect()
    }
  }

  customElements.define('sticky-scroller', StickyScroller)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.drawer"] && !Shopify.designMode) return;
  try {
    class OverlayDrawer extends HTMLElement {
    constructor() {
      super();
      
      
      
      // Store arrow functions to ensure same reference for add/remove
    }

    connectedCallback() {
      this.closeButton = null;
      this.triggers = null;
      this.previouslyFocused = document.activeElement;
      this.trapFocusHandlers = {};
      this.abortController = new AbortController();
      this.closeButton = this.querySelector('[data-drawer-close-button]');
      this.triggers = document.querySelectorAll(
        `[data-open-drawer="${this.id}"]`
      );

      const signal = this.abortController.signal;
      
      this.moveToBody();

      this.closeButton.addEventListener('click', () => this.close(), { signal });
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        }, { signal });
      });
      document.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
      this.addEventListener('click', (event) => this.handleOverlayClick(event), { signal });
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    open() {
      this.previouslyFocused = document.activeElement;
      
      this.setAttribute('open', 'true');
      this.trapFocus(this);
    }

    close() {
      this.setAttribute('open', 'false');
      this.removeTrapFocus(this.previouslyFocused);
    }

    moveToBody() {
      if (this.parentNode === document.body) return;
      
      // Store the original parent and next sibling for potential restoration
      this.originalParent = this.parentNode;
      this.originalNextSibling = this.nextSibling;
      
      // Move the element to the body
      document.body.appendChild(this);
    }

    handleOverlayClick(event) {
      if (event.target === this) this.close();
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && this.getAttribute('open') === 'true') {
        this.close();
      }
    }

    removeTrapFocus(elementToFocus = null) {
      if (this.trapFocusAbortController) {
        this.trapFocusAbortController.abort();
        this.trapFocusAbortController = null;
      }

      if (elementToFocus) {
        try {
          elementToFocus.focus({ preventScroll: true })
        } catch (e) {
          elementToFocus.focus()
        }
      }
    }

    forceFocus(element, options = {}) {
      let savedTabIndex = element.tabIndex

      element.tabIndex = -1
      element.dataset.tabIndex = savedTabIndex
      element.focus()
      if (typeof options.className !== 'undefined') {
        element.classList.add(options.className)
      }
      element.addEventListener('blur', callback)

      function callback(event) {
        event.target.removeEventListener(event.type, callback)

        element.tabIndex = savedTabIndex
        delete element.dataset.tabIndex
        if (typeof options.className !== 'undefined') {
          element.classList.remove(options.className)
        }
      }
    }

    // Only what is rendered: a control inside a hidden panel can't take focus, so as the
    // first or last stop it would leave Tab with nowhere to wrap to.
    focusable(container) {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => element.getClientRects().length > 0)
    }

    trapFocus(container, options = {}) {
      let elements = this.focusable(container)
      let elementToFocus = options.elementToFocus || container
      let first = elements[0]
      let last = elements[elements.length - 1]

      this.removeTrapFocus()

      // Create new AbortController for focus trap events
      this.trapFocusAbortController = new AbortController();
      const signal = this.trapFocusAbortController.signal;

      this.trapFocusHandlers.focusin = function (event) {
        if (container !== event.target && !container.contains(event.target)) {
          this.forceFocus(first || container, options)
        }

        if (event.target !== container && event.target !== last && event.target !== first) return
        document.addEventListener('keydown', this.trapFocusHandlers.keydown, { signal })
      }.bind(this)

      this.trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', this.trapFocusHandlers.keydown)
      }.bind(this)

      this.trapFocusHandlers.keydown = function (event) {
        if (event.keyCode !== 9) return // If not TAB key

        // On the last focusable element and tab forward, focus the first element.
          if (event.target === last && !event.shiftKey) {
        event.preventDefault()
        this.forceFocus(first || container, options)
      }

        //  On the first focusable element and tab backward, focus the last element.
          if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault()
        this.forceFocus(last || container, options)
      }
      }.bind(this)

      document.addEventListener('focusout', this.trapFocusHandlers.focusout, { signal })
      document.addEventListener('focusin', this.trapFocusHandlers.focusin, { signal })

      this.forceFocus(elementToFocus, options)
    }
  }

  customElements.define('overlay-drawer', OverlayDrawer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.lightbox"] && !Shopify.designMode) return;
  try {
    class OverlayLightbox extends HTMLElement {
    // Static registry to track all lightbox instances
    static registry = new Map();
    // Track which groups have been prefetched
    static prefetchedGroups = new Set();

    constructor() {
      super();
      this.trigger = null;
      this.template = null;
      this.overlay = null;
      this.closeBtn = null;
      this.prevBtn = null;
      this.nextBtn = null;
      this.group = this.dataset.group;
      this.groupItems = [];
      this.currentIndex = 0;

      // Register this instance
      if (this.group) { 
        if (!OverlayLightbox.registry.has(this.group)) {
          OverlayLightbox.registry.set(this.group, []);
        }
        OverlayLightbox.registry.get(this.group).push(this);
      }
    }

    connectedCallback() {
      // Initialize elements when connected to DOM
      this.trigger = this.querySelector('.overlay-lightbox__trigger');
      this.template = this.querySelector('.overlay-lightbox__template');
      this.init();
    }

    init() {
      // Open lightbox on trigger click
      if (this.trigger) {
        this.trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.openLightbox();
        });
      }


      // Handle ESC key globally
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.closeLightbox();
        } else if (this.isOpen() && this.group) {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.navigateToPrevious();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.navigateToNext();
          }
        }
      });
    }

    openLightbox() {
      // Create overlay if it doesn't exist
      if (!this.overlay) {
        this.createOverlay();
      }

      this.overlay.classList.add('overlay-lightbox__overlay--open');
      document.body.style.overflow = 'hidden';

      // If this is part of a group, find all group items
      if (this.group) {
        this.findGroupItems();

        // Prefetch images for the group
        this.prefetchGroupImages();

        // Add single-item class if there's only one item in the group
        if (this.groupItems.length <= 1) {
          this.overlay.classList.add('overlay-lightbox__overlay--single-item');
        } else {
          this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        }
      } else {
        // No group, so hide navigation buttons
        this.overlay.classList.add('overlay-lightbox__overlay--single-item');
      }
    }

    createOverlay() {
      // Check if template exists
      if (!this.template) {
        console.error('OverlayLightbox: Template not found');
        return;
      }

      // Clone the template content
      this.overlay = this.template.content.cloneNode(true).querySelector('.overlay-lightbox__overlay');
      
      // Check if overlay was created successfully
      if (!this.overlay) {
        console.error('OverlayLightbox: Overlay element not found in template');
        return;
      }
      
      // Get references to buttons
      this.closeBtn = this.overlay.querySelector('.lightbox-close');
      this.prevBtn = this.overlay.querySelector('.overlay-lightbox__nav--prev');
      this.nextBtn = this.overlay.querySelector('.overlay-lightbox__nav--next');

      // Add event listeners
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeLightbox();
        });
      }

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToPrevious();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToNext();
        });
      }

      // Close lightbox when clicking outside content
      if (this.overlay) {
        this.overlay.addEventListener('click', (e) => {
          if (e.target === this.overlay) {
            this.closeLightbox();
          }
        });
      }

      // Append to body
      if (this.overlay) {
        document.body.appendChild(this.overlay);
      }
    }

    closeLightbox() {
      if (this.overlay) {
        this.overlay.classList.remove('overlay-lightbox__overlay--open');
        this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        
        // Remove overlay immediately
        if (this.overlay.parentNode) {
          this.overlay.parentNode.removeChild(this.overlay);
          this.overlay = null;
          this.closeBtn = null;
          this.prevBtn = null;
          this.nextBtn = null;
        }
      }
      
      document.body.style.overflow = '';
    }


    findGroupItems() {
      // Use the static registry to find group items
      this.groupItems = OverlayLightbox.registry.get(this.group) || [];
      this.currentIndex = this.groupItems.indexOf(this);
    }

    navigateToPrevious() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex - 1;
      if (targetIndex < 0) {
        // Loop to last item
        targetIndex = this.groupItems.length - 1;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    navigateToNext() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex + 1;
      if (targetIndex >= this.groupItems.length) {
        // Loop to first item
        targetIndex = 0;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    switchToLightbox(targetLightbox) {
      // Close current lightbox
      this.closeLightbox();
      
      // Open target lightbox immediately
      targetLightbox.openLightbox();
    }

    prefetchGroupImages() {
      // Only prefetch once per group
      if (this.group && !OverlayLightbox.prefetchedGroups.has(this.group)) {
        OverlayLightbox.prefetchedGroups.add(this.group);
        
        this.groupItems.forEach(lightbox => {
          // Find all images in this lightbox's content
          const images = lightbox.querySelectorAll('img');
          images.forEach(img => {
            // Prefetch the largest available image
            this.prefetchLargestImage(img);
          });
        });
      }
    }

    prefetchLargestImage(img) {
      // Try to get the largest image from srcset first
      if (img.srcset) {
        const srcsetUrls = img.srcset.split(',').map(src => src.trim().split(' ')[0]);
        // Find the largest size (highest number in the URL)
        let largestUrl = img.src;
        let largestSize = 0;
        
        srcsetUrls.forEach(url => {
          const size = this.extractImageSize(url);
          if (size > largestSize) {
            largestSize = size;
            largestUrl = url;
          }
        });
        
        this.prefetchImage(largestUrl);
      } else {
        // No srcset, try to get largest size from original URL
        const largestUrl = this.getLargestImageUrl(img.src);
        this.prefetchImage(largestUrl);
      }
    }

    extractImageSize(url) {
      try {
        const urlObj = new URL(url);
        
        // Check for width parameter
        if (urlObj.searchParams.has('width')) {
          return parseInt(urlObj.searchParams.get('width')) || 0;
        }
        
        // Check for underscore format (image_2400x.jpg)
        const pathParts = urlObj.pathname.split('_');
        if (pathParts.length > 1) {
          const sizeMatch = pathParts[pathParts.length - 1].match(/(\d+)x/);
          if (sizeMatch) {
            return parseInt(sizeMatch[1]) || 0;
          }
        }
      } catch (e) {
        // URL parsing failed
      }
      
      return 0;
    }

    getLargestImageUrl(originalUrl) {
      try {
        const url = new URL(originalUrl);
        
        // Handle Shopify image URLs - try to get 2400px version
        if (url.searchParams.has('width')) {
          url.searchParams.set('width', '2400');
          return url.toString();
        } else if (url.pathname.includes('_')) {
          // Handle Shopify's underscore format
          const pathParts = url.pathname.split('_');
          if (pathParts.length > 1) {
            const extension = pathParts[pathParts.length - 1].split('.')[1] || 'jpg';
            const newPath = pathParts.slice(0, -1).join('_') + '_2400x.' + extension;
            url.pathname = newPath;
            return url.toString();
          }
        }
      } catch (e) {
        // If URL parsing fails, return original
      }
      
      return originalUrl;
    }

    prefetchImage(url) {
      const prefetchImg = new Image();
      prefetchImg.src = url;
    }

    isOpen() {
      return this.overlay && this.overlay.classList.contains('overlay-lightbox__overlay--open');
    }

    // Clean up when element is removed
    disconnectedCallback() {
      if (this.group) {
        const groupItems = OverlayLightbox.registry.get(this.group);
        if (groupItems) {
          const index = groupItems.indexOf(this);
          if (index > -1) {
            groupItems.splice(index, 1);
          }
          // Remove empty groups
          if (groupItems.length === 0) {
            OverlayLightbox.registry.delete(this.group);
          }
        }
      }
    }
  }

  // Define the custom element
  customElements.define('overlay-lightbox', OverlayLightbox);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pagination"] && !Shopify.designMode) return;
  try {
    (function () {
    /*
      The page picker. Everything is listened for on the document, so a grid re-fetched by a filter change
      (theme.js replaces #CollectionAjaxContent) keeps a picker that works.

      Phones and tablets open the select's own picker; choosing a page fires its change and goes there. A desktop
      browser would open its own small grey list the width of the middle third, so where there is a mouse, and in
      desktop Chrome and Edge with any pointer (DevTools' device mode), a press or a key on the select opens the
      drawn list of page links instead. WebHID is only in desktop Chrome and Edge: see the sort's note in
      snippets/collection-grid.liquid, which draws its list by the same rule.
    */
    var MOUSE = window.matchMedia('(hover: hover) and (pointer: fine)');
    var DESKTOP_CHROME = 'hid' in navigator;
    var openNav = null;

    function drawn() {
      return MOUSE.matches || DESKTOP_CHROME;
    }

    function jumpOf(target) {
      return target.closest ? target.closest('[data-pagination-jump]') : null;
    }

    function inPanel(target) {
      return Boolean(target.closest && target.closest('[data-pagination-panel]'));
    }

    function linksOf(nav) {
      return Array.from(nav.querySelectorAll('[data-pagination-panel] a'));
    }

    function open(nav, focusList) {
      var panel = nav.querySelector('[data-pagination-panel]');
      if (!panel) return;
      panel.hidden = false;
      openNav = nav;
      var current = panel.querySelector('[aria-current]') || panel.querySelector('a');
      if (current) {
        current.scrollIntoView({ block: 'nearest' });
        if (focusList) current.focus();
      }
    }

    /* `byKey`: a key did this, not the mouse, so the focus handed back to the select shows its ring. */
    function close(refocus, byKey) {
      if (!openNav) return;
      var nav = openNav;
      openNav = null;
      nav.querySelector('[data-pagination-panel]').hidden = true;
      if (refocus) nav.querySelector('[data-pagination-jump]').focus({ focusVisible: Boolean(byKey) });
    }

    document.addEventListener('change', function (event) {
      var select = jumpOf(event.target);
      if (select && select.value) window.location.assign(select.value);
    });

    document.addEventListener('mousedown', function (event) {
      var select = jumpOf(event.target);
      if (!select || !drawn() || event.button !== 0) return;
      event.preventDefault();
      var nav = select.closest('.pagination');
      select.focus({ focusVisible: false });
      if (openNav === nav) close(false);
      else open(nav, false);
    });

    /* A press anywhere but the list or its select closes it. */
    document.addEventListener('pointerdown', function (event) {
      if (!openNav || jumpOf(event.target)) return;
      if (!inPanel(event.target)) close(false);
    });

    document.addEventListener('keydown', function (event) {
      var select = jumpOf(event.target);
      if (select && drawn()) {
        var nav = select.closest('.pagination');
        if (event.key === 'Escape' && openNav === nav) {
          event.preventDefault();
          event.stopPropagation();
          close(true, true);
        } else if (['Enter', ' ', 'ArrowDown', 'ArrowUp'].includes(event.key)) {
          event.preventDefault();
          open(nav, true);
        }
        return;
      }

      if (!openNav || !inPanel(event.target)) return;
      var links = linksOf(openNav);
      var index = links.indexOf(document.activeElement);
      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault();
          links[Math.min(links.length - 1, index + 1)].focus();
          break;
        case 'ArrowUp':
          event.preventDefault();
          links[Math.max(0, index - 1)].focus();
          break;
        case 'Home':
          event.preventDefault();
          links[0].focus();
          break;
        case 'End':
          event.preventDefault();
          links[links.length - 1].focus();
          break;
        case ' ':
          event.preventDefault();
          if (index > -1) links[index].click();
          break;
        /*
          Escape stops here: theme.js closes the search on any Escape that reaches the document, and that blurs
          whatever has focus, which would drop it off the select it goes back to.
        */
        case 'Escape':
          event.preventDefault();
          event.stopPropagation();
          close(true, true);
          break;
        case 'Tab':
          close(false);
          break;
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-complementary-products"] && !Shopify.designMode) return;
  try {
    (function () {
    var SLIDE_SELECTOR = '.pdp-complementary__slide';

    // How long a card's button says "Added" or "Try again" before it resets.
    var CARD_RESET_MS = 1200;

    // The widths a card's photo is offered at (snippets/product-slim-card.liquid).
    var IMAGE_WIDTHS = [220, 330, 440, 660];

    function optionData(option, key) {
      return option && option.dataset ? option.dataset[key] : null;
    }

    // Shopify's CDN sizes from the width param image_url writes, so one URL gives them all.
    function imageSrcset(url) {
      return IMAGE_WIDTHS.map(function (width) {
        return url.replace(/([?&]width=)\d+/, '$1' + width) + ' ' + width + 'w';
      }).join(', ');
    }

    // The endpoint answers with bare slides; take just those out of the response.
    function slidesMarkup(slides) {
      return Array.prototype.map
        .call(slides, function (slide) {
          return slide.outerHTML;
        })
        .join('');
    }

    class PdpComplementaryProducts extends HTMLElement {
      connectedCallback() {
        this.row = this.querySelector('[data-complementary-row]');
        if (!this.row) return;

        this.tab = this.closest('.collapsibles-wrapper');
        this.heading = this.tab && this.tab.querySelector('[data-complementary-heading]');
        this.arrows = this.tab && this.tab.querySelector('[data-carousel-arrows]');

        // Product-level, so it survives variant switches and is fetched at most once.
        this.fallbackHtml = null;
        this.fallbackPromise = null;

        /*
          Bumped per request, and checked again before anything is painted: clicking
          through swatches quickly leaves several fetches in flight, and without this
          a slow earlier one can land last and leave the wrong cards on screen.
        */
        this.requestToken = 0;

        this.abortController = new AbortController();
        var signal = this.abortController.signal;

        /*
          The cards' select and add button are handled here, not in
          product-slim-card.liquid. Shopify runs a snippet's script only on a page
          that rendered the snippet when the page was built (the page lists them in
          #snippets-script), and the "Consider These Pieces" cards only arrive later,
          by fetch: on those PDPs the card's own script never ran and its button did
          nothing. Delegated from this element, so it also covers the cards that
          replace these on every variant switch.
        */
        this.addEventListener('change', this.onCardChange.bind(this), { signal: signal });
        this.addEventListener('click', this.onCardClick.bind(this), { signal: signal });
        this.row.addEventListener('scroll', this.syncEnds.bind(this), { signal: signal, passive: true });
        if (this.arrows) this.arrows.addEventListener('click', this.onArrow.bind(this), { signal: signal });

        /*
          Scoped to this PDP's section rather than document, because Impulse fires
          the document-level `variant:change` without saying which product it came
          from — and a page can carry a featured-product alongside the main one.
          `variantChange` is dispatched straight onto the section container.
        */
        this.productSection = this.closest('[data-section-type="product"]');
        if (this.productSection) {
          this.productSection.addEventListener('variantChange', this.onVariantChange.bind(this), { signal: signal });
        }

        // The arrows show while the row runs past its box, which changes with the page's width.
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.syncArrows.bind(this));
          this.resizeObserver.observe(this.row);
        }

        if (this.slideCount()) {
          this.syncArrows();
        } else {
          this.showFallback(this.requestToken);
        }
      }

      disconnectedCallback() {
        if (this.abortController) this.abortController.abort();
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      slideCount() {
        return this.row.querySelectorAll(SLIDE_SELECTOR).length;
      }

      /*
        The arrows show once the row runs past its box, and the tab's title keeps
        clear of them while they do (--collapsible-aside-room, snippets/tab.liquid):
        their width and the margins the tab sets around them.
      */
      syncArrows() {
        if (!this.arrows) return;

        var overflow = this.row.scrollWidth - this.row.clientWidth > 1;
        this.arrows.hidden = !overflow;

        var aside = this.arrows.parentElement;
        if (overflow && this.tab && aside) {
          var style = getComputedStyle(aside);
          var room = aside.offsetWidth + parseFloat(style.marginInlineStart) + parseFloat(style.marginInlineEnd);
          this.tab.style.setProperty('--collapsible-aside-room', Math.ceil(room) + 'px');
        } else if (this.tab) {
          this.tab.style.removeProperty('--collapsible-aside-room');
        }

        this.syncEnds();
      }

      // Each arrow greys at its end of the row.
      syncEnds() {
        if (!this.arrows || this.arrows.hidden) return;

        var row = this.row;
        var buttons = this.arrows.querySelectorAll('[data-step]');
        buttons[0].disabled = row.scrollLeft <= 1;
        buttons[1].disabled = row.scrollLeft >= row.scrollWidth - row.clientWidth - 1;
      }

      // A card and a gap at a time.
      onArrow(event) {
        var arrow = event.target.closest('[data-step]');
        if (!arrow || arrow.disabled) return;

        var card = this.row.querySelector(SLIDE_SELECTOR);
        var gap = parseFloat(getComputedStyle(this.row).columnGap) || 0;
        var step = (card ? card.getBoundingClientRect().width + gap : this.row.clientWidth) * Number(arrow.dataset.step);
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.row.scrollBy({ left: step, behavior: reduced ? 'auto' : 'smooth' });
      }

      setHeading(text) {
        if (this.heading && text) this.heading.textContent = text;
      }

      render(html, headingText) {
        this.row.innerHTML = html;
        this.row.scrollLeft = 0;
        this.setHeading(headingText);
        this.syncArrows();
      }

      onVariantChange(event) {
        var variant = event.detail && event.detail.variant;
        if (!variant) return;
        this.showVariant(variant.id);
      }

      showVariant(variantId) {
        var token = ++this.requestToken;
        var url = this.dataset.variantUrl + '&variant=' + encodeURIComponent(variantId);

        return fetch(url, { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) throw new Error('Complementary fetch failed: ' + response.status);
            return response.text();
          })
          .then(
            function (html) {
              if (token !== this.requestToken) return;

              var doc = new DOMParser().parseFromString(html, 'text/html');
              var slides = doc.querySelectorAll(SLIDE_SELECTOR);

              if (slides.length) {
                this.render(slidesMarkup(slides), this.dataset.headingComplete);
              } else {
                this.showFallback(token);
              }
            }.bind(this)
          )
          .catch(
            function (error) {
              if (token !== this.requestToken) return;
              console.error('[pdp-complementary-products]', error);
              this.showFallback(token);
            }.bind(this)
          );
      }

      fetchFallback() {
        if (this.fallbackHtml !== null) return Promise.resolve(this.fallbackHtml);
        if (this.fallbackPromise) return this.fallbackPromise;

        this.fallbackPromise = fetch(this.dataset.recommendationsUrl, { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) throw new Error('Recommendations fetch failed: ' + response.status);
            return response.text();
          })
          .then(
            function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              this.fallbackHtml = slidesMarkup(doc.querySelectorAll(SLIDE_SELECTOR));
              return this.fallbackHtml;
            }.bind(this)
          )
          .catch(
            function (error) {
              console.error('[pdp-complementary-products]', error);
              this.fallbackHtml = '';
              return this.fallbackHtml;
            }.bind(this)
          );

        return this.fallbackPromise;
      }

      showFallback(token) {
        return this.fetchFallback().then(
          function (html) {
            if (token !== this.requestToken) return;
            this.render(html, this.dataset.headingConsider);
          }.bind(this)
        );
      }

      // A card's select: keep its choice, price, photo, links and add button on the variant picked.
      onCardChange(event) {
        var select = event.target.closest('.slim-card__select');
        var card = select && select.closest('.slim-card');
        if (!card) return;

        var option = select.options[select.selectedIndex];
        var choice = card.querySelector('[data-choice]');
        var button = card.querySelector('.slim-card__button');
        var priceWrap = card.querySelector('[data-price]');
        var image = card.querySelector('.slim-card__image');

        if (choice) choice.textContent = option.textContent.trim();

        // A sold-out variant's option is disabled, so whatever was picked can be added.
        if (button) {
          button.dataset.variantId = option.value;
          button.disabled = false;
          if (button.dataset.addText) button.textContent = button.dataset.addText;
        }

        if (priceWrap) {
          var current = priceWrap.querySelector('.slim-card__price--current');
          var compare = priceWrap.querySelector('.slim-card__price--compare');
          var savings = priceWrap.querySelector('[data-save-price]');
          var newPrice = optionData(option, 'price');
          var newCompare = optionData(option, 'comparePrice');
          var newSaveText = optionData(option, 'saveText');

          if (current && newPrice) current.textContent = newPrice;

          if (compare) {
            compare.textContent = newCompare || '';
            compare.classList.toggle('hide', !newCompare);
          }

          if (savings) {
            var showSavings = Boolean(newCompare && newSaveText);
            savings.textContent = showSavings ? newSaveText : '';
            savings.classList.toggle('hide', !showSavings);
          }
        }

        // Only the recommendations fallback emits per-option images (see
        // pdp-complementary-slides), so hand-picked cards keep their picture.
        var newImage = optionData(option, 'image');
        if (image && newImage) {
          image.src = newImage;
          image.srcset = imageSrcset(newImage);
        }

        card.querySelectorAll('a[href]').forEach(function (link) {
          try {
            var url = new URL(link.href, window.location.origin);
            url.searchParams.set('variant', option.value);
            link.href = url.pathname + url.search;
          } catch (e) {
            /* leave the link as it is */
          }
        });
      }

      // A card's add button: add its variant, then tell the cart drawer.
      onCardClick(event) {
        var button = event.target.closest('[data-slim-card-add]');
        if (!button) return;

        event.preventDefault();

        var variantId = button.dataset.variantId;
        if (!variantId || button.disabled) return;

        var addUrl = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
        var originalText = button.textContent;

        button.disabled = true;
        button.textContent = button.dataset.addingText || originalText;

        fetch(addUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Add to cart failed: ' + response.status);
            return response.json();
          })
          .then(function (item) {
            button.textContent = button.dataset.addedText || originalText;

            /*
              Impulse's cart drawer listens for this on document, rebuilds itself and
              opens (theme.js CartDrawer.init). Dispatched on document rather than
              bubbled from the card, because the gift-card RecipientForm listens for
              the same event and reads event.target.querySelector('[name="id"]').value;
              a card has no such input, so bubbling from here would throw in that listener.
            */
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: { product: item, addToCartBtn: button }
            }));
          })
          .catch(function (error) {
            console.error('[pdp-complementary-products] Add to cart failed:', error);
            button.textContent = button.dataset.errorText || originalText;
          })
          .finally(function () {
            setTimeout(function () {
              button.textContent = originalText;
              button.disabled = false;
            }, CARD_RESET_MS);
          });
      }
    }

    if (!customElements.get('pdp-complementary-products')) {
      customElements.define('pdp-complementary-products', PdpComplementaryProducts);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-info-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var DRAWER_ID = 'pdp-info-drawer';

    function getDrawer() {
      return document.getElementById(DRAWER_ID);
    }

    function showPanel(drawer, panel) {
      var matched = false;
      drawer.querySelectorAll('[data-info-drawer-panel]').forEach(function (el) {
        var isMatch = el.dataset.infoDrawerPanel === panel;
        el.hidden = !isMatch;
        if (isMatch) matched = true;
      });
      if (!matched) return false;

      // data-title-size-guide / -delivery / -returns, set from locale keys.
      var title = drawer.querySelector('[data-info-drawer-title]');
      var label = title && title.getAttribute('data-title-' + panel);
      if (label) title.textContent = label;

      // A panel opens at its top, whatever the last one was scrolled to.
      var inner = drawer.querySelector('.overlay-drawer__inner');
      if (inner) inner.scrollTop = 0;

      if (panel === 'size-guide') markSelectedSize();

      return true;
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-info-drawer-open]');
      if (!trigger) return;

      var drawer = getDrawer();
      if (!drawer || typeof drawer.open !== 'function') return;

      e.preventDefault();
      if (!showPanel(drawer, trigger.dataset.infoDrawerOpen)) return;
      // Opening again while open would re-record the element to give focus back to on close.
      if (drawer.getAttribute('open') !== 'true') drawer.open();
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('#' + DRAWER_ID + ' [data-info-drawer-close]')) return;
      var drawer = getDrawer();
      if (drawer && typeof drawer.close === 'function') drawer.close();
    });

    /* The drawer is a dialog while it is open, named by its title. */
    function initDialog() {
      var drawer = getDrawer();
      if (!drawer || drawer.dataset.infoDrawerReady) return;
      drawer.dataset.infoDrawerReady = 'true';

      var sync = function () {
        if (drawer.getAttribute('open') === 'true') {
          drawer.setAttribute('role', 'dialog');
          drawer.setAttribute('aria-modal', 'true');
          drawer.setAttribute('aria-labelledby', 'pdp-info-drawer-title');
        } else {
          drawer.removeAttribute('role');
          drawer.removeAttribute('aria-modal');
          drawer.removeAttribute('aria-labelledby');
        }
      };
      new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['open'] });
      sync();

      /*
        Escape, while open, is the drawer's alone. The header search (theme.js) closes on
        every Escape, open or not, and blurs whatever has focus as it does — which took
        focus straight back off the button the drawer had just returned it to.
      */
      window.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' || drawer.getAttribute('open') !== 'true') return;
        e.stopImmediatePropagation();
        drawer.close();
      }, true);
    }

    /*
      Chart state on arrival. Each unit group shows its first panel (INCH) and hides
      the rest — the authored HTML leaves them all visible, so without this the CM
      table sat under the INCH one. Charts cut by body length then show the table
      for the Length the shopper has picked, and follow it when they change it.
    */
    var LENGTHS = ['short', 'regular', 'long'];
    var LENGTH_INPUTS = 'input[name="Length"], select[name="Length"], input[name="length"], select[name="length"]';
    var SIZE_INPUTS = 'input[name="Size" i], select[name="Size" i]';

    function selectedLength() {
      var field = document.querySelector('input[name="Length"]:checked, input[name="length"]:checked, select[name="Length"], select[name="length"]');
      return field && field.value ? field.value.toLowerCase() : 'regular';
    }

    // The length or unit showing, for screen readers as well as by its rule.
    function markCurrent(tab, on) {
      tab.classList.toggle('active', on);
      if (on) {
        tab.setAttribute('aria-current', 'true');
      } else {
        tab.removeAttribute('aria-current');
      }
    }

    function showLength(guide, length) {
      guide.querySelectorAll('.cw-length-nav a').forEach(function (tab) {
        markCurrent(tab, tab.dataset.length === length);
      });
      guide.querySelectorAll('.cw-size-guide-table').forEach(function (table) {
        table.style.display = table.classList.contains('length-' + length) ? 'table' : 'none';
      });
    }

    /*
      The buy box says XXL where the charts say 2XL, and 4-7 where the sock chart says
      4–7; anything else is compared as written, so a size the chart doesn't list
      simply marks nothing.
    */
    function sizeKey(value) {
      var key = String(value || '').replace(/\s+/g, '').replace(/–/g, '-').toUpperCase();
      var aliases = { XXL: '2XL', XXXL: '3XL', XXXXL: '4XL' };
      return aliases[key] || key;
    }

    function selectedSize() {
      var field = document.querySelector('input[name="Size" i]:checked, select[name="Size" i]');
      return field ? sizeKey(field.value) : '';
    }

    /*
      Marks the size picked in the buy box in every chart: a column where the sizes
      run across (the default charts), a row where they run down (the authored ones).
      Socks are sold by their UK size, which the sock chart gives in its first row
      under S / M / L, so a size found among the figures marks its column too.
    */
    function markSelectedSize() {
      var drawer = getDrawer();
      var panel = drawer && drawer.querySelector('[data-info-drawer-panel="size-guide"]');
      if (!panel) return;

      var size = selectedSize();
      var spoken = panel.dataset.strSelectedSize || '';

      panel.querySelectorAll('.cw-size-guide-table').forEach(function (table) {
        table.querySelectorAll('.is-selected-size').forEach(function (el) {
          el.classList.remove('is-selected-size');
        });
        table.querySelectorAll('[data-selected-size-label]').forEach(function (el) {
          el.remove();
        });
        if (!size) return;

        var marker = document.createElement('span');
        marker.className = 'info-drawer__sr';
        marker.dataset.selectedSizeLabel = '';
        marker.textContent = ', ' + spoken;

        var head = table.tHead && table.tHead.rows[0];
        var heads = head ? Array.prototype.slice.call(head.cells) : [];
        var column = -1;
        heads.forEach(function (cell, index) {
          if (index > 0 && column === -1 && sizeKey(cell.textContent) === size) column = index;
        });

        var rows = [];
        Array.prototype.forEach.call(table.tBodies, function (body) {
          rows = rows.concat(Array.prototype.slice.call(body.rows));
        });
        var named = rows.some(function (row) {
          return row.cells[0] && sizeKey(row.cells[0].textContent) === size;
        });
        if (column === -1 && !named) {
          rows.some(function (row) {
            if (row.cells.length !== heads.length) return false;
            for (var i = 1; i < row.cells.length; i++) {
              if (sizeKey(row.cells[i].textContent) === size) {
                column = i;
                return true;
              }
            }
            return false;
          });
        }

        Array.prototype.forEach.call(table.tBodies, function (body) {
          Array.prototype.forEach.call(body.rows, function (row) {
            if (column > 0) {
              if (row.cells.length === heads.length) row.cells[column].classList.add('is-selected-size');
            } else if (row.cells[0] && sizeKey(row.cells[0].textContent) === size) {
              row.classList.add('is-selected-size');
              row.cells[0].append(marker.cloneNode(true));
            }
          });
        });

        if (column > 0) {
          heads[column].classList.add('is-selected-size');
          heads[column].append(marker);
        }
      });
    }

    /* The wide default chart says which way it continues (see the stylesheet). */
    function watchScroller(scroller) {
      var update = function () {
        var room = scroller.scrollWidth - scroller.clientWidth;
        scroller.toggleAttribute('data-scrollable', room > 1);
        scroller.toggleAttribute('data-at-start', scroller.scrollLeft <= 1);
        scroller.toggleAttribute('data-at-end', scroller.scrollLeft >= room - 1);
      };
      scroller.addEventListener('scroll', update, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(scroller);
      update();
    }

    function initSizeGuides() {
      var drawer = getDrawer();
      if (!drawer) return;

      drawer.querySelectorAll('.cw-tabs').forEach(function (tabs) {
        tabs.querySelectorAll('.cw-tabs__item').forEach(function (item, index) {
          item.style.display = index === 0 ? 'block' : 'none';
        });
      });
      drawer.querySelectorAll('.cw-tabs__nav a').forEach(function (tab) {
        markCurrent(tab, tab.classList.contains('active'));
      });

      drawer.querySelectorAll('.cw-size-guide-table-wrapper').forEach(watchScroller);
      markSelectedSize();

      var length = selectedLength();
      if (LENGTHS.indexOf(length) === -1) return;
      drawer.querySelectorAll('.cw-size-guide__multi-tab').forEach(function (guide) {
        showLength(guide, length);
      });
    }

    function init() {
      initDialog();
      initSizeGuides();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('change', function (e) {
      if (e.target.matches(SIZE_INPUTS)) markSelectedSize();
      if (!e.target.matches(LENGTH_INPUTS)) return;
      var length = selectedLength();
      if (LENGTHS.indexOf(length) === -1) return;
      document.querySelectorAll('#' + DRAWER_ID + ' .cw-size-guide__multi-tab').forEach(function (guide) {
        showLength(guide, length);
      });
    });

    document.addEventListener('click', function (e) {
      var tab = e.target.closest('#' + DRAWER_ID + ' .cw-length-nav a');
      if (!tab) return;
      var guide = tab.closest('.cw-size-guide__multi-tab');
      if (!guide) return;
      e.preventDefault();
      showLength(guide, tab.dataset.length);
    });

    /*
      INCH/CM switching. The markup comes from two places — the default tables and
      the merchant-authored html_for_table metaobject field — and both use the same
      .cw-tabs markup, so one delegated handler covers both. Scoped to the nearest
      .cw-tabs so a panel with several tables switches them independently.
    */
    document.addEventListener('click', function (e) {
      var tab = e.target.closest('#' + DRAWER_ID + ' .cw-tabs__nav a');
      if (!tab) return;

      var tabs = tab.closest('.cw-tabs');
      var target = tabs && tabs.querySelector(tab.getAttribute('href'));
      if (!target) return;

      e.preventDefault();
      tabs.querySelectorAll('.cw-tabs__nav a').forEach(function (t) {
        markCurrent(t, t === tab);
      });
      tabs.querySelectorAll('.cw-tabs__item').forEach(function (item) {
        item.style.display = 'none';
      });
      target.style.display = 'block';
    });

    // "How to measure?" links inside the authored size-chart HTML.
    document.addEventListener('click', function (e) {
      var link = e.target.closest('#' + DRAWER_ID + ' a[href="#how-to-measure"]');
      if (!link) return;
      e.preventDefault();
      var target = document.getElementById('how-to-measure');
      var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (target) target.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-jm-video"] && !Shopify.designMode) return;
  try {
    class JmVideo extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.media = this.querySelector('.jm-video__media');
      if (!this.media) return;

      /* The old theme's handler was `e.play()` on click and nothing else — no
         pause, no toggle. Matched exactly rather than improved, because a
         shopper who knows the live site should not find this behaving
         differently. */
      this.media.addEventListener('click', () => this.media.play());

      this.media.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        this.media.play();
      });

      this.bound = true;
    }
  }

  if (!customElements.get('jm-video')) {
    customElements.define('jm-video', JmVideo);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-product-summary"] && !Shopify.designMode) return;
  try {
    (function () {
    var REVEAL_MS = 400;

    // The clamp is CSS, but CSS can't tell us whether it clipped anything —
    // measure, and only offer Read more when it actually did.
    function syncOverflow(wrapper) {
      if (wrapper.classList.contains('is-expanded')) return;
      var content = wrapper.querySelector('[data-product-summary-content]');
      if (!content) return;
      wrapper.classList.toggle('has-overflow', content.scrollHeight > content.clientHeight + 1);
    }

    function syncAll() {
      document.querySelectorAll('[data-product-summary]').forEach(syncOverflow);
    }

    function expand(wrapper) {
      var content = wrapper.querySelector('[data-product-summary-content]');
      var collapsedHeight = content ? content.offsetHeight : 0;

      wrapper.classList.add('is-expanded');

      // Measured while the content sits at its natural full height, before the
      // reveal animation pins it back down to the teaser height.
      var tab = wrapper.closest('.collapsible-content');
      var inner = tab ? tab.querySelector('.collapsible-content__inner') : null;
      var tabHeight = inner ? inner.offsetHeight : 0;

      if (content) {
        var fullHeight = content.offsetHeight;
        if (fullHeight > collapsedHeight) {
          content.style.height = collapsedHeight + 'px';
          content.classList.add('is-animating');
          // Force a reflow so the browser has a start value to animate from.
          void content.offsetHeight;
          content.style.height = fullHeight + 'px';
          setTimeout(function () {
            content.classList.remove('is-animating');
            content.style.height = '';
          }, REVEAL_MS);
        }
      }

      // Impulse pins an opened collapsible to a pixel height, so re-sync it or the
      // un-clamped text is clipped. A force-opened tab is height:auto and grows on
      // its own — leave that alone.
      if (tab && inner && tab.classList.contains('is-open') && tab.style.height !== 'auto') {
        tab.style.height = tabHeight + 'px';
      }
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-product-summary-expand]');
      if (btn) {
        var wrapper = btn.closest('[data-product-summary]');
        if (wrapper) expand(wrapper);
        return;
      }

      // A click on the teaser itself opens it too, unless it lands on a link in the
      // description or ends a text selection.
      var content = e.target.closest('[data-product-summary-content]');
      if (!content || e.target.closest('a')) return;
      var owner = content.closest('[data-product-summary]');
      if (!owner || owner.classList.contains('is-expanded') || !owner.classList.contains('has-overflow')) return;
      var selection = window.getSelection && window.getSelection();
      if (selection && String(selection).length) return;
      expand(owner);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncAll);
    } else {
      syncAll();
    }
    // Web fonts land after DOMContentLoaded and change where the clamp falls.
    window.addEventListener('load', syncAll);
    window.addEventListener('resize', syncAll);
    document.addEventListener('shopify:section:load', syncAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-size-chart-default"] && !Shopify.designMode) return;
  try {
    /*
    The women's chart tabs, as WAI-ARIA tabs: a click (or Enter) shows a chart; the
    arrow keys, Home and End move along the tabs and show each as they go.
  */
  (function () {
    function select(tab, focus) {
      var list = tab.closest('[role="tablist"]');
      if (!list) return;
      list.querySelectorAll('[role="tab"]').forEach(function (other) {
        var selected = other === tab;
        other.setAttribute('aria-selected', selected ? 'true' : 'false');
        other.tabIndex = selected ? 0 : -1;
        var panel = document.getElementById(other.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });
      if (focus) tab.focus();
    }

    document.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-size-chart-tabs] [role="tab"]');
      if (tab) select(tab, false);
    });

    document.addEventListener('keydown', function (e) {
      var tab = e.target.closest && e.target.closest('[data-size-chart-tabs] [role="tab"]');
      if (!tab) return;
      var tabs = Array.prototype.slice.call(tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]'));
      var index = tabs.indexOf(tab);
      var target = { ArrowRight: index + 1, ArrowLeft: index - 1, Home: 0, End: tabs.length - 1 }[e.key];
      if (target === undefined) return;
      e.preventDefault();
      select(tabs[(target + tabs.length) % tabs.length], true);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-size-guide-trigger"] && !Shopify.designMode) return;
  try {
    (function () {
    // Easysize injects #easysize_button asynchronously from its app block, after
    // three round trips to its API (about 3-4s on a fast connection). Reveal the
    // styled proxy once it lands. There is no time limit, as on staging, so a slow
    // phone connection still gets the button.
    function initSizeQuiz() {
      var proxy = document.querySelector('[data-size-quiz]');
      if (!proxy || proxy.dataset.sizeQuizInit === '1') return;
      proxy.dataset.sizeQuizInit = '1';

      proxy.addEventListener('click', function () {
        var easysize = document.getElementById('easysize_button');
        if (easysize) easysize.click();
      });

      function reveal() {
        if (!document.getElementById('easysize_button')) return false;
        proxy.hidden = false;
        return true;
      }

      if (reveal()) return;

      var observer = new MutationObserver(function () {
        if (reveal()) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSizeQuiz);
    } else {
      initSizeQuiz();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-sticky-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('pdp-sticky-bar')) return;

    // Narrower than this the buy button pins itself instead (product-form).
    var WIDE = '(min-width: 769px)';
    // The photo's width in the bar's markup (image_url above), for a variant's own.
    var IMAGE_WIDTH = '160';
    // The least room kept above and below the options when the link brings them back.
    var OPTIONS_MARGIN = 24;

    class PdpStickyBar extends HTMLElement {
      connectedCallback() {
        var form = document.getElementById(this.dataset.formId);
        this.addButton = form && form.querySelector('[data-add-to-cart]');
        if (!this.addButton) return;

        this.section = document.getElementById(this.dataset.sectionId);
        this.row = this.addButton.closest('.product-form__buy-row') || this.addButton;
        this.priceLine = this.section && this.section.querySelector('.product-block--price .product__price-line');
        this.button = this.querySelector('[data-sticky-button]');
        this.price = this.querySelector('[data-sticky-price]');
        this.compare = this.querySelector('[data-sticky-compare]');
        this.options = this.querySelector('[data-sticky-options]');
        this.optionsLink = this.querySelector('[data-sticky-options-link]');
        this.image = this.querySelector('.pdp-sticky-bar__image');

        this.passedRow = false;
        this.atFooter = false;
        this.wide = window.matchMedia(WIDE);

        this.onPress = this.press.bind(this);
        this.onOptions = this.goToOptions.bind(this);
        this.onVariant = this.showVariant.bind(this);
        this.onWide = this.update.bind(this);
        this.button.addEventListener('click', this.onPress);
        if (this.optionsLink) this.optionsLink.addEventListener('click', this.onOptions);
        this.wide.addEventListener('change', this.onWide);
        if (this.section) this.section.addEventListener('variantChange', this.onVariant);

        // The two points it shows between: the buy row gone off the top of the
        // screen, and the footer coming on at the bottom. The row is watched
        // against an area that runs from the top of the screen to far below the
        // page, so it leaves that area only by going off the top, and a jump
        // straight past it (End, a scrollbar drag) still counts. Watched against
        // the screen alone, a row that never touched it on the way would be missed.
        this.rowWatch = new IntersectionObserver(function (entries) {
          this.passedRow = !entries[entries.length - 1].isIntersecting;
          this.update();
        }.bind(this), { rootMargin: '0px 0px 100000px 0px' });
        this.rowWatch.observe(this.row);

        var footer = document.querySelector('.site-footer');
        if (footer) {
          this.footerWatch = new IntersectionObserver(function (entries) {
            this.atFooter = entries[entries.length - 1].isIntersecting;
            this.update();
          }.bind(this));
          this.footerWatch.observe(footer);
        }

        // Whatever the buy box shows: the button's label, its sold-out and loading
        // states, Appikon's button arriving in or leaving the slot, and the price.
        this.copier = new MutationObserver(this.copy.bind(this));
        var everything = { attributes: true, childList: true, characterData: true, subtree: true };
        this.copier.observe(this.row, everything);
        if (this.priceLine) this.copier.observe(this.priceLine, everything);

        this.copy();
        this.update();
      }

      disconnectedCallback() {
        if (!this.copier) return;
        this.copier.disconnect();
        this.rowWatch.disconnect();
        if (this.footerWatch) this.footerWatch.disconnect();
        this.button.removeEventListener('click', this.onPress);
        if (this.optionsLink) this.optionsLink.removeEventListener('click', this.onOptions);
        this.wide.removeEventListener('change', this.onWide);
        if (this.section) this.section.removeEventListener('variantChange', this.onVariant);
      }

      update() {
        var show = this.wide.matches && this.passedRow && !this.atFooter;
        this.classList.toggle('is-visible', show);
        this.inert = !show;
      }

      // The control holding the buy slot: Add to cart, or, while the variant is
      // sold out, Appikon's back-in-stock button (it is hidden the rest of the time).
      target() {
        if (!this.addButton.disabled) return this.addButton;
        var notify = document.getElementById('SI_trigger');
        return notify && notify.getClientRects().length ? notify : null;
      }

      press() {
        var target = this.target();
        if (target) target.click();
      }

      // The options link: brings the price, the options and the buy row on screen
      // together, centred when they fit (top first when they don't), so the shopper
      // can change a choice and add from there. The bar leaves by itself as the buy
      // row arrives. Focus moves to the first option's current choice, so the
      // keyboard carries on from the options and not from the hidden bar.
      goToOptions(event) {
        var picker = this.section && this.section.querySelector('.product-single__meta .variant-wrapper');
        if (!picker) return;
        event.preventDefault();

        var price = this.section.querySelector('.product-block--price');
        var pickerBox = picker.getBoundingClientRect();
        var top = Math.min(pickerBox.top, price ? price.getBoundingClientRect().top : Infinity);
        var bottom = Math.max(pickerBox.bottom, this.row.getBoundingClientRect().bottom);
        var room = window.innerHeight - 2 * OPTIONS_MARGIN;
        var offset = bottom - top <= room ? (top + bottom - window.innerHeight) / 2 : top - OPTIONS_MARGIN;
        var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: window.scrollY + offset, behavior: still ? 'auto' : 'smooth' });

        var choice = picker.querySelector('input:checked, select');
        if (choice) choice.focus({ preventScroll: true });
      }

      copy() {
        var target = this.target();
        var label = target && target !== this.addButton
          ? target
          : this.addButton.querySelector('[data-add-to-cart-text]') || this.addButton;
        var text = label.textContent.trim();
        if (this.button.textContent !== text) this.button.textContent = text;
        this.button.disabled = !target;
        this.button.classList.toggle('btn--loading', this.addButton.classList.contains('btn--loading'));

        if (!this.priceLine) return;
        var price = this.priceLine.querySelector('[data-product-price]');
        var compare = this.priceLine.querySelector('[data-compare-price]');
        var compareWrap = this.priceLine.querySelector('[data-product-price-wrap]');
        var compareText = compare ? compare.textContent.trim() : '';
        var onSale = compareText !== '' && compareWrap && !compareWrap.classList.contains('hide');

        if (price) this.price.textContent = price.textContent.trim();
        this.compare.textContent = onSale ? compareText : '';
        this.compare.hidden = !onSale;
      }

      showVariant(event) {
        var detail = event.detail || {};
        var variant = detail.variant;

        if (this.options) {
          if (variant) {
            this.options.textContent = variant.title;
          } else if (detail.currentlySelectedValues) {
            this.options.textContent = detail.currentlySelectedValues.map(function (option) {
              return option.value;
            }).join(' / ');
          }
        }

        var src = variant && variant.featured_image && variant.featured_image.src;
        if (this.image && src) {
          var url = new URL(src, location.href);
          url.searchParams.set('width', IMAGE_WIDTH);
          if (this.image.src !== url.href) this.image.src = url.href;
        }
      }
    }

    customElements.define('pdp-sticky-bar', PdpStickyBar);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-variant-tooltip"] && !Shopify.designMode) return;
  try {
    (function () {
    var DESKTOP_MIN_WIDTH = 769;
    var DISABLED_SWATCH_SELECTOR = '.variant__button-label.disabled';

    function tooltip() {
      return document.querySelector('[data-variant-tooltip]');
    }

    document.addEventListener('mouseover', function (event) {
      if (window.innerWidth < DESKTOP_MIN_WIDTH) return;

      var target = event.target.closest(DISABLED_SWATCH_SELECTOR);
      if (!target) return;

      var element = tooltip();
      if (!element) return;

      element.textContent = element.dataset.label || '';

      var bounds = target.getBoundingClientRect();
      element.style.left = bounds.left + bounds.width / 2 + 'px';
      element.style.top = bounds.top + 'px';
      element.classList.add('variant-tooltip--visible');
    });

    document.addEventListener('mouseout', function (event) {
      if (!event.target.closest(DISABLED_SWATCH_SELECTOR)) return;

      var element = tooltip();
      if (element) element.classList.remove('variant-tooltip--visible');
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    (function () {
    var STICKY_MAX_WIDTH = 768;
    // How far past the button you must scroll before it re-appears pinned.
    var STICKY_SCROLL_OFFSET = 800;
    var STICKY_SELECTOR = '.main-add-to-cart, #SI_trigger';
    // The three methods PJ surface next to the button, in the footer's markup order.
    var ICON_IDS = ['pi-paypal', 'pi-american_express', 'pi-visa'];

    function bindInstallmentsToggle() {
      var toggle = document.querySelector('[data-installments-toggle]');
      var terms = document.querySelector('[data-installments-terms]');
      if (!toggle || !terms || toggle.dataset.bound === 'true') return;

      toggle.dataset.bound = 'true';
      toggle.addEventListener('click', function () {
        styleShopPayTerms();
        var collapsed = terms.classList.toggle('pdp-installments__terms--collapsed');
        toggle.setAttribute('aria-expanded', String(!collapsed));
      });
    }

    // Shop Pay's banner (the form's payment_terms filter) draws inside its own shadow
    // root, in Shop's face (GT Standard), its amount bold, the Shop mark in
    // purple and a 20px help icon; no page rule reaches in. The root is open,
    // so the banner is handed a sheet of the theme's after Shop's own: the
    // page's face, the amount at the sentence's weight, the mark in the text
    // colour (Shop's black mark), the icon at the type's size. It stays through
    // a size change (the banner redraws its words, not its sheets). Should Shop
    // rename these parts, the banner simply looks as Shop draws it.
    var SHOP_PAY_TERMS_CSS =
      '#shopify-installments { font-family: inherit; }' +
      '#shopify-installments .font-bold { font-weight: inherit; }' +
      '#shopify-installments .text-purple-primary { color: currentColor; }' +
      '#shopify-installments-content svg { width: auto; height: 1.05em; }' +
      '#shopify-installments-cta svg { width: 1.15em; height: 1.15em; }';
    var shopPayTermsSheet = null;

    function styleShopPayTerms() {
      if (typeof CSSStyleSheet === 'undefined' || !('replaceSync' in CSSStyleSheet.prototype)) return;
      document.querySelectorAll('shopify-payment-terms').forEach(function (host) {
        var root = host.shadowRoot;
        if (!root || !('adoptedStyleSheets' in root)) return;
        if (!shopPayTermsSheet) {
          shopPayTermsSheet = new CSSStyleSheet();
          shopPayTermsSheet.replaceSync(SHOP_PAY_TERMS_CSS);
        }
        if (Array.from(root.adoptedStyleSheets).indexOf(shopPayTermsSheet) === -1) {
          root.adoptedStyleSheets = Array.from(root.adoptedStyleSheets).concat(shopPayTermsSheet);
        }
      });
    }

    // The payment icons are rendered once, in the footer. Clone rather than
    // re-render so the two lists can never drift apart.
    function cloneIcons() {
      var source = document.querySelector('.payment-icons');
      var target = document.querySelector('[data-installments-icons]');
      if (!source || !target) return false;

      var cloned = 0;
      ICON_IDS.forEach(function (id) {
        if (target.querySelector('[aria-labelledby="' + id + '"]')) {
          cloned++;
          return;
        }
        var icon = source.querySelector('[aria-labelledby="' + id + '"]');
        var item = icon && icon.closest('li');
        if (!item) return;
        target.appendChild(item.cloneNode(true));
        cloned++;
      });

      return cloned > 0;
    }

    function updateSticky() {
      var buttons = document.querySelectorAll(STICKY_SELECTOR);
      if (!buttons.length) return;

      var wide = window.innerWidth > STICKY_MAX_WIDTH;
      buttons.forEach(function (button) {
        var pinned = !wide && window.scrollY > button.offsetTop + STICKY_SCROLL_OFFSET;
        if (pinned && !button.classList.contains('is-sticky')) holdPlace(button);
        button.classList.toggle('is-sticky', pinned);
      });
    }

    // The spacer takes the height the button has in the flow, read the moment
    // before it pins (pinned, its border grows). A hidden button has no box.
    function holdPlace(button) {
      var spacer = button.parentElement && button.parentElement.querySelector('.main-add-to-cart__spacer');
      if (!spacer || !button.getClientRects().length) return;
      spacer.style.setProperty('--_pinned-height', button.getBoundingClientRect().height + 'px');
    }

    function init() {
      bindInstallmentsToggle();
      cloneIcons();
      updateSticky();
    }

    init();

    if (window.customElements) {
      customElements.whenDefined('shopify-payment-terms').then(styleShopPayTerms);
    }

    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
    document.addEventListener('shopify:section:load', init);

    // Two things arrive after us: the footer may not be parsed when we run, and
    // Appikon injects the back-in-stock button. Watch until each has turned up
    // once, then stop.
    var pendingIcons = true;
    var pendingNotify = true;
    var observer = new MutationObserver(function () {
      bindInstallmentsToggle();
      if (pendingIcons && cloneIcons()) pendingIcons = false;
      if (pendingNotify && document.getElementById('SI_trigger')) {
        pendingNotify = false;
        updateSticky();
      }
      if (!pendingIcons && !pendingNotify) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery-video"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('product-gallery-video')) return;

    class ProductGalleryVideo extends HTMLElement {
      connectedCallback() {
        if (!this._wired) {
          this._wired = true;
          this.wire();
        }

        // Flickity moves every cell into the .flickity-slider it creates, which
        // disconnects this element and takes the slide observer with it (see
        // disconnectedCallback). So re-resolve the slide and re-observe on every
        // connect, not just the first: otherwise nothing is left watching
        // `is-selected` and the video never plays when its slide is chosen.
        this.slide = this.closest('.product-main-slide');
        this.observeSlide();

        if (this.isSlideActive()) {
          this.onSlideActive();
        }
      }

      wire() {
        var self = this;
        this.video = this.querySelector('.product-gallery-video__player--inline'); // hosted only
        this.poster = this.querySelector('.product-gallery-video__poster');          // external only
        this.resume = this.querySelector('.product-gallery-video__resume');          // hosted only
        this.stage = this.querySelector('.product-gallery-video__stage');
        this.template = this.querySelector('.product-gallery-video__template');

        // A tap, not a swipe: Flickity swallows the click that ends a drag, so a swipe
        // across the button still moves the gallery.
        if (this.resume) {
          this.resume.addEventListener('click', function (evt) {
            evt.preventDefault();
            evt.stopPropagation();
            self.resumePlay();
          });
        }
        if (this.video) {
          this.video.addEventListener('playing', function () {
            if (self.resume) self.resume.hidden = true;
          });
        }

        // An external embed is interactive from the start, so its stage needs the
        // drag guard immediately. The hosted player has no controls until autoplay
        // is refused, so it is guarded in enableControls() instead — leaving a
        // swipe across the video to move the carousel, as it does on live.
        this.guardPointer(this.stage);

        // External embeds are click-to-play in the main gallery.
        if (this.poster) {
          this.poster.addEventListener('click', function (evt) {
            evt.preventDefault();
            evt.stopPropagation();
            self.openExternal();
          });
        }
      }

      // The gallery's own slide is active: the one Flickity has selected, or —
      // before Flickity has run — the featured slide the page rendered first.
      isSlideActive() {
        if (!this.slide) return false;
        return this.slide.classList.contains('is-selected') || this.slide.classList.contains('starting-slide');
      }

      onSlideActive() {
        if (!this.video) return;

        // A slide reached before the gallery asked for its poster (a far thumbnail).
        if (!this.video.hasAttribute('poster') && this.video.dataset.poster) {
          this.video.setAttribute('poster', this.video.dataset.poster);
        }

        var self = this;
        var p = this.video.play();
        if (p && typeof p.catch === 'function') {
          p.catch(function (err) {
            // An AbortError is the slide left before playback began (pause() cut the play() short), not a refusal:
            // a quick swipe past the video gave it a control bar for good.
            if (err && err.name === 'AbortError') return;
            self.offerPlay();
          });
        }
      }

      // Autoplay refused (power saving, data saver, a browser setting): live hands over
      // the native controls, and on a Samsung phone their time bar sat over the poster
      // (Ayoob, 2026-10-17). The poster stays instead, with the play button over it; a
      // tap is always allowed to start a film.
      offerPlay() {
        if (this.resume) this.resume.hidden = false;
        else this.enableControls();
      }

      resumePlay() {
        var self = this;
        var p = this.video.play();
        if (p && typeof p.catch === 'function') {
          p.catch(function (err) {
            if (err && err.name === 'AbortError') return;
            if (self.resume) self.resume.hidden = true;
            self.enableControls();
          });
        }
      }

      // The last resort, as live does in playMp4Video's catch: a tap refused too (an
      // unplayable source) leaves a poster nobody can start, so the native controls.
      enableControls() {
        if (!this.video || this.video.hasAttribute('controls')) return;
        this.video.setAttribute('controls', '');
        this.guardPointer(this.video);
      }

      // Pointer interaction on a player with controls (scrubbing, the volume
      // slider) must not read as a Flickity drag / slide change.
      guardPointer(el) {
        if (!el || el.dataset.pointerGuarded) return;
        el.dataset.pointerGuarded = 'true';
        ['pointerdown', 'mousedown', 'touchstart'].forEach(function (type) {
          el.addEventListener(type, function (evt) {
            evt.stopPropagation();
          });
        });
      }

      onSlideInactive() {
        if (this.video) {
          this.video.pause();
        } else {
          // External: tear the iframe down so no audio bleeds once the slide is left.
          this.reset();
        }
      }

      openExternal() {
        if (this.classList.contains('is-playing') || !this.template || !this.stage) return;
        this.stage.appendChild(this.template.content.cloneNode(true));
        this.classList.add('is-playing');
      }

      reset() {
        if (!this.classList.contains('is-playing')) return;
        this.classList.remove('is-playing');
        if (this.stage) this.stage.innerHTML = '';
      }

      // Play / pause with the Flickity selected state of the owning slide.
      observeSlide() {
        if (this._observer) {
          this._observer.disconnect();
          this._observer = null;
        }

        if (!this.slide || typeof MutationObserver === 'undefined') return;

        var self = this;
        this._wasSelected = this.slide.classList.contains('is-selected');
        this._observer = new MutationObserver(function () {
          var selected = self.slide.classList.contains('is-selected');
          if (selected === self._wasSelected) return;
          self._wasSelected = selected;
          if (selected) {
            self.onSlideActive();
          } else {
            self.onSlideInactive();
          }
        });
        this._observer.observe(this.slide, { attributes: true, attributeFilter: ['class'] });
      }

      disconnectedCallback() {
        if (this._observer) {
          this._observer.disconnect();
          this._observer = null;
        }
      }
    }

    customElements.define('product-gallery-video', ProductGalleryVideo);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-grid-item"] && !Shopify.designMode) return;
  try {
    /*
    Colour chips on product cards. Pointing at a chip that has a photo shows that colour
    on the card and keeps it there until another chip is pointed at, with the card's link
    following it — on every card, "You may also like" included. Live drops the photo as
    the pointer leaves the chip (and its "You may also like" chips do nothing): keeping it
    is Ayoob's call, 2026-10-08. On collection and search cards a click does the same
    instead of navigating; product pages keep plain links on click, as the old theme did.
    Delegated from the document so cards re-rendered by filtering, sorting or
    recommendations keep it.
  */
  function showCardColour(swatch, card) {
    card.querySelectorAll('.grid-product__colors .color-swatch').forEach(function (chip) {
      chip.classList.toggle('color-swatch--selected', chip === swatch);
    });

    var link = card.querySelector('.grid-product__link');
    var href = swatch.getAttribute('href');
    if (link && href) link.setAttribute('href', href);

    var id = swatch.dataset.variantId;
    card.querySelectorAll('.grid-product__color-image').forEach(function (image) {
      var chosen = Boolean(id) && image.classList.contains('grid-product__color-image--' + id);
      // A keyboard press never hovers, so the photo may not be loaded yet.
      if (chosen && !image.style.backgroundImage && swatch.dataset.variantImage) {
        image.style.backgroundImage = 'url(' + swatch.dataset.variantImage + ')';
      }
      image.classList.toggle('grid-product__color-image--selected', chosen);
    });
  }

  document.addEventListener('mouseover', function (event) {
    var swatch = event.target.closest('.grid-product__colors .color-swatch--with-image');
    if (!swatch || swatch.contains(event.relatedTarget)) return;

    var card = swatch.closest('.grid-product');
    if (card) showCardColour(swatch, card);
  });

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('.grid-product__colors .color-swatch');
    if (!swatch || document.body.classList.contains('template-product')) return;

    var card = swatch.closest('.grid-product');
    if (!card) return;
    event.preventDefault();
    showCardColour(swatch, card);
  });

  /*
    The figures for the card's rating, "★★★★★ 4.8 (406)" (see the stylesheet): copied off Yotpo's own
    badge as it draws, so the card always agrees with it. The count comes from its "406 Reviews"; the
    average from its label, "4.8 out 5 stars rating in total 406 reviews". Yotpo's reviews_count
    metafield was tried first and ran a review behind on 7 of 53 cards, and was missing on one
    (2026-10-11). Watched rather than read once: Yotpo draws its badges after load, and a filter
    or sort redraws the grid.

    The badge is inert inside the card's link (see the markup), so its label without the closing
    "Jump to reviews.", "4.8 out 5 stars rating in total 406 reviews", becomes the card's words for
    screen readers.
  */
  function copyReviewCount(rating) {
    var text = rating.querySelector('.yotpo-sr-bottom-line-text');
    var summary = rating.querySelector('.yotpo-sr-bottom-line-summary');
    var label = summary ? (summary.getAttribute('aria-label') || '').split('. ')[0] : '';
    var count = text && text.textContent.match(/\d[\d,.]*/);
    var average = label.match(/^\s*(\d+(?:[.,]\d+)?)/);
    if (count && average) {
      var figure = parseFloat(average[1].replace(',', '.')).toFixed(1);
      if (rating.dataset.reviewCount !== count[0]) rating.dataset.reviewCount = count[0];
      if (rating.dataset.reviewAverage !== figure) rating.dataset.reviewAverage = figure;
    } else {
      delete rating.dataset.reviewCount;
      delete rating.dataset.reviewAverage;
    }

    var words = rating.parentElement && rating.parentElement.querySelector('.grid-product__rating-label');
    if (words && words.textContent !== label) words.textContent = label;
  }

  function watchReviewCounts() {
    var root = document.getElementById('MainContent') || document.body;
    root.querySelectorAll('.yotpo-grid-rating').forEach(copyReviewCount);
    new MutationObserver(function (records) {
      var ratings = new Set();
      records.forEach(function (record) {
        // A change inside a badge (Yotpo drawing or updating it)…
        var node = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        var rating = node && node.closest('.yotpo-grid-rating');
        if (rating) {
          ratings.add(rating);
          return;
        }
        // …or cards arriving (a filter or sort redrawing the grid).
        record.addedNodes.forEach(function (added) {
          if (added.nodeType !== 1) return;
          if (added.matches('.yotpo-grid-rating')) ratings.add(added);
          added.querySelectorAll('.yotpo-grid-rating').forEach(function (inside) {
            ratings.add(inside);
          });
        });
      });
      ratings.forEach(copyReviewCount);
    }).observe(root, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchReviewCounts, { once: true });
  } else {
    watchReviewCounts();
  }

  /*
    Yotpo draws the badges it finds when it loads and never the ones that arrive later: after a filter redrew
    /collections/men in place, none of its 24 cards had stars (2026-10-14). theme.js fires `collection:reloaded`
    after every such redraw, Back and Forward included, so ask Yotpo to draw the new ones then.
  */
  document.addEventListener('collection:reloaded', function () {
    var yotpo = window.yotpoWidgetsContainer;
    if (yotpo && typeof yotpo.initWidgets === 'function') yotpo.initWidgets();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-images"] && !Shopify.designMode) return;
  try {
    (function () {
    /*
      The gallery's photos load one step ahead of the shopper. On arrival, the photos on
      screen (on phones the first and the edge of the second); once those are in, the next
      one along. Each move then loads the one after whatever is on screen, so a swipe lands
      on a photo that is already there while the next loads behind it. A thumbnail loads its
      photo when the pointer rests on it, and once the shopper has used the gallery the photo
      before the current one loads as well.

      This file's script runs before theme.js builds the carousel, so the gallery is marked
      before any slide is laid out.
    */
    var AHEAD = 1;

    function loaded(img) {
      return new Promise(function (resolve) {
        if (img.complete) return resolve();
        img.addEventListener('load', resolve, { once: true });
        img.addEventListener('error', resolve, { once: true });
      });
    }

    function setup(gallery) {
      if (gallery.hasAttribute('data-gallery-loader')) return;
      var root = gallery.closest('[data-product-images]') || gallery;
      var used = false;

      // The carousel's slides in its own order: with an image set, only that colour's.
      function slides() {
        var slider = gallery.querySelector('.flickity-slider');
        return Array.prototype.slice.call((slider || gallery).querySelectorAll('.product-main-slide'));
      }

      // Lets a slide's photo into the layout, where the browser loads it as it comes into
      // view; `now` asks for it straight away. A video slide gets its poster.
      function open(slide, now) {
        if (!slide) return;
        slide.setAttribute('data-gallery-near', '');
        var video = slide.querySelector('video[data-poster]');
        if (video && !video.hasAttribute('poster')) video.setAttribute('poster', video.dataset.poster);
        if (!now) return;
        slide.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
          img.loading = 'eager';
        });
      }

      // Slides on screen at rest: one on desktop; on phones the current one and the edge of
      // the next.
      function perView(all) {
        var frame = gallery.querySelector('.flickity-viewport');
        if (!frame) return 1;
        var style = getComputedStyle(all[0]);
        var step = all[0].offsetWidth + parseFloat(style.marginLeft) + parseFloat(style.marginRight);
        return step > 0 ? Math.max(1, Math.ceil((frame.clientWidth - 1) / step)) : 1;
      }

      function update() {
        var all = slides();
        if (!all.length) return;
        var at = all.findIndex(function (slide) { return slide.classList.contains('is-selected'); });
        if (at < 0) at = Math.max(0, all.findIndex(function (slide) { return slide.classList.contains('starting-slide'); }));
        var count = Math.min(perView(all), all.length);
        var shown = [];
        for (var i = 0; i < count; i++) shown.push(all[(at + i) % all.length]);

        var photos = [];
        shown.forEach(function (slide) {
          open(slide, false);
          slide.querySelectorAll('img').forEach(function (img) { photos.push(img); });
        });
        Promise.all(photos.map(loaded)).then(function () {
          for (var n = 0; n < AHEAD; n++) open(all[(at + count + n) % all.length], true);
          if (used) open(all[(at - 1 + all.length) % all.length], true);
        });
      }

      function use() {
        if (used) return;
        used = true;
        update();
      }

      // A photo not yet loaded marks its slide, so its frame breathes until it lands (or fails); see the stylesheet.
      gallery.querySelectorAll('.product-main-slide').forEach(function (slide) {
        var img = slide.querySelector('.image-wrap > image-element > img');
        if (!img || img.complete) return;
        slide.setAttribute('data-photo-waiting', '');
        loaded(img).then(function () {
          slide.removeAttribute('data-photo-waiting');
        });
      });

      // What is on screen is let in before the mark goes on, so it never drops out for a frame.
      update();
      gallery.setAttribute('data-gallery-loader', '');

      // The carousel moves `is-selected` from slide to slide, on a swipe, an arrow, a
      // thumbnail or a colour change, and when it is built or rebuilt.
      new MutationObserver(function (mutations) {
        var moved = mutations.some(function (m) { return m.target.classList && m.target.classList.contains('product-main-slide'); });
        if (moved) update();
      }).observe(gallery, { subtree: true, attributes: true, attributeFilter: ['class'] });

      gallery.addEventListener('pointerdown', use, { passive: true });
      gallery.addEventListener('keydown', use);
      root.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
        var slide = gallery.querySelector('.product-main-slide[data-index="' + thumb.dataset.index + '"]');
        thumb.addEventListener('pointerenter', function () { open(slide, true); });
        thumb.addEventListener('focus', function () { open(slide, true); });
        thumb.addEventListener('click', use);
      });
    }

    function init(scope) {
      scope.querySelectorAll('[data-product-photos]').forEach(setup);
    }

    init(document);
    document.addEventListener('shopify:section:load', function (evt) {
      init(evt.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-template"] && !Shopify.designMode) return;
  try {
    /*
    Yotpo writes American English (its AI topics and "Customers say"), the shop British (Ayoob,
    2026-10-19). The scripts below re-spell Yotpo's words wherever they show or measure them:
    color and the words built on it, in the word's own case (Color > Colour, COLOR > COLOUR,
    discolored > discoloured; colour and watercolor stay as they are). Shopify wraps this file's
    script in a function of its own, so these two are not globals.
  */
  var COLOUR_WORDS = /\b(dis)?(colo)(r)(s|ed|ful|fully|ing|less|way|ways)?\b/gi;

  var britishColour = function (text) {
    return text.replace(COLOUR_WORDS, function (word, dis, colo, r, end) {
      return (dis || '') + colo + (colo === colo.toUpperCase() ? 'U' : 'u') + r + (end || '');
    });
  };

  // Yotpo's own text nodes edited in place, only where the spelling differs, so Yotpo can still update them.
  var respellColour = function (root) {
    var walk = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walk.nextNode())) {
      var text = britishColour(node.nodeValue);
      if (text !== node.nodeValue) node.nodeValue = text;
    }
  };

  /*
    The buy box's marks from Yotpo's own count, before the scripts below read them. The marks
    (data-has-yotpo-reviews, data-pj-strip: top of this file) come from Shopify's count, wrong on a
    few products (2026-10-18); the reviews section lower down the page has Yotpo's own
    (sections/apps.liquid reads it from the box Yotpo prints): whether there are reviews
    (data-reviews-held) and whether the "Highly rated" line will come (data-reviews-strip). The
    stylesheet holds the right room from the first paint by the section itself; this hands it to
    the marks (data-pj-reviews-synced), so the scripts below and the "Highly rated" line's sizing
    work as on any product. A mark the section doesn't contradict is left as it is: the line's
    sizing lets its hold go when Yotpo has no topics. Only the product page's own buy box.
  */
  (function () {
    var section = document.querySelector('.product-reviews[data-reviews-held]');
    var meta = document.querySelector('[data-modal="false"] .product-single__meta');
    if (!section || !meta) return;
    if (section.getAttribute('data-reviews-held') === 'none') {
      meta.removeAttribute('data-has-yotpo-reviews');
      meta.removeAttribute('data-pj-strip');
    } else {
      meta.setAttribute('data-has-yotpo-reviews', '');
      var strip = section.getAttribute('data-reviews-strip');
      if (strip && !meta.hasAttribute('data-pj-strip')) meta.setAttribute('data-pj-strip', strip === 'maybe' ? 'maybe' : '');
    }
    meta.setAttribute('data-pj-reviews-synced', '');
  })();

  /*
    Yotpo's "Highly rated by customers for: ..." strip (styled above) is drawn by Yotpo on some
    page loads and skipped on others: a race inside Yotpo's own script, not the theme. Measured
    2026-10-09, it showed on 4 of 10 first visits and about 9 of 10 reloads. Asking Yotpo to
    redraw its widgets once brings it back within ~300ms, but a redraw also blinks the stars for
    ~150ms, so it only happens when the product has topics to show. That is read from the same
    productFilters response Yotpo's widgets fetch (its summaryTopics are the strip's topics), at
    the address Yotpo itself used. Nothing happens when the strip arrived on its own, when the
    product has no reviews or no topics, or when Yotpo changes any of this.
  */
  (function () {
    var meta = document.querySelector('.product-single__meta[data-has-yotpo-reviews]');
    var instance = meta && meta.querySelector('[data-yotpo-product-id]');
    if (!instance || !('PerformanceObserver' in window) || !window.fetch) return;

    var STRIP = '.yotpo-star-rating-reviews-highly-rated-topics';
    var STARS = '.yotpo-sr-bottom-line-text';
    var WAIT_AFTER_STARS = 1500; // Yotpo's own strip lands within ~500ms of the stars
    var GIVE_UP_AFTER = 30000;

    var filtersPath = '/product/' + instance.getAttribute('data-yotpo-product-id') + '/productFilters';
    var filtersUrl = null;
    var timer = null;

    // The address of Yotpo's own request for this product's topics. An observer (unlike
    // performance.getEntries) still sees it once the resource-timing buffer is full.
    var requests = new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (entry) {
        if (entry.name.indexOf(filtersPath) !== -1) filtersUrl = entry.name;
      });
    });
    requests.observe({ type: 'resource', buffered: true });

    var stars = new MutationObserver(waitForStrip);
    stars.observe(meta, { childList: true, subtree: true });
    var giveUp = setTimeout(stop, GIVE_UP_AFTER);
    waitForStrip();

    function waitForStrip() {
      if (timer || !meta.querySelector(STARS)) return;
      stars.disconnect();
      timer = setTimeout(check, WAIT_AFTER_STARS);
    }

    function stop() {
      stars.disconnect();
      requests.disconnect();
      clearTimeout(giveUp);
    }

    function check() {
      stop();
      if (meta.querySelector(STRIP) || !filtersUrl) return;

      fetch(filtersUrl)
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          var yotpo = window.yotpoWidgetsContainer;
          var hasTopics = data && data.summaryTopics && data.summaryTopics.length > 0;
          if (!hasTopics || meta.querySelector(STRIP) || !yotpo || typeof yotpo.initWidgets !== 'function') return;
          yotpo.initWidgets();
        })
        .catch(function () {});
    }
  })();

  /*
    The "Highly rated" line's space (the stylesheet's data-pj-strip rule). As the page
    opens, the product's topics are asked of Yotpo (the request its own widget makes
    seconds later), so the space is held only where the line will come, whatever the
    review count said, and at its exact height: a stand-in with Yotpo's markup for the
    line, the three most-mentioned topics in it (Yotpo's pick), laid out in the line's
    place one-line-or-stacked as the script further down decides for the real line, is
    measured and taken away in the same moment, before anything is painted. Its width
    and number of lines go to the stylesheet too, for the faint outline drawn in the
    space while it loads. Measured again when the fonts land or the window resizes, until
    the real line is in; then the hold is dropped, and the line keeps its own space.
  */
  (function () {
    var meta = document.querySelector('.product-single__meta');
    var slot = meta && meta.querySelector('[data-yotpo-section-id="product"]');
    var product = meta && meta.querySelector('[data-yotpo-product-id]');

    // The store's key is in the address of Yotpo's widget loader. The page has two loaders,
    // the reviews' and the loyalty programme's, each with its own key, in either order from
    // one load to the next: the one that names a language (the reviews') is tried first, the
    // other if Yotpo doesn't know the first.
    var sources = [].map.call(document.querySelectorAll('script[src*="cdn-widgetsrepository.yotpo.com/v1/loader/"]'), function (script) {
      return script.getAttribute('src');
    });
    sources.sort(function (a, b) {
      return /[?&]languageCode=/.test(b) - /[?&]languageCode=/.test(a);
    });
    var keys = [];
    sources.forEach(function (src) {
      var key = (src.match(/\/loader\/([^/?#]+)/) || [])[1];
      if (key && keys.indexOf(key) === -1) keys.push(key);
    });
    if (!slot || !product || !keys.length || !window.fetch) return;

    var STRIP = '.yotpo-star-rating-reviews-highly-rated-topics';
    var lang = (sources[0].match(/[?&]languageCode=([\w-]+)/) || [])[1] || 'en';
    var path = '/product/' + product.getAttribute('data-yotpo-product-id') + '/productFilters?lang=' + lang;
    var topics = null;
    var frame = 0;
    var finished = false;

    var watch = new MutationObserver(function () {
      var line = meta.querySelector(STRIP);
      if (line && line.getBoundingClientRect().height > 0) finish();
    });
    watch.observe(meta, { childList: true, subtree: true });

    function finish() {
      finished = true;
      watch.disconnect();
      window.removeEventListener('resize', soon);
      meta.removeAttribute('data-pj-strip');
      meta.style.removeProperty('--pj-strip-space');
      meta.style.removeProperty('--pj-strip-width');
      meta.style.removeProperty('--pj-strip-lines');
    }

    function span(className, text) {
      var el = document.createElement('span');
      if (className) el.className = className;
      if (text) el.textContent = text;
      return el;
    }

    function measure() {
      frame = 0;
      if (finished || !topics) return;

      var line = document.createElement('div');
      line.className = 'yotpo-star-rating-reviews-highly-rated-topics';
      line.style.cssText = 'display: flex; flex-direction: row; width: auto; gap: 10px; align-items: start;';
      var text = span('yotpo-star-rating-highly-rated-topics-text');
      var lead = span('yotpo-highly-rated-topics-title', 'Highly rated by customers for:');
      text.append(lead, ' ');
      topics.forEach(function (topic, i) {
        var words = span('', '');
        words.append(span('yotpo-topic-underline', topic));
        if (i < topics.length - 1) words.append(span('yotpo-topic-comma', ', '));
        var content = span('yotpo-highly-rated-topics-content');
        content.append(words);
        text.append(content);
      });
      line.append(text);

      var place = document.createElement('div');
      place.className = 'yotpo-widget-clear yotpo-bottom-line-scroll-panel';
      place.setAttribute('aria-hidden', 'true');
      place.style.cssText = 'position: absolute; visibility: hidden; pointer-events: none; display: flex; flex-direction: column; align-items: flex-start; width: ' + slot.getBoundingClientRect().width + 'px;';
      place.append(line);
      meta.append(place);

      var last = text.querySelectorAll('.yotpo-highly-rated-topics-content');
      var leadLine = lead.getClientRects()[0];
      if (leadLine && last[last.length - 1].getBoundingClientRect().top >= leadLine.bottom) {
        line.setAttribute('data-pj-stacked', '');
      }
      var box = line.getBoundingClientRect();
      var style = getComputedStyle(line);
      var height = box.height + parseFloat(style.marginTop);
      // Its lines, for the outline drawn while it loads: the stacked lead's 2px is well under half a line.
      var lines = Math.round((box.height - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom)) / parseFloat(getComputedStyle(lead).lineHeight));
      place.remove();

      meta.style.setProperty('--pj-strip-space', height + 'px');
      meta.style.setProperty('--pj-strip-width', box.width + 'px');
      meta.style.setProperty('--pj-strip-lines', String(Math.max(1, lines || 1)));
      meta.setAttribute('data-pj-strip', '');
    }

    function soon() {
      if (!frame) frame = requestAnimationFrame(measure);
    }

    function answer(data) {
      if (finished) return;
      var summary = (data && data.summaryTopics) || [];
      if (!summary.length) {
        finish();
        return;
      }
      topics = summary
        .map(function (topic, i) {
          return { name: topic.displayTopic, coverage: Number(topic.coverage) || 0, order: i };
        })
        .sort(function (a, b) {
          return b.coverage - a.coverage || a.order - b.order;
        })
        .slice(0, 3)
        .map(function (topic) {
          // as the line will read once the font release below has re-spelt it ("Colour", a letter longer)
          return britishColour(topic.name);
        });
      measure();
      window.addEventListener('resize', soon);
      if (document.fonts) {
        document.fonts.ready.then(soon);
        document.fonts.addEventListener('loadingdone', soon);
      }
    }

    // A 404 means the key was the loyalty programme's: the next one. Anything else that fails
    // is tried once more after a moment (Yotpo can answer "Bandwidth Exceeded"); after that
    // the space stays as the review count guessed it.
    function ask(i, again) {
      fetch('https://api-cdn.yotpo.com/v3/storefront/store/' + keys[i] + path)
        .then(function (response) {
          if (response.status === 404 && i + 1 < keys.length) {
            ask(i + 1, again);
            return;
          }
          if (!response.ok) throw new Error(response.status);
          return response.json().then(answer);
        })
        .catch(function () {
          if (again && !finished) {
            setTimeout(function () {
              ask(i, false);
            }, 800);
          }
        });
    }

    ask(0, true);
  })();

  /*
    The "Highly rated" strip in the theme's face (Ayoob, 2026-10-09). Yotpo writes
    `font-family: Gotham !important` and `font-weight: 400 !important` into the style
    attribute of every span in the strip, which no stylesheet can override, so those
    two declarations are taken off each time Yotpo draws or redraws the strip (the
    nudge above redraws it too); the stylesheet's small-print rule then applies. The
    strip's own box carries Gotham too, and loses it the same way (2026-10-16: no
    Yotpo face anywhere). Its topics are re-spelt here too ("Color" > "Colour", Ayoob,
    2026-10-19), before the one-line-or-stacked check below measures the line: this
    observer was set up first, so it runs first. Nothing else Yotpo writes is touched.
  */
  (function () {
    var meta = document.querySelector('.product-single__meta[data-has-yotpo-reviews]');
    if (!meta) return;

    var STRIP = '.yotpo-star-rating-reviews-highly-rated-topics';

    function release() {
      meta.querySelectorAll(STRIP + ', ' + STRIP + ' [style]').forEach(function (el) {
        if (el.style.getPropertyValue('font-family')) el.style.removeProperty('font-family');
        if (el.style.getPropertyValue('font-weight')) el.style.removeProperty('font-weight');
      });
      meta.querySelectorAll(STRIP + ' .yotpo-topic-underline').forEach(respellColour);
    }

    new MutationObserver(release).observe(meta, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style'],
    });
    release();
  })();

  /*
    The strip on one line when it fits, otherwise stacked: the lead on a line of its own
    and the topics on the next (the stylesheet's data-pj-stacked rule; Ayoob, 2026-10-09).
    Whether it fits depends on the topics Yotpo picks for the product, so it is measured
    rather than set by screen width: laid out on one line, does the last topic start
    below the lead's line? Checked whenever Yotpo draws the strip (after the font release
    above, whose observer was set up first, so the theme's face is measured), when the
    window resizes and once the fonts have loaded.
  */
  (function () {
    var meta = document.querySelector('.product-single__meta[data-has-yotpo-reviews]');
    if (!meta) return;
    var frame = 0;

    function fit() {
      frame = 0;
      var band = meta.querySelector('.yotpo-star-rating-reviews-highly-rated-topics');
      var lead = band && band.querySelector('.yotpo-highly-rated-topics-title');
      var topics = band ? band.querySelectorAll('.yotpo-highly-rated-topics-content') : [];
      if (!lead || !topics.length) return;
      band.removeAttribute('data-pj-stacked');
      var leadLine = lead.getClientRects()[0];
      if (leadLine && topics[topics.length - 1].getBoundingClientRect().top >= leadLine.bottom) {
        band.setAttribute('data-pj-stacked', '');
      }
    }

    function soon() {
      if (!frame) frame = requestAnimationFrame(fit);
    }

    new MutationObserver(fit).observe(meta, { childList: true, subtree: true });
    window.addEventListener('resize', soon);
    if (document.fonts) document.fonts.ready.then(soon);
    fit();
  })();

  /*
    The review highlights in Yotpo's "Customers say" drawer, shown as comments (Ayoob,
    2026-10-09; styled in the stylesheet above). Yotpo writes each one as
    `“review“ - Name`: this takes the dash off the name and the quote marks off the review,
    and puts the reviewer's initials in data-pj-initials for the stylesheet's circle. Yotpo
    builds the drawer when it opens and can rebuild it, so this runs on any change to the
    page while the drawer exists. It edits Yotpo's own text nodes in place, and only when
    they differ, so Yotpo can still update them and its own edits end there.
  */
  (function () {
    var DASH = /^[\s\-–—]+/;
    var QUOTE_MARKS = /^\s*[“”„"]\s*|\s*[“”"]\s*$/g;

    function initials(name) {
      var words = name.match(/\p{L}[\p{L}'’-]*/gu);
      if (!words) return '';
      var last = words.length > 1 ? words[words.length - 1].charAt(0) : '';
      return (words[0].charAt(0) + last).toUpperCase();
    }

    function tidyText(el, pattern) {
      var node = el && el.childNodes.length === 1 ? el.firstChild : null;
      if (!node || node.nodeType !== Node.TEXT_NODE) return;
      var text = node.nodeValue.replace(pattern, '').trim();
      if (text !== node.nodeValue) node.nodeValue = text;
    }

    function tidy() {
      var drawer = document.getElementById('yotpo-summary-container');
      if (!drawer) return;
      drawer.querySelectorAll('.yotpo-summary-highlight-content').forEach(function (comment) {
        var reviewer = comment.querySelector('.yotpo-summary-highlight-reviewer');
        if (!reviewer) return;
        tidyText(reviewer, DASH);
        tidyText(comment.querySelector('p'), QUOTE_MARKS);
        var letters = initials(reviewer.textContent);
        if (comment.getAttribute('data-pj-initials') !== letters) comment.setAttribute('data-pj-initials', letters);
      });
    }

    new MutationObserver(tidy).observe(document.body, { childList: true, subtree: true, characterData: true });
    tidy();
  })();

  /*
    "Colour" in Yotpo's "Customers say" (Ayoob, 2026-10-19: "The review summary generated on the pdp page uses
    color. Which is American ... Just focus on customers say", then of the "Highly rated" line: "It still shows
    it"). Yotpo's AI writes in American English and has no British setting, so its own words are re-spelt
    (britishColour, top of this script): the summary's paragraph (in the reviews section and in the drawer), the
    drawer's topic names and their lines ("Customers keep praising the great color ..."), and the "Highly rated"
    line's topics, which the font release above re-spells as they are drawn, this catching any later edit of
    Yotpo's. The customers' quotes in the drawer are their own words and are left alone.
  */
  (function () {
    var PARTS = '.yotpo-paragraph-summary-text, .yotpo-summary-topic, .yotpo-summary-content, .yotpo-topic-underline';

    function respell() {
      document.querySelectorAll(PARTS).forEach(respellColour);
    }

    new MutationObserver(respell).observe(document.body, { childList: true, subtree: true, characterData: true });
    respell();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product.hot-reload"] && !Shopify.designMode) return;
  try {
    class ProductHotReload extends HTMLElement {
    constructor() {
      super();
      this.cache = new Map(); // Cache for pre-fetched content
      this.activeRequests = new Map(); // Track active fetch requests
      this.loadingTimeout = null; // Timeout for loading state
      this.supportsViewTransitions = 'startViewTransition' in document;
      
      this.addEventListener('change', (event) => this.onVariantChange(event));
      this.addEventListener('mouseover', (event) => this.onMouseOver(event));
    }

    showLoadingState() {
      // Start loading state (pulse) after 200ms
      this.loadingTimeout = setTimeout(() => {
        this.classList.add('product-hot-reload--loading');
      }, 200);
    }

    hideLoadingState() {
      // Clear the timeout if it hasn't triggered yet
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
        this.loadingTimeout = null;
      }
      
      // Remove loading animation
      this.classList.remove('product-hot-reload--loading');
    }

    buildRequestUrl(input) {
      const productFormElement = input.closest('form');
      const sectionId = this.dataset.sectionId;
      
      // Get dataset values from the input or selected option
      let newProductUrl, optionValueId;
      
      if (input.type === 'radio') {
        newProductUrl = input.dataset.productUrl;
        optionValueId = input.dataset.optionValueId;
      } else if (input.tagName === 'SELECT') {
        const selectedOption = input.options[input.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl;
        optionValueId = selectedOption.dataset.optionValueId;
      }

      // Get all currently selected values from both radio inputs and select elements
      let selectedOptionValues = [];
      
      // Get values from checked radio inputs
      const checkedRadios = Array.from(productFormElement.querySelectorAll('input[type="radio"]:checked'));
      selectedOptionValues = checkedRadios.map(({ dataset }) => dataset.optionValueId).filter(Boolean);
      
      // Get values from select elements
      const selects = Array.from(productFormElement.querySelectorAll('select'));
      selects.forEach(select => {
        const selectedOption = select.options[select.selectedIndex];
        if (selectedOption && selectedOption.dataset.optionValueId) {
          selectedOptionValues.push(selectedOption.dataset.optionValueId);
        }
      });

      // If we're building for a hover state, replace the current option's value
      if (input.type === 'radio' && !input.checked) {
        const currentOptionName = input.name;
        // Remove any existing selection for this option
        selectedOptionValues = selectedOptionValues.filter(id => {
          const input = productFormElement.querySelector(`input[data-option-value-id="${id}"]`);
          return input && input.name !== currentOptionName;
        });
        // Add the hovered option value
        selectedOptionValues.push(optionValueId);
      }

      const params = selectedOptionValues.length > 0 ? `&option_values=${selectedOptionValues.join(',')}` : '';
      return `${newProductUrl}?section_id=${sectionId}${params}`;
    }

    onMouseOver(event) {
      const label = event.target.closest('label');
      if (!label) return;

      const input = label.querySelector('input[type="radio"]');
      if (!input) return;

      // Don't pre-fetch if already selected
      if (input.checked) return;

      const requestUrl = this.buildRequestUrl(input);

      // Don't prefetch if we already have cached content or an active request
      if (this.cache.has(requestUrl) || this.activeRequests.has(requestUrl)) return;

      // Pre-fetch the content for this option
      this.fetchContent(requestUrl);
    }

    fetchContent(requestUrl) {
      // Create and store the fetch promise
      const fetchPromise = fetch(requestUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.cache.set(requestUrl, html);
          this.activeRequests.delete(requestUrl);
          return html;
        })
        .catch((error) => {
          this.activeRequests.delete(requestUrl);
          throw error;
        });

      this.activeRequests.set(requestUrl, fetchPromise);
      return fetchPromise;
    }

    async onVariantChange(event) {
      if (!event.target.hasAttribute('data-product-hot-reload-trigger')) return;

      const optionValueElement = event.target;
      const requestUrl = this.buildRequestUrl(optionValueElement);
      const oldProductUrl = this.dataset.productUrl;
      
      // Get new product URL from the input or selected option
      let newProductUrl;
      if (optionValueElement.type === 'radio') {
        newProductUrl = optionValueElement.dataset.productUrl || oldProductUrl;
      } else if (optionValueElement.tagName === 'SELECT') {
        const selectedOption = optionValueElement.options[optionValueElement.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl || oldProductUrl;
      } else {
        newProductUrl = oldProductUrl;
      }

      // Start loading state immediately on change event
      this.showLoadingState();

      let html;

      try {
        // Use cached content if available
        if (this.cache.has(requestUrl)) {
          html = this.cache.get(requestUrl);
        }
        // Wait for active request if one exists
        else if (this.activeRequests.has(requestUrl)) {
          html = await this.activeRequests.get(requestUrl);
        }
        // Make new request if no cache or active request
        else {
          html = await this.fetchContent(requestUrl);
        }

        await this.updateProductWithTransition(html, newProductUrl, event.target.id);
      } catch (error) {
        console.error('Error updating product content:', error);
      } finally {
        // Always hide loading state
        this.hideLoadingState();
      }
    }

    async updateProductWithTransition(html, newProductUrl, targetId) {
      const updatedHtml = html.getElementById(this.id);
      
      if (this.supportsViewTransitions) {
        // Use View Transitions API for smooth transitions
        const transition = document.startViewTransition(() => {
          this.innerHTML = updatedHtml.innerHTML;
          this.dataset.productUrl = updatedHtml.dataset.productUrl;
          this.dataset.variantId = updatedHtml.dataset.variantId;
        });

        // Wait for the transition to complete
        await transition.finished;
      } else {
        // Fallback: Update content immediately without animations
        this.innerHTML = updatedHtml.innerHTML;
        this.dataset.productUrl = updatedHtml.dataset.productUrl;
        this.dataset.variantId = updatedHtml.dataset.variantId;
      }

      // Update URL and history
      let url = new URL(newProductUrl, window.location.origin);

      // Preserve all existing URL parameters from the current page
      const currentUrl = new URL(window.location.href);
      for (const [key, value] of currentUrl.searchParams.entries()) {
        // Don't override the variant parameter we're setting
        if (key !== 'variant') {
          url.searchParams.set(key, value);
        }
      }

      // Add variant param if variantId exists
      url.searchParams.set('variant', this.dataset.variantId);

      // Push new state to browser history
      window.history.pushState({}, '', url.toString());

      // Focus the input for the last clicked option value
      this.querySelector(`#${targetId}`).focus();
    }
  }

  customElements.define('product-hot-reload', ProductHotReload);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.gift-recipient"] && !Shopify.designMode) return;
  try {
    class GiftRecipientForm extends HTMLElement {
    constructor() {
      super()
      this.checkboxInput = this.querySelector('.gift-recipient-form__checkbox input[type="checkbox"]')
      this.emailInput = this.querySelector('.gift-recipient-form__email')
      this.nameInput = this.querySelector('.gift-recipient-form__name')
      this.messageInput = this.querySelector('.gift-recipient-form__message')
      this.dateInput = this.querySelector('.gift-recipient-form__date')
      this.addEventListener('change', () => this.onChange())
      this.recipientFields = this.querySelector('.recipient-fields')

      this.checkboxInput.addEventListener('change', () => {
        event.stopPropagation()
        this.recipientFields.style.display = this.checkboxInput.checked ? 'block' : 'none'
      })
    }

    connectedCallback() {
      this.abortController = new AbortController()

      document.addEventListener('product-form:submit:error', (event) => {
        if (event.target.form.id === this.dataset.formId) {
          this.displayErrorMessage(event.detail.errorMessage)
        }
      }, { signal: this.abortController.signal })

      document.addEventListener('product-form:submit:success', (event) => {
        if (event.target.form.id === this.dataset.formId) {
          this.clearInputFields()
          this.clearErrorMessage()
        }
      }, { signal: this.abortController.signal })
    }

    disconnectedCallback() {
      this.abortController.abort()
    }

    onChange() {
      if (!this.checkboxInput.checked) {
        this.clearInputFields()
        this.clearErrorMessage()
      }
    }

    clearInputFields() {
      for (const element of this.querySelectorAll('input')) {
        element.value = ''
      }
    }

    displayErrorMessage(body) {
      this.clearErrorMessage()
      if (body) {
        return Object.entries(body).forEach(([key, value]) => {
          const inputElement = this[`${key}Input`]
          if (!inputElement) {
            return
          }

          inputElement.setAttribute('aria-invalid', true)
        })
      }
    }

    clearErrorMessage() {
      for (const inputElement of this.querySelectorAll('input')) {
        inputElement.setAttribute('aria-invalid', false)
        inputElement.removeAttribute('aria-describedby')
      }
    }
  }

  customElements.define('gift-recipient-form', GiftRecipientForm)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.media-gallery"] && !Shopify.designMode) return;
  try {
    class MediaGalleryElement extends HTMLElement {
    constructor() {
      super();
      this.slides = this.querySelectorAll('.media-gallery__slide');
      this.thumbs = this.querySelectorAll('.media-gallery__thumb');
      this.prevBtn = this.querySelector('.media-gallery__nav--prev');
      this.nextBtn = this.querySelector('.media-gallery__nav--next');
      this.mainContainer = this.querySelector('.media-gallery__main');
      this.currentIndex = 0;
      this.isAnimating = false;
      this.isNaturalAspectRatio = this.mainContainer?.getAttribute('data-aspect-ratio') === 'initial';

      // Touch/swipe handling
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchEndX = 0;
      this.touchEndY = 0;
      this.minSwipeDistance = 50;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      // Adjust container height for natural aspect ratio
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight(true); // Disable transition for initial setup

        // Set up resize observer for images that might load asynchronously
        this.setupResizeObserver();
      }

      // Add click handlers to thumbnails
      this.thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          const direction = index > this.currentIndex ? 'next' : 'prev';
          this.goToSlide(index, direction);
        });
      });

      // Add click handlers to navigation buttons
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.previousSlide();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.nextSlide();
        });
      }

      // Add keyboard navigation
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.previousSlide();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.nextSlide();
        }
      });

      // Make the gallery focusable for keyboard navigation
      this.setAttribute('tabindex', '0');

      // Add touch/swipe handlers
      this.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true });
      this.addEventListener('touchend', this.handleTouchEnd.bind(this), { passive: true });
      this.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: true });

      // Ensure only the initial active slide can play
      this.pauseNonActiveSlides();
      this.autoplayActiveSlideIfEligible();
    }

    goToSlide(index, direction = 'next') {
      if (index < 0 || index >= this.slides.length) return;
      if (index === this.currentIndex) return;
      if (this.isAnimating) return;

      const currentSlide = this.slides[this.currentIndex];
      const targetSlide = this.slides[index];

      // Before animating, pause non-target slides
      this.pauseAllMediaExceptInSlide(targetSlide);

      // Reset all slides
      this.resetSlides();

      // Position slides for animation
      this.positionSlidesForAnimation(currentSlide, targetSlide, direction);

      // Update UI state
      this.updateThumbnails(index);
      this.currentIndex = index;

      // Start animation after positioning is applied
      this.animateSlides(currentSlide, targetSlide, direction);

      // Adjust container height for natural aspect ratio after slide change
      if (this.isNaturalAspectRatio) {
        setTimeout(() => {
          this.adjustContainerHeight();
        }, 50); // Small delay to ensure slide is positioned
      }
    }

    resetSlides() {
      this.slides.forEach(slide => {
        slide.classList.remove('media-gallery__slide--prev', 'media-gallery__slide--next');
      });
    }

    positionSlidesForAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class from all slides during positioning
      this.slides.forEach(slide => {
        slide.classList.remove('media-gallery__slide--is-animating');
      });

      if (direction === 'next') {
        // Next: target and others on right, current stays in center
        targetSlide.style.transform = 'translateX(100%)';
        this.slides.forEach(slide => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(100%)';
          }
        });
      } else {
        // Previous: target and others on left, current stays in center
        targetSlide.style.transform = 'translateX(-100%)';
        this.slides.forEach(slide => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(-100%)';
          }
        });
      }
    }

    updateThumbnails(activeIndex) {
      this.thumbs[this.currentIndex].classList.remove('media-gallery__thumb--active');
      this.thumbs[activeIndex].classList.add('media-gallery__thumb--active');
    }

    adjustContainerHeight(disableTransition = false) {
      if (!this.isNaturalAspectRatio || !this.mainContainer) return;

      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;

      // Disable transition if requested (for initial setup)
      if (disableTransition) {
        this.mainContainer.classList.add('media-gallery__main--no-transition');
      }

      // Find the image in the active slide
      const img = activeSlide.querySelector('img');
      if (!img) return;

      // Get the image's natural dimensions
      const imgWidth = img.naturalWidth || img.width;
      const imgHeight = img.naturalHeight || img.height;

      if (imgWidth && imgHeight) {
        // Calculate the aspect ratio
        const aspectRatio = imgWidth / imgHeight;

        // Get the container width
        const containerWidth = this.mainContainer.offsetWidth;

        // Calculate the height based on the aspect ratio
        const calculatedHeight = containerWidth / aspectRatio;

        // Set the container height
        this.mainContainer.style.height = calculatedHeight + 'px';
      } else {
        // Fallback: temporarily make the slide visible to measure its height
        const originalOpacity = activeSlide.style.opacity;
        const originalTransform = activeSlide.style.transform;
        activeSlide.style.opacity = '1';
        activeSlide.style.transform = 'translateX(0)';
        activeSlide.style.position = 'relative';
        activeSlide.style.visibility = 'hidden';

        // Get the natural height of the slide content
        const slideHeight = activeSlide.offsetHeight;

        // Restore original styles
        activeSlide.style.opacity = originalOpacity;
        activeSlide.style.transform = originalTransform;
        activeSlide.style.position = '';
        activeSlide.style.visibility = '';

        // Set the container height to match the slide height
        this.mainContainer.style.height = slideHeight + 'px';
      }

      // Re-enable transition after a brief delay
      if (disableTransition) {
        setTimeout(() => {
          this.mainContainer.classList.remove('media-gallery__main--no-transition');
        }, 10);
      }
    }

    setupResizeObserver() {
      if (!this.isNaturalAspectRatio || !window.ResizeObserver) return;

      this.resizeObserver = new ResizeObserver(() => {
        this.adjustContainerHeight();
      });

      // Observe all images in the slides
      this.slides.forEach(slide => {
        const images = slide.querySelectorAll('img');
        images.forEach(img => {
          this.resizeObserver.observe(img);

          // Also listen for load events to recalculate when image loads
          img.addEventListener('load', () => {
            if (slide.classList.contains('media-gallery__slide--active')) {
              this.adjustContainerHeight();
            }
          });
        });
      });
    }

    animateSlides(currentSlide, targetSlide, direction) {
      // Set animation flag
      this.isAnimating = true;

      // Frame 1: Initial positions are already set (no animation class)

      // Frame 2: Add animation class
      requestAnimationFrame(() => {
        currentSlide.classList.add('media-gallery__slide--is-animating');
        targetSlide.classList.add('media-gallery__slide--is-animating');

        // Frame 3: Trigger animation
        requestAnimationFrame(() => {
          // Animate current slide out
          if (direction === 'next') {
            currentSlide.style.transform = 'translateX(-100%)';
          } else {
            currentSlide.style.transform = 'translateX(100%)';
          }

          // Animate target slide in
          targetSlide.style.transform = 'translateX(0)';
          targetSlide.classList.add('media-gallery__slide--active');

          // Clean up after animation
          this.waitForTransition(currentSlide).then(() => {
            this.positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction);
            this.scrollActiveThumbnailIntoView();
            // Hydrate and autoplay current slide media if eligible and pause others
            this.pauseNonActiveSlides();
            this.autoplayActiveSlideIfEligible();
            // Clear animation flag
            this.isAnimating = false;
          });
        });
      });
    }

    positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class and active class from current slide
      currentSlide.classList.remove('media-gallery__slide--is-animating', 'media-gallery__slide--active');
      targetSlide.classList.remove('media-gallery__slide--is-animating');

      if (direction === 'next') {
        currentSlide.style.transform = 'translateX(100%)';
      } else {
        currentSlide.style.transform = 'translateX(-100%)';
      }

      // Adjust container height for natural aspect ratio after animation
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight();
      }
    }

    scrollActiveThumbnailIntoView() {
      this.thumbs[this.currentIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }

    nextSlide() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex, 'next');
    }

    previousSlide() {
      const prevIndex = this.currentIndex === 0 ? this.slides.length - 1 : this.currentIndex - 1;
      this.goToSlide(prevIndex, 'prev');
    }

    waitForTransition(element) {
      return new Promise((resolve) => {
        const handleTransitionEnd = (e) => {
          if (e.target === element) {
            element.removeEventListener('transitionend', handleTransitionEnd);
            resolve();
          }
        };
        element.addEventListener('transitionend', handleTransitionEnd);
      });
    }

    handleTouchStart(e) {
      if (this.isAnimating) return;

      const touch = e.touches[0];
      this.touchStartX = touch.clientX;
      this.touchStartY = touch.clientY;
    }

    handleTouchMove(e) {
      if (this.isAnimating) return;

      const touch = e.touches[0];
      this.touchEndX = touch.clientX;
      this.touchEndY = touch.clientY;
    }

    handleTouchEnd(e) {
      if (this.isAnimating) return;

      const deltaX = this.touchEndX - this.touchStartX;
      const deltaY = this.touchEndY - this.touchStartY;
      const absDeltaX = Math.abs(deltaX);
      const absDeltaY = Math.abs(deltaY);

      // Only trigger swipe if horizontal movement is greater than vertical
      if (absDeltaX > absDeltaY && absDeltaX > this.minSwipeDistance) {
        if (deltaX > 0) {
          // Swipe right - go to previous slide
          this.previousSlide();
        } else {
          // Swipe left - go to next slide
          this.nextSlide();
        }
      }
    }

    // Utilities for media control
    pauseAllMediaExceptInSlide(slide) {
      const allowed = new Set(slide ? Array.from(slide.querySelectorAll('video-media, model-media')) : []);
      this.querySelectorAll('video-media[playing], model-media[playing]').forEach((el) => {
        if (!allowed.has(el)) {
          el.pause();
        }
      });
    }

    pauseNonActiveSlides() {
      this.slides.forEach((slide, index) => {
        if (index !== this.currentIndex) {
          slide.querySelectorAll('video-media[playing], model-media[playing]').forEach((element) => element.pause());
        }
      });
    }

    autoplayActiveSlideIfEligible() {
      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;

      const mediaEls = activeSlide.querySelectorAll('video-media, model-media');
      mediaEls.forEach((element) => {
        if (!element.hasAttribute('autoplay')) return;
        if (element.hasAttribute('playing')) return;
        // If already loaded, try immediately; else wait for 'loaded' attribute
        if (element.hasAttribute('loaded')) {
          element.play();
        } else {
          const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'loaded' && element.hasAttribute('loaded')) {
                observer.disconnect();
                element.play();
                break;
              }
            }
          });

          observer.observe(element, { attributes: true, attributeFilter: ['loaded'] });
        }
      });
    }
  }

  // Define the custom element
  customElements.define('media-gallery', MediaGalleryElement);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-button"] && !Shopify.designMode) return;
  try {
    /*
    Phones: a colour tapped in the buy box takes the page up to the photos, so
    the colour is seen as the gallery turns to it (Ayoob, 2026-10-19). The buy
    box sits about a screen under the photos there (the T-shirt: 66px of its
    450px photo on screen as a colour was picked). Only after a tap: the
    keyboard's arrows step through the colours, and each step would carry the
    page away from the row. Not when the photos are all on screen already, not
    in the quick-shop modal, and at once rather than gliding for reduced motion.
    Wider screens keep the photos beside the buy box. Anything the theme pins to
    the top (its sticky header or announcement bar, both off on this store)
    stays clear of the photo's top edge.
  */
  (function () {
    var phone = window.matchMedia('(max-width: 768px)');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var tappedAt = -Infinity;

    document.addEventListener(
      'pointerup',
      function (event) {
        if (event.target.closest && event.target.closest('.variant-input-wrap')) tappedAt = event.timeStamp;
      },
      true
    );

    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!phone.matches || !input.classList || !input.classList.contains('variant__input--color-swatch')) return;
      if (event.timeStamp - tappedAt > 1000 || input.closest('.modal')) return;

      var section = input.closest('[data-section-type="product"]');
      var photos = section && section.querySelector('.product__main-photos');
      if (!photos) return;

      var pinned = 0;
      document.querySelectorAll('.site-header--stuck, .announcement-bar--sticky').forEach(function (bar) {
        pinned += bar.offsetHeight;
      });

      var box = photos.getBoundingClientRect();
      if (box.top >= pinned && box.bottom <= window.innerHeight) return;

      window.scrollTo({
        top: window.scrollY + box.top - pinned,
        behavior: reducedMotion.matches ? 'auto' : 'smooth'
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video-sound"] && !Shopify.designMode) return;
  try {
    window.theme = window.theme || {};

  window.theme.videoSound = window.theme.videoSound || (function () {
    var gestures = ['pointerdown', 'pointerup', 'touchend', 'keydown', 'click'];
    var listen = { capture: true, passive: true };
    var refused = false;
    var current = null;

    // Only events that confer permission count: not a touch that turns into a scroll,
    // or Escape. Browsers without the API get every event.
    function activated() {
      return !navigator.userActivation || navigator.userActivation.isActive;
    }

    function playMuted(video) {
      video.muted = true;
      var attempt = video.play();
      if (attempt && attempt.catch) attempt.catch(function () {});
    }

    // Registered when this script runs, before any section can call afterInteraction(),
    // so it runs first on the same event.
    gestures.forEach(function (type) {
      document.addEventListener(type, function () {
        if (activated()) refused = false;
      }, listen);
    });

    return {
      // Unmute and play. Resolves false if the browser refused sound (the video carries on
      // playing muted) and true otherwise.
      play: function (video) {
        if (refused) {
          playMuted(video);
          return Promise.resolve(false);
        }

        video.muted = false;
        var attempt = video.play();
        if (!attempt || !attempt.then) return Promise.resolve(true);

        return attempt.then(function () {
          return true;
        }, function (error) {
          // AbortError and friends mean a pause() or a source change got in first, which
          // is not a refusal of sound. Only NotAllowedError is.
          if (!error || error.name !== 'NotAllowedError') return true;
          refused = true;
          playMuted(video);
          return false;
        });
      },

      // Calls fn once, at the visitor's next click, tap or key press outside `ignore`: a
      // video's own controls, which act for themselves (pre-empting a mute button here
      // would unmute, then its click would mute straight back). Returns a cancel function.
      afterInteraction: function (fn, ignore) {
        function handle(event) {
          if (ignore && ignore.contains(event.target)) return;
          if (!activated()) return;
          cancel();
          fn();
        }

        function cancel() {
          gestures.forEach(function (type) {
            document.removeEventListener(type, handle, listen);
          });
        }

        gestures.forEach(function (type) {
          document.addEventListener(type, handle, listen);
        });

        return cancel;
      },

      // One video with sound at a time: claiming the sound silences whichever video had
      // it, through the onYield it registered.
      claim: function (video, onYield) {
        if (current && current.video !== video) current.onYield();
        current = { video: video, onYield: onYield };
      },

      release: function (video) {
        if (current && current.video === video) current = null;
      }
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yotpo-reviews-carousel"] && !Shopify.designMode) return;
  try {
    (function () {
    /*
      Yotpo writes its typeface and colours (`font-family`, `font-weight`, `font-style`, `color`) into the style
      attribute of each text it draws, which no stylesheet outranks without !important, so they are taken off as
      it draws and the stylesheet above applies (as the product page does for Yotpo's "Highly rated" strip). It
      draws after load, the carousel clones its slides, and "Read more" redraws a review, so this runs on every
      change, once per frame. The review count gets its thousands separator ("33,510 reviews"), and Yotpo's "See
      all reviews" link becomes "Read all 33,510 reviews" (the wording is the theme's, general.reviews.read_all,
      handed over by sections/apps.liquid), both written into Yotpo's own text nodes so its redraws keep working.
      Without a count the link keeps Yotpo's words.
    */
    var PROPS = ['font-family', 'font-weight', 'font-style', 'color'];

    /*
      Calmer movement (Ayoob, 2026-10-12: "the animation from 1 review to the other is a bit aggressive"). Yotpo's
      carousel (the Glide library inside it, which the page can't reach) moves its strip of cards over 200ms on a
      sharp curve, every 4 seconds (Yotpo's "Auto slide" at "medium"). Each move now takes 700ms on an even
      ease-in-out: the strip's style is wrapped (see calm), so a move Glide starts is given this timing as it is set.
      Glide wraps from the last review to the first by moving onto a copy, then jumping back to the original when its
      own 200ms timer runs out; that jump is held until the slower move has landed, where the copy and the original
      look the same. A new move or a drag before then takes the held jump first, from wherever the strip has got to.
      If a browser won't let the style be wrapped, the carousel keeps Yotpo's own motion.

      A swipe ends differently (Ayoob, 2026-10-17: swiping on a phone "sort of jerks"): the even curve starts from
      rest, so the strip stopped dead as the finger lifted (740px/s in the drag's last 50ms, 1px/s the 50ms after),
      then set off again at 300px/s. The move that ends a swipe carries on at the finger's speed and slows to a stop,
      taking as long as that speed needs for what is left; it keeps the even curve when the finger had stopped or the
      strip goes back the way it came.
    */
    var MOVE = 'transform 700ms cubic-bezier(0.65, 0, 0.35, 1)';

    /*
      A swipe's end: an ease-out, cubic-bezier(0.33, 0.33k, 0.68, 1), which starts at k times its average speed. The
      time is what the finger's speed needs for the distance left at k = 3 (3 * distance / speed), kept within 200 to
      700ms; k is then what starts the strip at the finger's speed in that time.
    */
    function ending(distance, speed) {
      var ms = Math.min(700, Math.max(200, (3 * distance) / speed));
      var k = Math.min(3, Math.max(1, (speed * ms) / distance));
      return { ms: Math.round(ms), transition: 'transform ' + Math.round(ms) + 'ms cubic-bezier(0.33, ' + (0.33 * k).toFixed(3) + ', 0.68, 1)' };
    }
    var PREFIXED = ['webkitTransform', 'mozTransform', 'MozTransform'];
    var calmed = new WeakSet();

    function offsetOf(value) {
      var match = /translate3d\((-?[\d.]+)px/.exec(value || '');
      return match ? parseFloat(match[1]) : NaN;
    }

    /*
      The strip's style properties are its own (not setters on a prototype), so the strip is given a style of its own:
      the real one behind a proxy that passes everything through except the transition and the transform, which go
      through onTransition and onTransform below.
    */
    function calm(track) {
      if (calmed.has(track)) return;
      calmed.add(track);
      var native = Object.getOwnPropertyDescriptor(HTMLElement.prototype, 'style');
      if (!native || !native.get || typeof Proxy !== 'function') return;
      var real = native.get.call(track);

      var moving = false;
      var holdNext = false;
      var held = null;
      var target = null;
      var dragging = false;
      var timer = 0;
      var timed = 0; // the duration given to the move under way, 0 when Glide's own (a drag's 0ms) applies
      var settle = false; // the next move ends a swipe
      var settleTimer = 0;
      var end = null; // the timing given to a swipe's end, kept through the task that set it
      var speed = 0; // the finger's speed as it lifted, px per ms, + to the right
      var trail = []; // the finger's last positions, [time, x]

      // Take a held jump at once, from where the strip is now: the copy and the original sit one loop apart.
      function land() {
        clearTimeout(timer);
        moving = false;
        if (held === null) return;
        var shift = offsetOf(held) - offsetOf(target);
        var to = held;
        held = null;
        if (!isNaN(shift)) {
          to = 'translate3d(' + (new DOMMatrix(getComputedStyle(track).transform).m41 + shift) + 'px, 0px, 0px)';
        }
        real.transition = 'transform 0ms';
        timed = 0;
        real.transform = to;
        void track.offsetWidth;
        target = to;
      }

      function onTransition(value) {
        var duration = /(\d+(?:\.\d+)?)ms/.exec(value || '');
        if (!duration) {
          real.transition = value;
          timed = 0;
        } else if (parseFloat(duration[1]) > 0) {
          if (held !== null) land();
          // A swipe's end is timed in onTransform, which knows how far it goes. Glide gives a move its position
          // before its timing, so a timing that comes after keeps the swipe's.
          if (end) {
            real.transition = end;
          } else if (!settle) {
            real.transition = MOVE;
            timed = 700;
          }
        } else if (moving && !dragging) {
          holdNext = true;
        } else {
          real.transition = value;
          timed = 0;
        }
      }

      function onTransform(value) {
        if (holdNext) {
          holdNext = false;
          held = value;
          return;
        }
        if (settle && value !== real.transform) {
          settle = false;
          var distance = offsetOf(value) - new DOMMatrix(getComputedStyle(track).transform).m41;
          if (Math.abs(speed) > 0.15 && distance * speed > 0) {
            var timing = ending(Math.abs(distance), Math.abs(speed));
            timed = timing.ms;
            end = timing.transition;
          } else {
            timed = 700;
            end = MOVE;
          }
          real.transition = end;
          Promise.resolve().then(function () {
            end = null;
          });
        }
        if (value !== real.transform && timed > 0) {
          moving = true;
          target = value;
          clearTimeout(timer);
          timer = setTimeout(land, timed + 200);
        }
        real.transform = value;
      }

      var proxy = new Proxy(real, {
        get: function (style, name) {
          var value = Reflect.get(style, name, style);
          return typeof value === 'function' ? value.bind(style) : value;
        },
        set: function (style, name, value) {
          if (name === 'transition') onTransition(value);
          else if (name === 'transform') onTransform(value);
          // Glide sets the prefixed names just before `transform`, which carries the value; they would apply it unheld.
          else if (PREFIXED.indexOf(name) === -1) style[name] = value;
          return true;
        },
      });

      try {
        Object.defineProperty(track, 'style', {
          configurable: true,
          get: function () { return proxy; },
          set: function (value) { native.set.call(track, value); },
        });
      } catch (error) {
        return;
      }

      track.addEventListener('transitionend', function (event) {
        if (event.target === track && event.propertyName === 'transform') land();
      });
      // The finger's last 80ms, for its speed as it lifts.
      function note(x) {
        var now = performance.now();
        trail.push([now, x]);
        while (trail.length > 2 && now - trail[0][0] > 80) trail.shift();
      }

      track.addEventListener('pointerdown', function (event) {
        if (held !== null) land();
        moving = false;
        dragging = true;
        trail = [];
        note(event.clientX);
      }, true);
      window.addEventListener('pointermove', function (event) {
        if (dragging) note(event.clientX);
      }, true);
      window.addEventListener('touchmove', function (event) {
        if (dragging && event.touches[0]) note(event.touches[0].clientX);
      }, { capture: true, passive: true });
      ['pointerup', 'pointercancel', 'touchend'].forEach(function (type) {
        window.addEventListener(type, function () {
          if (dragging && trail.length > 1) {
            var first = trail[0];
            var last = trail[trail.length - 1];
            speed = last[0] > first[0] ? (last[1] - first[1]) / (last[0] - first[0]) : 0;
            // Only a drag that moved; a tap leaves the next move (the auto slide's) its even curve.
            settle = Math.abs(last[1] - trail[0][1]) > 2 || Math.abs(speed) > 0.15;
            clearTimeout(settleTimer);
            settleTimer = setTimeout(function () {
              settle = false;
            }, 400);
          }
          dragging = false;
        }, true);
      });
    }

    class CustomerReviews extends HTMLElement {
      connectedCallback() {
        this.frame = 0;
        this.observer = new MutationObserver(() => {
          if (!this.frame) this.frame = requestAnimationFrame(() => this.tidy());
        });
        this.observer.observe(this, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['style'],
        });
        this.tidy();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        cancelAnimationFrame(this.frame);
      }

      tidy() {
        this.frame = 0;
        var widget = this.querySelector('.yotpo-reviews-carousel-widget-container');
        if (!widget) return;

        var track = widget.querySelector('.glide__slides');
        if (track) calm(track);

        widget.querySelectorAll('[style]').forEach(function (el) {
          PROPS.forEach(function (prop) {
            if (el.style.getPropertyValue(prop)) el.style.removeProperty(prop);
          });
        });

        var count = widget.querySelector('.reviews-bottomline-total-reviews');
        if (!count) return;
        count.childNodes.forEach(function (node) {
          if (node.nodeType !== Node.TEXT_NODE || !/\d{4,}/.test(node.data)) return;
          node.data = node.data.replace(/\d{4,}/, function (digits) {
            return Number(digits).toLocaleString(document.documentElement.lang || 'en-GB');
          });
        });

        var link = widget.querySelector('.yotpo-reviews-carousel-seo-link-button');
        var figure = count.textContent.match(/\d[\d.,\s]*\d|\d/);
        var label = this.dataset.readAll;
        if (!link || !figure || !label) return;
        var words = label.replace('[number]', figure[0]);
        link.childNodes.forEach(function (node) {
          if (node.nodeType === Node.TEXT_NODE && node.data.trim() && node.data !== words) node.data = words;
        });
      }
    }

    if (!customElements.get('customer-reviews')) {
      customElements.define('customer-reviews', CustomerReviews);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yotpo-reviews-widget"] && !Shopify.designMode) return;
  try {
    (function () {
    /*
      Yotpo writes the AI summary's size into the paragraph's style attribute (14px on a 20px line), and its
      "Customers say" title's (20px), which no stylesheet outranks without !important; they are taken off as Yotpo
      draws them, so the stylesheet's sizes apply. Yotpo redraws the widget on every filter, sort and page, so this
      runs on each change, once a frame.
    */
    var TARGETS = [
      { selector: '.yotpo-paragraph-summary-text', props: ['font-size', 'line-height'] },
      { selector: '.yotpo-paragraph-summary-title', props: ['font-size'] },
    ];
    var queued = false;

    function clean(root) {
      TARGETS.forEach(function (target) {
        root.querySelectorAll(target.selector + '[style]').forEach(function (el) {
          target.props.forEach(function (prop) {
            if (el.style.getPropertyValue(prop)) el.style.removeProperty(prop);
          });
        });
      });
    }

    /*
      A product with no reviews yet: Yotpo's empty state in the theme's words, which sections/apps.liquid puts on
      the wrapper. Its line says "No reviews yet." and its button "Write a review", as on a product with reviews;
      the stylesheet takes away the picture and Yotpo's own title. Changed only when they differ, so Yotpo's
      redraws end here too.
    */
    function words(host) {
      var state = host.querySelector('.yotpo-empty-state');
      if (!state) return;
      setText(state.querySelector('.yotpo-body-text'), host.dataset.noneYet);
      setText(host.querySelector('.yotpo-new-review-btn.empty-state'), host.dataset.write);
    }

    function setText(el, text) {
      if (!el || !text || el.textContent.trim() === text) return;
      el.textContent = text;
    }

    /*
      The line under the "Write a review" button (with reviews or without): what a review earns in Yotpo Loyalty,
      read from the programme's own campaigns (window.swellAPI), so it gives the points the programme gives today,
      and says nothing when there is no such campaign. Campaigns carry no type, so the review ones are known by
      their names ("Leave a review", "Add photo to review"; a Google review is something else). The programme's
      script arrives a few seconds in; until then there is no line, and the wait gives up after 30s.
    */
    function reviewPoints() {
      var api = window.swellAPI;
      var list = [];
      try {
        list = api && typeof api.getActiveCampaigns === 'function' ? api.getActiveCampaigns() || [] : [];
      } catch (error) {
        return null;
      }
      var points = { review: 0, photo: 0 };
      list.forEach(function (campaign) {
        var name = (campaign.title || '') + ' ' + (campaign.ctaText || '');
        var amount = Number(campaign.rewardPoints) || 0;
        if (!amount || !/review/i.test(name) || /google/i.test(name)) return;
        if (/photo/i.test(name)) {
          points.photo = points.photo || amount;
        } else {
          points.review = points.review || amount;
        }
      });
      return points.review ? points : null;
    }

    // True once there is nothing left to wait for: the line is written, or there is no button yet.
    function earn(host) {
      var button = host.querySelector('#yotpo-main-widget-btn');
      var line = host.querySelector('.product-reviews__earn');
      if (!button) {
        if (line) line.remove();
        return true;
      }
      var points = reviewPoints();
      if (!points) return false;
      var text = points.photo && host.dataset.earnPhoto
        ? host.dataset.earnPhoto.replace('[points]', points.review).replace('[photo]', points.photo)
        : (host.dataset.earn || '').replace('[points]', points.review);
      if (!text) return true;
      if (!line || line.previousElementSibling !== button) {
        if (line) line.remove();
        line = document.createElement('p');
        line.className = 'product-reviews__earn';
        line.id = 'ProductReviewsEarn';
        button.after(line);
      }
      setText(line, text);
      if (button.getAttribute('aria-describedby') !== line.id) button.setAttribute('aria-describedby', line.id);
      return true;
    }

    function waitForPoints(host) {
      if (host.dataset.pjEarnWaiting) return;
      host.dataset.pjEarnWaiting = 'true';
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (earn(host)) {
          clearInterval(timer);
          delete host.dataset.pjEarnWaiting;
        } else if (tries >= 60) {
          // Gives up for good: the flag stays, so a later redraw doesn't start another wait.
          clearInterval(timer);
        }
      }, 500);
    }

    function update(host) {
      // Yotpo has drawn: the outline in the room goes for good, also while Yotpo takes its first draw away and draws
      // again (the stylesheet hides it on this mark as well as on the drawn widget); and what it drew, its "No
      // reviews yet" or reviews, as the stylesheet holds the no-reviews room for the first, through a redraw too.
      if (host.querySelector('#yotpo-reviews-main-widget .yotpo-head')) {
        if (!host.hasAttribute('data-reviews-drawn')) host.setAttribute('data-reviews-drawn', '');
        var shown = host.querySelector('#yotpo-reviews-main-widget .yotpo-empty-state') ? 'none' : 'reviews';
        if (host.getAttribute('data-reviews-shown') !== shown) host.setAttribute('data-reviews-shown', shown);
      }
      clean(host);
      words(host);
      if (!earn(host)) waitForPoints(host);
    }

    function watch(host) {
      if (host.dataset.pjReviewsWatched) return;
      host.dataset.pjReviewsWatched = 'true';
      update(host);
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () {
          queued = false;
          update(host);
        });
      }).observe(host, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
    }

    function init() {
      document.querySelectorAll('.product-reviews').forEach(watch);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
